import * as moment from 'moment';
const CryptoJS = require('crypto-js');
const secretKeyForCrypto = 'WEBDCS';
export const shortcutKeysForPageNavigation = ['F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F10'];
export const shortcutKeysforHumburgerMenu = ['i', 'h', 'm', 'd', 'p'];
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const AirportRoles = ['APT', 'APTS'];
export const ServicesAllowed = ['SFBO'];
export const shortcutKeys = ['F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F10', 'i', 'h', 'm', 'd', 'p'];
export const shortcutKeysBoarding = ['F2', 'F3', 'F4', 'F5', 'F6', 'o', 'p', 'c'];
export const checkinModule = 'Check-In';
export const boardingModule = 'Boarding';
export const notificationModule = 'Notifications';
export const boardingTime = 30; // in minutes
export const searchPageIconsMapping = {
        SODMALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Sod_Passenger.svg",
        SODFEMALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Female_Sod_Passenger.svg",
        SODMALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Sod_Passenger.svg",
        SODFEMALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Female_Sod_Passenger.svg",
        SODMALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Sod_Passenger.svg",
        SODFEMALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Female_Sod_Passenger.svg",
        SODMALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Sod_Passenger.svg",
        SODFEMALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Female_Sod_Passenger.svg",
        MALEWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Passenger_with_Infant.svg",
        MALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Passenger.svg",
        FEMALEWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Female_Passenger_with_Infant.svg",
        FEMALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Female_Passenger.svg",
        CHILDWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Child_Passenger_with_Infant.svg",
        CHILDWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Child_Passenger.svg",
        MALEWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Passenger_with_infant.svg",
        MALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Passenger.svg",
        FEMALEWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Female_Passenger_with_infant.svg",
        FEMALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Female_Passenger.svg",
        CHILDWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Child_Passenger_with_Infant.svg",
        CHILDWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Child_Passenger.svg",
        MALEWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Passenger_with_infant.svg",
        MALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Passenger.svg",
        FEMALEWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Female_Passenger_with_infant.svg",
        FEMALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Female_Passenger.svg",
        CHILDWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Child_Passenger_with_Infant.svg",
        CHILDWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Child_Passenger.svg",
        MALEWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Passenger_with_infant.svg",
        MALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Passenger.svg",
        FEMALEWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Female_Passenger_with_infant.svg",
        FEMALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Female_Passenger.svg",
        CHILDWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Child_Passenger_with_Infant.svg",
        CHILDWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Child_Passenger.svg",
        ELTMALEWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Elt_Passenger_with_infant.svg",
        ELTMALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Elt_passenger.svg",
        ELTFEMALEWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Female_Elt_Passenger_With_infant.svg",
        ELTFEMALEWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Female_Elt_Passenger.svg",
        ELTCHILDWITHINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Child_Elt_Passenger_With_Infant.svg",
        ELTCHILDWITHOUTINFANTPARTIAL: "newImages/searchPagePassengerImages/Partial_Male_Child_Elt_Passenger.svg",
        ELTMALEWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Elt_Passenger_With_Infant.svg",
        ELTMALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Elt_Passenger.svg",
        ELTFEMALEWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Female_Elt_Passenger_With_Infant.svg",
        ELTFEMALEWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Female_Elt_Passenger.svg",
        ELTCHILDWITHINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Child_Elt_Passenger_with_Infant.svg",
        ELTCHILDWITHOUTINFANTCHECKEDIN: "newImages/searchPagePassengerImages/Checked-in_Male_Child_Elt_Passenger.svg",
        ELTMALEWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Elt_Passenger_With_Infant.svg",
        ELTMALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Elt_Passenger.svg",
        ELTFEMALEWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Female_Elt_Passenger_With_Infant.svg",
        ELTFEMALEWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Female_Elt_Passenger.svg",
        ELTCHILDWITHINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Child_Elt_Passenger_With_Infant.svg",
        ELTCHILDWITHOUTINFANTBOARDED: "newImages/searchPagePassengerImages/Boarded_Male_Child_Elt_Passenger.svg",
        ELTMALEWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Elt_Passenger_with_infant.svg",
        ELTMALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Elt_Passenger.svg",
        ELTFEMALEWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Female_Elt_Passenger_with_infant.svg",
        ELTFEMALEWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Female_Elt_Passenger.svg.svg",
        ELTCHILDWITHINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Child_Elt_Passenger_With_Infant.svg",
        ELTCHILDWITHOUTINFANTDEFAULT: "newImages/searchPagePassengerImages/Default_Male_Child_Elt_Passenger.svg"
}
export const defaultCountryInfo = { "name": "INDIA", "dial_code": "+91", "code": "IN", "flag": "🇮🇳", "regex": "^[6|7|8|9]{1}[0-9]{9}$" };
export const countryCodes3to2Converter = [
        {
          "COUNTRY_NAME": "AFGHANISTAN",
          "2DigitCode": "AF",
          "3DigitCode": "AFG"
        },
        {
          "COUNTRY_NAME": "ALAND ISLANDS",
          "2DigitCode": "AX",
          "3DigitCode": "ALA"
        },
        {
          "COUNTRY_NAME": "ALBANIA",
          "2DigitCode": "AL",
          "3DigitCode": "ALB"
        },
        {
          "COUNTRY_NAME": "ALGERIA",
          "2DigitCode": "DZ",
          "3DigitCode": "DZA"
        },
        {
          "COUNTRY_NAME": "AMERICAN SAMOA",
          "2DigitCode": "AS",
          "3DigitCode": "ASM"
        },
        {
          "COUNTRY_NAME": "ANDORRA",
          "2DigitCode": "AD",
          "3DigitCode": "AND"
        },
        {
          "COUNTRY_NAME": "ANGOLA",
          "2DigitCode": "AO",
          "3DigitCode": "AGO"
        },
        {
          "COUNTRY_NAME": "ANGUILLA",
          "2DigitCode": "AI",
          "3DigitCode": "AIA"
        },
        {
          "COUNTRY_NAME": "ANTARCTICA",
          "2DigitCode": "AQ",
          "3DigitCode": "ATA"
        },
        {
          "COUNTRY_NAME": "ANTIGUA AND BARBUDA",
          "2DigitCode": "AG",
          "3DigitCode": "ATG"
        },
        {
          "COUNTRY_NAME": "ARGENTINA",
          "2DigitCode": "AR",
          "3DigitCode": "ARG"
        },
        {
          "COUNTRY_NAME": "ARMENIA",
          "2DigitCode": "AM",
          "3DigitCode": "ARM"
        },
        {
          "COUNTRY_NAME": "ARUBA",
          "2DigitCode": "AW",
          "3DigitCode": "ABW"
        },
        {
          "COUNTRY_NAME": "AUSTRALIA",
          "2DigitCode": "AU",
          "3DigitCode": "AUS"
        },
        {
          "COUNTRY_NAME": "AUSTRIA",
          "2DigitCode": "AT",
          "3DigitCode": "AUT"
        },
        {
          "COUNTRY_NAME": "AZERBAIJAN",
          "2DigitCode": "AZ",
          "3DigitCode": "AZE"
        },
        {
          "COUNTRY_NAME": "BAHAMAS",
          "2DigitCode": "BS",
          "3DigitCode": "BHS"
        },
        {
          "COUNTRY_NAME": "BAHRAIN",
          "2DigitCode": "BH",
          "3DigitCode": "BHR"
        },
        {
          "COUNTRY_NAME": "BANGLADESH",
          "2DigitCode": "BD",
          "3DigitCode": "BGD"
        },
        {
          "COUNTRY_NAME": "BARBADOS",
          "2DigitCode": "BB",
          "3DigitCode": "BRB"
        },
        {
          "COUNTRY_NAME": "BELARUS",
          "2DigitCode": "BY",
          "3DigitCode": "BLR"
        },
        {
          "COUNTRY_NAME": "BELGIUM",
          "2DigitCode": "BE",
          "3DigitCode": "BEL"
        },
        {
          "COUNTRY_NAME": "BELIZE",
          "2DigitCode": "BZ",
          "3DigitCode": "BLZ"
        },
        {
          "COUNTRY_NAME": "BENIN",
          "2DigitCode": "BJ",
          "3DigitCode": "BEN"
        },
        {
          "COUNTRY_NAME": "BERMUDA",
          "2DigitCode": "BM",
          "3DigitCode": "BMU"
        },
        {
          "COUNTRY_NAME": "BHUTAN",
          "2DigitCode": "BT",
          "3DigitCode": "BTN"
        },
        {
          "COUNTRY_NAME": "BOLIVIA, PLURINATIONAL STATE OF",
          "2DigitCode": "BO",
          "3DigitCode": "BOL"
        },
        {
          "COUNTRY_NAME": "BONAIRE, SAINT EUSTATIUS AND SABA",
          "2DigitCode": "BQ",
          "3DigitCode": "BES"
        },
        {
          "COUNTRY_NAME": "BOSNIA AND HERZEGOVINA",
          "2DigitCode": "BA",
          "3DigitCode": "BIH"
        },
        {
          "COUNTRY_NAME": "BOTSWANA",
          "2DigitCode": "BW",
          "3DigitCode": "BWA"
        },
        {
          "COUNTRY_NAME": "BOUVET ISLAND",
          "2DigitCode": "BV",
          "3DigitCode": "BVT"
        },
        {
          "COUNTRY_NAME": "BRAZIL",
          "2DigitCode": "BR",
          "3DigitCode": "BRA"
        },
        {
          "COUNTRY_NAME": "BRITISH INDIAN OCEAN TERRITORY",
          "2DigitCode": "IO",
          "3DigitCode": "IOT"
        },
        {
          "COUNTRY_NAME": "BRUNEI DARUSSALAM",
          "2DigitCode": "BN",
          "3DigitCode": "BRN"
        },
        {
          "COUNTRY_NAME": "BULGARIA",
          "2DigitCode": "BG",
          "3DigitCode": "BGR"
        },
        {
          "COUNTRY_NAME": "BURKINA FASO",
          "2DigitCode": "BF",
          "3DigitCode": "BFA"
        },
        {
          "COUNTRY_NAME": "BURUNDI",
          "2DigitCode": "BI",
          "3DigitCode": "BDI"
        },
        {
          "COUNTRY_NAME": "CAMBODIA",
          "2DigitCode": "KH",
          "3DigitCode": "KHM"
        },
        {
          "COUNTRY_NAME": "CAMEROON",
          "2DigitCode": "CM",
          "3DigitCode": "CMR"
        },
        {
          "COUNTRY_NAME": "CANADA",
          "2DigitCode": "CA",
          "3DigitCode": "CAN"
        },
        {
          "COUNTRY_NAME": "CAPE VERDE",
          "2DigitCode": "CV",
          "3DigitCode": "CPV"
        },
        {
          "COUNTRY_NAME": "CAYMAN ISLANDS",
          "2DigitCode": "KY",
          "3DigitCode": "CYM"
        },
        {
          "COUNTRY_NAME": "CENTRAL AFRICAN REPUBLIC",
          "2DigitCode": "CF",
          "3DigitCode": "CAF"
        },
        {
          "COUNTRY_NAME": "CHAD",
          "2DigitCode": "TD",
          "3DigitCode": "TCD"
        },
        {
          "COUNTRY_NAME": "CHILE",
          "2DigitCode": "CL",
          "3DigitCode": "CHL"
        },
        {
          "COUNTRY_NAME": "CHINA",
          "2DigitCode": "CN",
          "3DigitCode": "CHN"
        },
        {
          "COUNTRY_NAME": "CHRISTMAS ISLAND",
          "2DigitCode": "CX",
          "3DigitCode": "CXR"
        },
        {
          "COUNTRY_NAME": "COCOS (KEELING) ISLANDS",
          "2DigitCode": "CC",
          "3DigitCode": "CCK"
        },
        {
          "COUNTRY_NAME": "COLOMBIA",
          "2DigitCode": "CO",
          "3DigitCode": "COL"
        },
        {
          "COUNTRY_NAME": "COMOROS",
          "2DigitCode": "KM",
          "3DigitCode": "COM"
        },
        {
          "COUNTRY_NAME": "CONGO",
          "2DigitCode": "CG",
          "3DigitCode": "COG"
        },
        {
          "COUNTRY_NAME": "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
          "2DigitCode": "CD",
          "3DigitCode": "COD"
        },
        {
          "COUNTRY_NAME": "COOK ISLANDS",
          "2DigitCode": "CK",
          "3DigitCode": "COK"
        },
        {
          "COUNTRY_NAME": "COSTA RICA",
          "2DigitCode": "CR",
          "3DigitCode": "CRI"
        },
        {
          "COUNTRY_NAME": "CÔTE D'IVOIRE",
          "2DigitCode": "CI",
          "3DigitCode": "CIV"
        },
        {
          "COUNTRY_NAME": "CROATIA",
          "2DigitCode": "HR",
          "3DigitCode": "HRV"
        },
        {
          "COUNTRY_NAME": "CUBA",
          "2DigitCode": "CU",
          "3DigitCode": "CUB"
        },
        {
          "COUNTRY_NAME": "CURAÇAO",
          "2DigitCode": "CW",
          "3DigitCode": "CUW"
        },
        {
          "COUNTRY_NAME": "CYPRUS",
          "2DigitCode": "CY",
          "3DigitCode": "CYP"
        },
        {
          "COUNTRY_NAME": "CZECH REPUBLIC",
          "2DigitCode": "CZ",
          "3DigitCode": "CZE"
        },
        {
          "COUNTRY_NAME": "DENMARK",
          "2DigitCode": "DK",
          "3DigitCode": "DNK"
        },
        {
          "COUNTRY_NAME": "DJIBOUTI",
          "2DigitCode": "DJ",
          "3DigitCode": "DJI"
        },
        {
          "COUNTRY_NAME": "DOMINICA",
          "2DigitCode": "DM",
          "3DigitCode": "DMA"
        },
        {
          "COUNTRY_NAME": "DOMINICAN REPUBLIC",
          "2DigitCode": "DO",
          "3DigitCode": "DOM"
        },
        {
          "COUNTRY_NAME": "ECUADOR",
          "2DigitCode": "EC",
          "3DigitCode": "ECU"
        },
        {
          "COUNTRY_NAME": "EGYPT",
          "2DigitCode": "EG",
          "3DigitCode": "EGY"
        },
        {
          "COUNTRY_NAME": "EL SALVADOR",
          "2DigitCode": "SV",
          "3DigitCode": "SLV"
        },
        {
          "COUNTRY_NAME": "EQUATORIAL GUINEA",
          "2DigitCode": "GQ",
          "3DigitCode": "GNQ"
        },
        {
          "COUNTRY_NAME": "ERITREA",
          "2DigitCode": "ER",
          "3DigitCode": "ERI"
        },
        {
          "COUNTRY_NAME": "ESTONIA",
          "2DigitCode": "EE",
          "3DigitCode": "EST"
        },
        {
          "COUNTRY_NAME": "ETHIOPIA",
          "2DigitCode": "ET",
          "3DigitCode": "ETH"
        },
        {
          "COUNTRY_NAME": "FALKLAND ISLANDS (MALVINAS)",
          "2DigitCode": "FK",
          "3DigitCode": "FLK"
        },
        {
          "COUNTRY_NAME": "FAROE ISLANDS",
          "2DigitCode": "FO",
          "3DigitCode": "FRO"
        },
        {
          "COUNTRY_NAME": "FIJI",
          "2DigitCode": "FJ",
          "3DigitCode": "FJI"
        },
        {
          "COUNTRY_NAME": "FINLAND",
          "2DigitCode": "FI",
          "3DigitCode": "FIN"
        },
        {
          "COUNTRY_NAME": "FRANCE",
          "2DigitCode": "FR",
          "3DigitCode": "FRA"
        },
        {
          "COUNTRY_NAME": "FRENCH GUIANA",
          "2DigitCode": "GF",
          "3DigitCode": "GUF"
        },
        {
          "COUNTRY_NAME": "FRENCH POLYNESIA",
          "2DigitCode": "PF",
          "3DigitCode": "PYF"
        },
        {
          "COUNTRY_NAME": "FRENCH SOUTHERN TERRITORIES",
          "2DigitCode": "TF",
          "3DigitCode": "ATF"
        },
        {
          "COUNTRY_NAME": "GABON",
          "2DigitCode": "GA",
          "3DigitCode": "GAB"
        },
        {
          "COUNTRY_NAME": "GAMBIA",
          "2DigitCode": "GM",
          "3DigitCode": "GMB"
        },
        {
          "COUNTRY_NAME": "GEORGIA",
          "2DigitCode": "GE",
          "3DigitCode": "GEO"
        },
        {
          "COUNTRY_NAME": "GERMANY",
          "2DigitCode": "DE",
          "3DigitCode": "DEU"
        },
        {
          "COUNTRY_NAME": "GHANA",
          "2DigitCode": "GH",
          "3DigitCode": "GHA"
        },
        {
          "COUNTRY_NAME": "GIBRALTAR",
          "2DigitCode": "GI",
          "3DigitCode": "GIB"
        },
        {
          "COUNTRY_NAME": "GREECE",
          "2DigitCode": "GR",
          "3DigitCode": "GRC"
        },
        {
          "COUNTRY_NAME": "GREENLAND",
          "2DigitCode": "GL",
          "3DigitCode": "GRL"
        },
        {
          "COUNTRY_NAME": "GRENADA",
          "2DigitCode": "GD",
          "3DigitCode": "GRD"
        },
        {
          "COUNTRY_NAME": "GUADELOUPE",
          "2DigitCode": "GP",
          "3DigitCode": "GLP"
        },
        {
          "COUNTRY_NAME": "GUAM",
          "2DigitCode": "GU",
          "3DigitCode": "GUM"
        },
        {
          "COUNTRY_NAME": "GUATEMALA",
          "2DigitCode": "GT",
          "3DigitCode": "GTM"
        },
        {
          "COUNTRY_NAME": "GUERNSEY",
          "2DigitCode": "GG",
          "3DigitCode": "GGY"
        },
        {
          "COUNTRY_NAME": "GUINEA",
          "2DigitCode": "GN",
          "3DigitCode": "GIN"
        },
        {
          "COUNTRY_NAME": "GUINEA-BISSAU",
          "2DigitCode": "GW",
          "3DigitCode": "GNB"
        },
        {
          "COUNTRY_NAME": "GUYANA",
          "2DigitCode": "GY",
          "3DigitCode": "GUY"
        },
        {
          "COUNTRY_NAME": "HAITI",
          "2DigitCode": "HT",
          "3DigitCode": "HTI"
        },
        {
          "COUNTRY_NAME": "HEARD ISLAND AND MCDONALD ISLANDS",
          "2DigitCode": "HM",
          "3DigitCode": "HMD"
        },
        {
          "COUNTRY_NAME": "HOLY SEE (VATICAN CITY STATE)",
          "2DigitCode": "VA",
          "3DigitCode": "VAT"
        },
        {
          "COUNTRY_NAME": "HONDURAS",
          "2DigitCode": "HN",
          "3DigitCode": "HND"
        },
        {
          "COUNTRY_NAME": "HONG KONG",
          "2DigitCode": "HK",
          "3DigitCode": "HKG"
        },
        {
          "COUNTRY_NAME": "HUNGARY",
          "2DigitCode": "HU",
          "3DigitCode": "HUN"
        },
        {
          "COUNTRY_NAME": "ICELAND",
          "2DigitCode": "IS",
          "3DigitCode": "ISL"
        },
        {
          "COUNTRY_NAME": "INDIA",
          "2DigitCode": "IN",
          "3DigitCode": "IND"
        },
        {
          "COUNTRY_NAME": "INDONESIA",
          "2DigitCode": "ID",
          "3DigitCode": "IDN"
        },
        {
          "COUNTRY_NAME": "IRAN, ISLAMIC REPUBLIC OF",
          "2DigitCode": "IR",
          "3DigitCode": "IRN"
        },
        {
          "COUNTRY_NAME": "IRAQ",
          "2DigitCode": "IQ",
          "3DigitCode": "IRQ"
        },
        {
          "COUNTRY_NAME": "IRELAND",
          "2DigitCode": "IE",
          "3DigitCode": "IRL"
        },
        {
          "COUNTRY_NAME": "ISLE OF MAN",
          "2DigitCode": "IM",
          "3DigitCode": "IMN"
        },
        {
          "COUNTRY_NAME": "ISRAEL",
          "2DigitCode": "IL",
          "3DigitCode": "ISR"
        },
        {
          "COUNTRY_NAME": "ITALY",
          "2DigitCode": "IT",
          "3DigitCode": "ITA"
        },
        {
          "COUNTRY_NAME": "JAMAICA",
          "2DigitCode": "JM",
          "3DigitCode": "JAM"
        },
        {
          "COUNTRY_NAME": "JAPAN",
          "2DigitCode": "JP",
          "3DigitCode": "JPN"
        },
        {
          "COUNTRY_NAME": "JERSEY",
          "2DigitCode": "JE",
          "3DigitCode": "JEY"
        },
        {
          "COUNTRY_NAME": "JORDAN",
          "2DigitCode": "JO",
          "3DigitCode": "JOR"
        },
        {
          "COUNTRY_NAME": "KAZAKHSTAN",
          "2DigitCode": "KZ",
          "3DigitCode": "KAZ"
        },
        {
          "COUNTRY_NAME": "KENYA",
          "2DigitCode": "KE",
          "3DigitCode": "KEN"
        },
        {
          "COUNTRY_NAME": "KIRIBATI",
          "2DigitCode": "KI",
          "3DigitCode": "KIR"
        },
        {
          "COUNTRY_NAME": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
          "2DigitCode": "KP",
          "3DigitCode": "PRK"
        },
        {
          "COUNTRY_NAME": "KOREA, REPUBLIC OF",
          "2DigitCode": "KR",
          "3DigitCode": "KOR"
        },
        {
          "COUNTRY_NAME": "KUWAIT",
          "2DigitCode": "KW",
          "3DigitCode": "KWT"
        },
        {
          "COUNTRY_NAME": "KYRGYZSTAN",
          "2DigitCode": "KG",
          "3DigitCode": "KGZ"
        },
        {
          "COUNTRY_NAME": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
          "2DigitCode": "LA",
          "3DigitCode": "LAO"
        },
        {
          "COUNTRY_NAME": "LATVIA",
          "2DigitCode": "LV",
          "3DigitCode": "LVA"
        },
        {
          "COUNTRY_NAME": "LEBANON",
          "2DigitCode": "LB",
          "3DigitCode": "LBN"
        },
        {
          "COUNTRY_NAME": "LESOTHO",
          "2DigitCode": "LS",
          "3DigitCode": "LSO"
        },
        {
          "COUNTRY_NAME": "LIBERIA",
          "2DigitCode": "LR",
          "3DigitCode": "LBR"
        },
        {
          "COUNTRY_NAME": "LIBYAN ARAB JAMAHIRIYA",
          "2DigitCode": "LY",
          "3DigitCode": "LBY"
        },
        {
          "COUNTRY_NAME": "LIECHTENSTEIN",
          "2DigitCode": "LI",
          "3DigitCode": "LIE"
        },
        {
          "COUNTRY_NAME": "LITHUANIA",
          "2DigitCode": "LT",
          "3DigitCode": "LTU"
        },
        {
          "COUNTRY_NAME": "LUXEMBOURG",
          "2DigitCode": "LU",
          "3DigitCode": "LUX"
        },
        {
          "COUNTRY_NAME": "MACAO",
          "2DigitCode": "MO",
          "3DigitCode": "MAC"
        },
        {
          "COUNTRY_NAME": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
          "2DigitCode": "MK",
          "3DigitCode": "MKD"
        },
        {
          "COUNTRY_NAME": "MADAGASCAR",
          "2DigitCode": "MG",
          "3DigitCode": "MDG"
        },
        {
          "COUNTRY_NAME": "MALAWI",
          "2DigitCode": "MW",
          "3DigitCode": "MWI"
        },
        {
          "COUNTRY_NAME": "MALAYSIA",
          "2DigitCode": "MY",
          "3DigitCode": "MYS"
        },
        {
          "COUNTRY_NAME": "MALDIVES",
          "2DigitCode": "MV",
          "3DigitCode": "MDV"
        },
        {
          "COUNTRY_NAME": "MALI",
          "2DigitCode": "ML",
          "3DigitCode": "MLI"
        },
        {
          "COUNTRY_NAME": "MALTA",
          "2DigitCode": "MT",
          "3DigitCode": "MLT"
        },
        {
          "COUNTRY_NAME": "MARSHALL ISLANDS",
          "2DigitCode": "MH",
          "3DigitCode": "MHL"
        },
        {
          "COUNTRY_NAME": "MARTINIQUE",
          "2DigitCode": "MQ",
          "3DigitCode": "MTQ"
        },
        {
          "COUNTRY_NAME": "MAURITANIA",
          "2DigitCode": "MR",
          "3DigitCode": "MRT"
        },
        {
          "COUNTRY_NAME": "MAURITIUS",
          "2DigitCode": "MU",
          "3DigitCode": "MUS"
        },
        {
          "COUNTRY_NAME": "MAYOTTE",
          "2DigitCode": "YT",
          "3DigitCode": "MYT"
        },
        {
          "COUNTRY_NAME": "MEXICO",
          "2DigitCode": "MX",
          "3DigitCode": "MEX"
        },
        {
          "COUNTRY_NAME": "MICRONESIA, FEDERATED STATES OF",
          "2DigitCode": "FM",
          "3DigitCode": "FSM"
        },
        {
          "COUNTRY_NAME": "MOLDOVA, REPUBLIC OF",
          "2DigitCode": "MD",
          "3DigitCode": "MDA"
        },
        {
          "COUNTRY_NAME": "MONACO",
          "2DigitCode": "MC",
          "3DigitCode": "MCO"
        },
        {
          "COUNTRY_NAME": "MONGOLIA",
          "2DigitCode": "MN",
          "3DigitCode": "MNG"
        },
        {
          "COUNTRY_NAME": "MONTENEGRO",
          "2DigitCode": "ME",
          "3DigitCode": "MNE"
        },
        {
          "COUNTRY_NAME": "MONTSERRAT",
          "2DigitCode": "MS",
          "3DigitCode": "MSR"
        },
        {
          "COUNTRY_NAME": "MOROCCO",
          "2DigitCode": "MA",
          "3DigitCode": "MAR"
        },
        {
          "COUNTRY_NAME": "MOZAMBIQUE",
          "2DigitCode": "MZ",
          "3DigitCode": "MOZ"
        },
        {
          "COUNTRY_NAME": "MYANMAR",
          "2DigitCode": "MM",
          "3DigitCode": "MMR"
        },
        {
          "COUNTRY_NAME": "NAMIBIA",
          "2DigitCode": "NA",
          "3DigitCode": "NAM"
        },
        {
          "COUNTRY_NAME": "NAURU",
          "2DigitCode": "NR",
          "3DigitCode": "NRU"
        },
        {
          "COUNTRY_NAME": "NEPAL",
          "2DigitCode": "NP",
          "3DigitCode": "NPL"
        },
        {
          "COUNTRY_NAME": "NETHERLANDS",
          "2DigitCode": "NL",
          "3DigitCode": "NLD"
        },
        {
          "COUNTRY_NAME": "NEW CALEDONIA",
          "2DigitCode": "NC",
          "3DigitCode": "NCL"
        },
        {
          "COUNTRY_NAME": "NEW ZEALAND",
          "2DigitCode": "NZ",
          "3DigitCode": "NZL"
        },
        {
          "COUNTRY_NAME": "NICARAGUA",
          "2DigitCode": "NI",
          "3DigitCode": "NIC"
        },
        {
          "COUNTRY_NAME": "NIGER",
          "2DigitCode": "NE",
          "3DigitCode": "NER"
        },
        {
          "COUNTRY_NAME": "NIGERIA",
          "2DigitCode": "NG",
          "3DigitCode": "NGA"
        },
        {
          "COUNTRY_NAME": "NIUE",
          "2DigitCode": "NU",
          "3DigitCode": "NIU"
        },
        {
          "COUNTRY_NAME": "NORFOLK ISLAND",
          "2DigitCode": "NF",
          "3DigitCode": "NFK"
        },
        {
          "COUNTRY_NAME": "NORTHERN MARIANA ISLANDS",
          "2DigitCode": "MP",
          "3DigitCode": "MNP"
        },
        {
          "COUNTRY_NAME": "NORWAY",
          "2DigitCode": "NO",
          "3DigitCode": "NOR"
        },
        {
          "COUNTRY_NAME": "OMAN",
          "2DigitCode": "OM",
          "3DigitCode": "OMN"
        },
        {
          "COUNTRY_NAME": "PAKISTAN",
          "2DigitCode": "PK",
          "3DigitCode": "PAK"
        },
        {
          "COUNTRY_NAME": "PALAU",
          "2DigitCode": "PW",
          "3DigitCode": "PLW"
        },
        {
          "COUNTRY_NAME": "PALESTINIAN TERRITORY, OCCUPIED",
          "2DigitCode": "PS",
          "3DigitCode": "PSE"
        },
        {
          "COUNTRY_NAME": "PANAMA",
          "2DigitCode": "PA",
          "3DigitCode": "PAN"
        },
        {
          "COUNTRY_NAME": "PAPUA NEW GUINEA",
          "2DigitCode": "PG",
          "3DigitCode": "PNG"
        },
        {
          "COUNTRY_NAME": "PARAGUAY",
          "2DigitCode": "PY",
          "3DigitCode": "PRY"
        },
        {
          "COUNTRY_NAME": "PERU",
          "2DigitCode": "PE",
          "3DigitCode": "PER"
        },
        {
          "COUNTRY_NAME": "PHILIPPINES",
          "2DigitCode": "PH",
          "3DigitCode": "PHL"
        },
        {
          "COUNTRY_NAME": "PITCAIRN",
          "2DigitCode": "PN",
          "3DigitCode": "PCN"
        },
        {
          "COUNTRY_NAME": "POLAND",
          "2DigitCode": "PL",
          "3DigitCode": "POL"
        },
        {
          "COUNTRY_NAME": "PORTUGAL",
          "2DigitCode": "PT",
          "3DigitCode": "PRT"
        },
        {
          "COUNTRY_NAME": "PUERTO RICO",
          "2DigitCode": "PR",
          "3DigitCode": "PRI"
        },
        {
          "COUNTRY_NAME": "QATAR",
          "2DigitCode": "QA",
          "3DigitCode": "QAT"
        },
        {
          "COUNTRY_NAME": "RÉUNION",
          "2DigitCode": "RE",
          "3DigitCode": "REU"
        },
        {
          "COUNTRY_NAME": "ROMANIA",
          "2DigitCode": "RO",
          "3DigitCode": "ROU"
        },
        {
          "COUNTRY_NAME": "RUSSIAN FEDERATION",
          "2DigitCode": "RU",
          "3DigitCode": "RUS"
        },
        {
          "COUNTRY_NAME": "RWANDA",
          "2DigitCode": "RW",
          "3DigitCode": "RWA"
        },
        {
          "COUNTRY_NAME": "SAINT BARTHÉLEMY",
          "2DigitCode": "BL",
          "3DigitCode": "BLM"
        },
        {
          "COUNTRY_NAME": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA",
          "2DigitCode": "SH",
          "3DigitCode": "SHN"
        },
        {
          "COUNTRY_NAME": "SAINT KITTS AND NEVIS",
          "2DigitCode": "KN",
          "3DigitCode": "KNA"
        },
        {
          "COUNTRY_NAME": "SAINT LUCIA",
          "2DigitCode": "LC",
          "3DigitCode": "LCA"
        },
        {
          "COUNTRY_NAME": "SAINT MARTIN (FRENCH PART)",
          "2DigitCode": "MF",
          "3DigitCode": "MAF"
        },
        {
          "COUNTRY_NAME": "SAINT PIERRE AND MIQUELON",
          "2DigitCode": "PM",
          "3DigitCode": "SPM"
        },
        {
          "COUNTRY_NAME": "SAINT VINCENT AND THE GRENADINES",
          "2DigitCode": "VC",
          "3DigitCode": "VCT"
        },
        {
          "COUNTRY_NAME": "SAMOA",
          "2DigitCode": "WS",
          "3DigitCode": "WSM"
        },
        {
          "COUNTRY_NAME": "SAN MARINO",
          "2DigitCode": "SM",
          "3DigitCode": "SMR"
        },
        {
          "COUNTRY_NAME": "SAO TOME AND PRINCIPE",
          "2DigitCode": "ST",
          "3DigitCode": "STP"
        },
        {
          "COUNTRY_NAME": "SAUDI ARABIA",
          "2DigitCode": "SA",
          "3DigitCode": "SAU"
        },
        {
          "COUNTRY_NAME": "SENEGAL",
          "2DigitCode": "SN",
          "3DigitCode": "SEN"
        },
        {
          "COUNTRY_NAME": "SERBIA",
          "2DigitCode": "RS",
          "3DigitCode": "SRB"
        },
        {
          "COUNTRY_NAME": "SEYCHELLES",
          "2DigitCode": "SC",
          "3DigitCode": "SYC"
        },
        {
          "COUNTRY_NAME": "SIERRA LEONE",
          "2DigitCode": "SL",
          "3DigitCode": "SLE"
        },
        {
          "COUNTRY_NAME": "SINGAPORE",
          "2DigitCode": "SG",
          "3DigitCode": "SGP"
        },
        {
          "COUNTRY_NAME": "SINT MAARTEN (DUTCH PART)",
          "2DigitCode": "SX",
          "3DigitCode": "SXM"
        },
        {
          "COUNTRY_NAME": "SLOVAKIA",
          "2DigitCode": "SK",
          "3DigitCode": "SVK"
        },
        {
          "COUNTRY_NAME": "SLOVENIA",
          "2DigitCode": "SI",
          "3DigitCode": "SVN"
        },
        {
          "COUNTRY_NAME": "SOLOMON ISLANDS",
          "2DigitCode": "SB",
          "3DigitCode": "SLB"
        },
        {
          "COUNTRY_NAME": "SOMALIA",
          "2DigitCode": "SO",
          "3DigitCode": "SOM"
        },
        {
          "COUNTRY_NAME": "SOUTH AFRICA",
          "2DigitCode": "ZA",
          "3DigitCode": "ZAF"
        },
        {
          "COUNTRY_NAME": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
          "2DigitCode": "GS",
          "3DigitCode": "SGS"
        },
        {
          "COUNTRY_NAME": "SPAIN",
          "2DigitCode": "ES",
          "3DigitCode": "ESP"
        },
        {
          "COUNTRY_NAME": "SRI LANKA",
          "2DigitCode": "LK",
          "3DigitCode": "LKA"
        },
        {
          "COUNTRY_NAME": "SUDAN",
          "2DigitCode": "SD",
          "3DigitCode": "SDN"
        },
        {
          "COUNTRY_NAME": "SURINAME",
          "2DigitCode": "SR",
          "3DigitCode": "SUR"
        },
        {
          "COUNTRY_NAME": "SVALBARD AND JAN MAYEN",
          "2DigitCode": "SJ",
          "3DigitCode": "SJM"
        },
        {
          "COUNTRY_NAME": "SWAZILAND",
          "2DigitCode": "SZ",
          "3DigitCode": "SWZ"
        },
        {
          "COUNTRY_NAME": "SWEDEN",
          "2DigitCode": "SE",
          "3DigitCode": "SWE"
        },
        {
          "COUNTRY_NAME": "SWITZERLAND",
          "2DigitCode": "CH",
          "3DigitCode": "CHE"
        },
        {
          "COUNTRY_NAME": "SYRIAN ARAB REPUBLIC",
          "2DigitCode": "SY",
          "3DigitCode": "SYR"
        },
        {
          "COUNTRY_NAME": "TAIWAN, PROVINCE OF CHINA",
          "2DigitCode": "TW",
          "3DigitCode": "TWN"
        },
        {
          "COUNTRY_NAME": "TAJIKISTAN",
          "2DigitCode": "TJ",
          "3DigitCode": "TJK"
        },
        {
          "COUNTRY_NAME": "TANZANIA, UNITED REPUBLIC OF",
          "2DigitCode": "TZ",
          "3DigitCode": "TZA"
        },
        {
          "COUNTRY_NAME": "THAILAND",
          "2DigitCode": "TH",
          "3DigitCode": "THA"
        },
        {
          "COUNTRY_NAME": "TIMOR-LESTE",
          "2DigitCode": "TL",
          "3DigitCode": "TLS"
        },
        {
          "COUNTRY_NAME": "TOGO",
          "2DigitCode": "TG",
          "3DigitCode": "TGO"
        },
        {
          "COUNTRY_NAME": "TOKELAU",
          "2DigitCode": "TK",
          "3DigitCode": "TKL"
        },
        {
          "COUNTRY_NAME": "TONGA",
          "2DigitCode": "TO",
          "3DigitCode": "TON"
        },
        {
          "COUNTRY_NAME": "TRINIDAD AND TOBAGO",
          "2DigitCode": "TT",
          "3DigitCode": "TTO"
        },
        {
          "COUNTRY_NAME": "TUNISIA",
          "2DigitCode": "TN",
          "3DigitCode": "TUN"
        },
        {
          "COUNTRY_NAME": "TURKEY",
          "2DigitCode": "TR",
          "3DigitCode": "TUR"
        },
        {
          "COUNTRY_NAME": "TURKMENISTAN",
          "2DigitCode": "TM",
          "3DigitCode": "TKM"
        },
        {
          "COUNTRY_NAME": "TURKS AND CAICOS ISLANDS",
          "2DigitCode": "TC",
          "3DigitCode": "TCA"
        },
        {
          "COUNTRY_NAME": "TUVALU",
          "2DigitCode": "TV",
          "3DigitCode": "TUV"
        },
        {
          "COUNTRY_NAME": "UGANDA",
          "2DigitCode": "UG",
          "3DigitCode": "UGA"
        },
        {
          "COUNTRY_NAME": "UKRAINE",
          "2DigitCode": "UA",
          "3DigitCode": "UKR"
        },
        {
          "COUNTRY_NAME": "UNITED ARAB EMIRATES",
          "2DigitCode": "AE",
          "3DigitCode": "ARE"
        },
        {
          "COUNTRY_NAME": "UNITED KINGDOM",
          "2DigitCode": "GB",
          "3DigitCode": "GBR"
        },
        {
          "COUNTRY_NAME": "UNITED STATES",
          "2DigitCode": "US",
          "3DigitCode": "USA"
        },
        {
          "COUNTRY_NAME": "UNITED STATES MINOR OUTLYING ISLANDS",
          "2DigitCode": "UM",
          "3DigitCode": "UMI"
        },
        {
          "COUNTRY_NAME": "URUGUAY",
          "2DigitCode": "UY",
          "3DigitCode": "URY"
        },
        {
          "COUNTRY_NAME": "UZBEKISTAN",
          "2DigitCode": "UZ",
          "3DigitCode": "UZB"
        },
        {
          "COUNTRY_NAME": "VANUATU",
          "2DigitCode": "VU",
          "3DigitCode": "VUT"
        },
        {
          "COUNTRY_NAME": "VENEZUELA, BOLIVARIAN REPUBLIC OF",
          "2DigitCode": "VE",
          "3DigitCode": "VEN"
        },
        {
          "COUNTRY_NAME": "VIET NAM",
          "2DigitCode": "VN",
          "3DigitCode": "VNM"
        },
        {
          "COUNTRY_NAME": "VIRGIN ISLANDS, BRITISH",
          "2DigitCode": "VG",
          "3DigitCode": "VGB"
        },
        {
          "COUNTRY_NAME": "VIRGIN ISLANDS, U.S.",
          "2DigitCode": "VI",
          "3DigitCode": "VIR"
        },
        {
          "COUNTRY_NAME": "WALLIS AND FUTUNA",
          "2DigitCode": "WF",
          "3DigitCode": "WLF"
        },
        {
          "COUNTRY_NAME": "WESTERN SAHARA",
          "2DigitCode": "EH",
          "3DigitCode": "ESH"
        },
        {
          "COUNTRY_NAME": "YEMEN",
          "2DigitCode": "YE",
          "3DigitCode": "YEM"
        },
        {
          "COUNTRY_NAME": "ZAMBIA",
          "2DigitCode": "ZM",
          "3DigitCode": "ZMB"
        },
        {
          "COUNTRY_NAME": "ZIMBABWE",
          "2DigitCode": "ZW",
          "3DigitCode": "ZWE"
        }
]
export const countryCodes = [
        {
            "name": "AFGHANISTAN",
            "dial_code": "+93",
            "code": "AF",
            "flag": "🇦🇫"
        },
        {
            "name": "ALAND ISLANDS",
            "dial_code": "+358",
            "code": "AX",
            "flag": "🇦🇽"
        },
        {
            "name": "ALBANIA",
            "dial_code": "+355",
            "code": "AL",
            "flag": "🇦🇱"
        },
        {
            "name": "ALGERIA",
            "dial_code": "+213",
            "code": "DZ",
            "flag": "🇩🇿"
        },
        {
            "name": "AMERICAN SAMOA",
            "dial_code": "+1684",
            "code": "AS",
            "flag": "🇺🇸"
        },
        {
            "name": "ANDORRA",
            "dial_code": "+376",
            "code": "AD",
            "flag": "🇦🇩"
        },
        {
            "name": "ANGOLA",
            "dial_code": "+244",
            "code": "AO",
            "flag": "🇦🇴"
        },
        {
            "name": "ANGUILLA",
            "dial_code": "+1264",
            "code": "AI",
            "flag": "🇦🇮"
        },
        {
            "name": "ANTARCTICA",
            "dial_code": "+672",
            "code": "AQ",
            "flag": "🇦🇶"
        },
        {
            "name": "ANTIGUA AND BARBUDA",
            "dial_code": "+1268",
            "code": "AG",
            "flag": "🇦🇬"
        },
        {
            "name": "ARGENTINA",
            "dial_code": "+54",
            "code": "AR",
            "flag": "🇦🇷"
        },
        {
            "name": "ARMENIA",
            "dial_code": "+374",
            "code": "AM",
            "flag": "🇦🇲"
        },
        {
            "name": "ARUBA",
            "dial_code": "+297",
            "code": "AW",
            "flag": "🇦🇼"
        },
        {
            "name": "AUSTRALIA",
            "dial_code": "+61",
            "code": "AU",
            "flag": "🇦🇺"
        },
        {
            "name": "AUSTRIA",
            "dial_code": "+43",
            "code": "AT",
            "flag": "🇦🇹"
        },
        {
            "name": "AZERBAIJAN",
            "dial_code": "+994",
            "code": "AZ",
            "flag": "🇦🇿"
        },
        {
            "name": "BAHAMAS",
            "dial_code": "+1242",
            "code": "BS",
            "flag": "🇧🇸"
        },
        {
            "name": "BAHRAIN",
            "dial_code": "+973",
            "code": "BH",
            "flag": "🇧🇸"
        },
        {
            "name": "BANGLADESH",
            "dial_code": "+880",
            "code": "BD",
            "flag": "🇧🇩"
        },
        {
            "name": "BARBADOS",
            "dial_code": "+1246",
            "code": "BB",
            "flag": "🇧🇧"
        },
        {
            "name": "BELARUS",
            "dial_code": "+375",
            "code": "BY",
            "flag": "🇧🇾"
        },
        {
            "name": "BELGIUM",
            "dial_code": "+32",
            "code": "BE",
            "flag": "🇧🇪"
        },
        {
            "name": "BELIZE",
            "dial_code": "+501",
            "code": "BZ",
            "flag": "🇧🇿"
        },
        {
            "name": "BENIN",
            "dial_code": "+229",
            "code": "BJ",
            "flag": "🇧🇯"
        },
        {
            "name": "BERMUDA",
            "dial_code": "+1441",
            "code": "BM",
            "flag": "🇧🇲"
        },
        {
            "name": "BHUTAN",
            "dial_code": "+975",
            "code": "BT",
            "flag": "🇧🇹"
        },
        {
            "name": "BOLIVIA, PLURINATIONAL STATE OF BOLIVIA",
            "dial_code": "+591",
            "code": "BO",
            "flag": "🇧🇴"
        },
        {
            "name": "BOSNIA AND HERZEGOVINA",
            "dial_code": "+387",
            "code": "BA",
            "flag": "🇧🇦"
        },
        {
            "name": "BOTSWANA",
            "dial_code": "+267",
            "code": "BW",
            "flag": "🇧🇼"
        },
        {
            "name": "BOUVET ISLAND",
            "dial_code": "+47",
            "code": "BV",
            "flag": "🏳"
        },
        {
            "name": "BRAZIL",
            "dial_code": "+55",
            "code": "BR",
            "flag": "🇧🇷"
        },
        {
            "name": "BRITISH INDIAN OCEAN TERRITORY",
            "dial_code": "+246",
            "code": "IO",
            "flag": "🇮🇴"
        },
        {
            "name": "BRUNEI DARUSSALAM",
            "dial_code": "+673",
            "code": "BN",
            "flag": "🇧🇳"
        },
        {
            "name": "BULGARIA",
            "dial_code": "+359",
            "code": "BG",
            "flag": "🇧🇬"
        },
        {
            "name": "BURKINA FASO",
            "dial_code": "+226",
            "code": "BF",
            "flag": "🇧🇫"
        },
        {
            "name": "BURUNDI",
            "dial_code": "+257",
            "code": "BI",
            "flag": "🇧🇮"
        },
        {
            "name": "CAMBODIA",
            "dial_code": "+855",
            "code": "KH",
            "flag": "🇰🇭"
        },
        {
            "name": "CAMEROON",
            "dial_code": "+237",
            "code": "CM",
            "flag": "🇨🇲"
        },
        {
            "name": "CANADA",
            "dial_code": "+1",
            "code": "CA",
            "flag": "🇨🇦"
        },
        {
            "name": "CAPE VERDE",
            "dial_code": "+238",
            "code": "CV",
            "flag": "🇨🇻"
        },
        {
            "name": "CAYMAN ISLANDS",
            "dial_code": "+345",
            "code": "KY",
            "flag": "🇰🇾"
        },
        {
            "name": "CENTRAL AFRICAN REPUBLIC",
            "dial_code": "+236",
            "code": "CF",
            "flag": "🇨🇫"
        },
        {
            "name": "CHAD",
            "dial_code": "+235",
            "code": "TD",
            "flag": "🇹🇩"
        },
        {
            "name": "CHILE",
            "dial_code": "+56",
            "code": "CL",
            "flag": "🇨🇱"
        },
        {
            "name": "CHINA",
            "dial_code": "+86",
            "code": "CN",
            "flag": "🇨🇳"
        },
        {
            "name": "CHRISTMAS ISLAND",
            "dial_code": "+61",
            "code": "CX",
            "flag": "🇨🇽"
        },
        {
            "name": "COCOS (KEELING) ISLANDS",
            "dial_code": "+61",
            "code": "CC",
            "flag": "🇨🇨"
        },
        {
            "name": "COLOMBIA",
            "dial_code": "+57",
            "code": "CO",
            "flag": "🇨🇴"
        },
        {
            "name": "COMOROS",
            "dial_code": "+269",
            "code": "KM",
            "flag": "🇰🇲"
        },
        {
            "name": "CONGO",
            "dial_code": "+242",
            "code": "CG",
            "flag": "🇨🇬"
        },
        {
            "name": "CONGO, THE DEMOCRATIC REPUBLIC OF THE CONGO",
            "dial_code": "+243",
            "code": "CD",
            "flag": "🇨🇩"
        },
        {
            "name": "COOK ISLANDS",
            "dial_code": "+682",
            "code": "CK",
            "flag": "🇨🇰"
        },
        {
            "name": "COSTA RICA",
            "dial_code": "+506",
            "code": "CR",
            "flag": "🇨🇷"
        },
        {
            "name": "COTE D'IVOIRE",
            "dial_code": "+225",
            "code": "CI",
            "flag": "🇨🇮"
        },
        {
            "name": "CROATIA",
            "dial_code": "+385",
            "code": "HR",
            "flag": "🇭🇷"
        },
        {
            "name": "CUBA",
            "dial_code": "+53",
            "code": "CU",
            "flag": "🇨🇺"
        },
        {
            "name": "CYPRUS",
            "dial_code": "+357",
            "code": "CY",
            "flag": "🇨🇾"
        },
        {
            "name": "CZECH REPUBLIC",
            "dial_code": "+420",
            "code": "CZ",
            "flag": "🇨🇿"
        },
        {
            "name": "DENMARK",
            "dial_code": "+45",
            "code": "DK",
            "flag": "🇩🇰"
        },
        {
            "name": "DJIBOUTI",
            "dial_code": "+253",
            "code": "DJ",
            "flag": "🇩🇯"
        },
        {
            "name": "DOMINICA",
            "dial_code": "+1767",
            "code": "DM",
            "flag": "🇩🇲"
        },
        {
            "name": "DOMINICAN REPUBLIC",
            "dial_code": "+1849",
            "code": "DO",
            "flag": "🇨🇩"
        },
        {
            "name": "ECUADOR",
            "dial_code": "+593",
            "code": "EC",
            "flag": "🇪🇨"
        },
        {
            "name": "EGYPT",
            "dial_code": "+20",
            "code": "EG",
            "flag": "🇪🇬"
        },
        {
            "name": "EL SALVADOR",
            "dial_code": "+503",
            "code": "SV",
            "flag": "🇸🇻"
        },
        {
            "name": "EQUATORIAL GUINEA",
            "dial_code": "+240",
            "code": "GQ",
            "flag": "🇬🇶"
        },
        {
            "name": "ERITREA",
            "dial_code": "+291",
            "code": "ER",
            "flag": "🇪🇷"
        },
        {
            "name": "ESTONIA",
            "dial_code": "+372",
            "code": "EE",
            "flag": "🇪🇪"
        },
        {
            "name": "ETHIOPIA",
            "dial_code": "+251",
            "code": "ET",
            "flag": "🇪🇹"
        },
        {
            "name": "FALKLAND ISLANDS (MALVINAS)",
            "dial_code": "+500",
            "code": "FK",
            "flag": "🇫🇰"
        },
        {
            "name": "FAROE ISLANDS",
            "dial_code": "+298",
            "code": "FO",
            "flag": "🇫🇴"
        },
        {
            "name": "FIJI",
            "dial_code": "+679",
            "code": "FJ",
            "flag": "🇫🇯"
        },
        {
            "name": "FINLAND",
            "dial_code": "+358",
            "code": "FI",
            "flag": "🇫🇮"
        },
        {
            "name": "FRANCE",
            "dial_code": "+33",
            "code": "FR",
            "flag": "🇫🇷"
        },
        {
            "name": "FRENCH GUIANA",
            "dial_code": "+594",
            "code": "GF",
            "flag": "🇬🇫"
        },
        {
            "name": "FRENCH POLYNESIA",
            "dial_code": "+689",
            "code": "PF",
            "flag": "🇵🇫"
        },
        {
            "name": "FRENCH SOUTHERN TERRITORIES",
            "dial_code": "+262",
            "code": "TF",
            "flag": "🇹🇫"
        },
        {
            "name": "GABON",
            "dial_code": "+241",
            "code": "GA",
            "flag": "🇬🇦"
        },
        {
            "name": "GAMBIA",
            "dial_code": "+220",
            "code": "GM",
            "flag": "🇬🇲"
        },
        {
            "name": "GEORGIA",
            "dial_code": "+995",
            "code": "GE",
            "flag": "🇬🇪"
        },
        {
            "name": "GERMANY",
            "dial_code": "+49",
            "code": "DE",
            "flag": "🇩🇪"
        },
        {
            "name": "GHANA",
            "dial_code": "+233",
            "code": "GH",
            "flag": "🇬🇭"
        },
        {
            "name": "GIBRALTAR",
            "dial_code": "+350",
            "code": "GI",
            "flag": "🇬🇮"
        },
        {
            "name": "GREECE",
            "dial_code": "+30",
            "code": "GR",
            "flag": "🇬🇷"
        },
        {
            "name": "GREENLAND",
            "dial_code": "+299",
            "code": "GL",
            "flag": "🇬🇱"
        },
        {
            "name": "GRENADA",
            "dial_code": "+1473",
            "code": "GD",
            "flag": "🇬🇩"
        },
        {
            "name": "GUADELOUPE",
            "dial_code": "+590",
            "code": "GP",
            "flag": "🇬🇵"
        },
        {
            "name": "GUAM",
            "dial_code": "+1671",
            "code": "GU",
            "flag": "🇬🇺"
        },
        {
            "name": "GUATEMALA",
            "dial_code": "+502",
            "code": "GT",
            "flag": "🇬🇹"
        },
        {
            "name": "GUERNSEY",
            "dial_code": "+44",
            "code": "GG",
            "flag": "🇬🇬"
        },
        {
            "name": "GUINEA",
            "dial_code": "+224",
            "code": "GN",
            "flag": "🇬🇳"
        },
        {
            "name": "GUINEA-BISSAU",
            "dial_code": "+245",
            "code": "GW",
            "flag": "🇬🇼"
        },
        {
            "name": "GUYANA",
            "dial_code": "+592",
            "code": "GY",
            "flag": "🇬🇾"
        },
        {
            "name": "HAITI",
            "dial_code": "+509",
            "code": "HT",
            "flag": "🇭🇹"
        },
        {
            "name": "HEARD ISLAND AND MCDONALD ISLANDS",
            "dial_code": "+0",
            "code": "HM",
            "flag": "🏳"
        },
        {
            "name": "HOLY SEE (VATICAN CITY STATE)",
            "dial_code": "+379",
            "code": "VA",
            "flag": "🇻🇦"
        },
        {
            "name": "HONDURAS",
            "dial_code": "+504",
            "code": "HN",
            "flag": "🇭🇳"
        },
        {
            "name": "HONG KONG",
            "dial_code": "+852",
            "code": "HK",
            "flag": "🇭🇰"
        },
        {
            "name": "HUNGARY",
            "dial_code": "+36",
            "code": "HU",
            "flag": "🇭🇺"
        },
        {
            "name": "ICELAND",
            "dial_code": "+354",
            "code": "IS",
            "flag": "🇮🇸"
        },
        {
            "name": "INDIA",
            "dial_code": "+91",
            "code": "IN",
            "flag": "🇮🇳"
        },
        {
            "name": "INDONESIA",
            "dial_code": "+62",
            "code": "ID",
            "flag": "🇮🇩"
        },
        {
            "name": "IRAN, ISLAMIC REPUBLIC OF PERSIAN GULF",
            "dial_code": "+98",
            "code": "IR",
            "flag": "🇮🇷"
        },
        {
            "name": "IRAQ",
            "dial_code": "+964",
            "code": "IQ",
            "flag": "🇮🇶"
        },
        {
            "name": "IRELAND",
            "dial_code": "+353",
            "code": "IE",
            "flag": "🇮🇪"
        },
        {
            "name": "ISLE OF MAN",
            "dial_code": "+44",
            "code": "IM",
            "flag": "🇮🇲"
        },
        {
            "name": "ISRAEL",
            "dial_code": "+972",
            "code": "IL",
            "flag": "🇮🇱"
        },
        {
            "name": "ITALY",
            "dial_code": "+39",
            "code": "IT",
            "flag": "🇮🇹"
        },
        {
            "name": "JAMAICA",
            "dial_code": "+1876",
            "code": "JM",
            "flag": "🇯🇲"
        },
        {
            "name": "JAPAN",
            "dial_code": "+81",
            "code": "JP",
            "flag": "🇯🇵"
        },
        {
            "name": "JERSEY",
            "dial_code": "+44",
            "code": "JE",
            "flag": "🇯🇪"
        },
        {
            "name": "JORDAN",
            "dial_code": "+962",
            "code": "JO",
            "flag": "🇯🇴"
        },
        {
            "name": "KAZAKHSTAN",
            "dial_code": "+7",
            "code": "KZ",
            "flag": "🇰🇿"
        },
        {
            "name": "KENYA",
            "dial_code": "+254",
            "code": "KE",
            "flag": "🇰🇪"
        },
        {
            "name": "KIRIBATI",
            "dial_code": "+686",
            "code": "KI",
            "flag": "🇰🇮"
        },
        {
            "name": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF KOREA",
            "dial_code": "+850",
            "code": "KP",
            "flag": "🇰🇵"
        },
        {
            "name": "KOREA, REPUBLIC OF SOUTH KOREA",
            "dial_code": "+82",
            "code": "KR",
            "flag": "🇰🇷"
        },
        {
            "name": "KOSOVO",
            "dial_code": "+383",
            "code": "XK",
            "flag": "🇽🇰"
        },
        {
            "name": "KUWAIT",
            "dial_code": "+965",
            "code": "KW",
            "flag": "🇰🇼"
        },
        {
            "name": "KYRGYZSTAN",
            "dial_code": "+996",
            "code": "KG",
            "flag": "🇰🇬"
        },
        {
            "name": "LAOS",
            "dial_code": "+856",
            "code": "LA",
            "flag": "🇱🇦"
        },
        {
            "name": "LATVIA",
            "dial_code": "+371",
            "code": "LV",
            "flag": "🇱🇻"
        },
        {
            "name": "LEBANON",
            "dial_code": "+961",
            "code": "LB",
            "flag": "🇱🇧"
        },
        {
            "name": "LESOTHO",
            "dial_code": "+266",
            "code": "LS",
            "flag": "🇱🇸"
        },
        {
            "name": "LIBERIA",
            "dial_code": "+231",
            "code": "LR",
            "flag": "🇱🇷"
        },
        {
            "name": "LIBYAN ARAB JAMAHIRIYA",
            "dial_code": "+218",
            "code": "LY",
            "flag": "🇱🇾"
        },
        {
            "name": "LIECHTENSTEIN",
            "dial_code": "+423",
            "code": "LI",
            "flag": "🇱🇮"
        },
        {
            "name": "LITHUANIA",
            "dial_code": "+370",
            "code": "LT",
            "flag": "🇱🇹"
        },
        {
            "name": "LUXEMBOURG",
            "dial_code": "+352",
            "code": "LU",
            "flag": "🇱🇺"
        },
        {
            "name": "MACAO",
            "dial_code": "+853",
            "code": "MO",
            "flag": "🇲🇴"
        },
        {
            "name": "MACEDONIA",
            "dial_code": "+389",
            "code": "MK",
            "flag": "🇲🇰"
        },
        {
            "name": "MADAGASCAR",
            "dial_code": "+261",
            "code": "MG",
            "flag": "🇲🇬"
        },
        {
            "name": "MALAWI",
            "dial_code": "+265",
            "code": "MW",
            "flag": "🇲🇼"
        },
        {
            "name": "MALAYSIA",
            "dial_code": "+60",
            "code": "MY",
            "flag": "🇲🇾"
        },
        {
            "name": "MALDIVES",
            "dial_code": "+960",
            "code": "MV",
            "flag": "🇲🇻"
        },
        {
            "name": "MALI",
            "dial_code": "+223",
            "code": "ML",
            "flag": "🇲🇱"
        },
        {
            "name": "MALTA",
            "dial_code": "+356",
            "code": "MT",
            "flag": "🇲🇹"
        },
        {
            "name": "MARSHALL ISLANDS",
            "dial_code": "+692",
            "code": "MH",
            "flag": "🇲🇭"
        },
        {
            "name": "MARTINIQUE",
            "dial_code": "+596",
            "code": "MQ",
            "flag": "🇲🇶"
        },
        {
            "name": "MAURITANIA",
            "dial_code": "+222",
            "code": "MR",
            "flag": "🇲🇷"
        },
        {
            "name": "MAURITIUS",
            "dial_code": "+230",
            "code": "MU",
            "flag": "🇲🇺"
        },
        {
            "name": "MAYOTTE",
            "dial_code": "+262",
            "code": "YT",
            "flag": "🇾🇹"
        },
        {
            "name": "MEXICO",
            "dial_code": "+52",
            "code": "MX",
            "flag": "🇲🇽"
        },
        {
            "name": "MICRONESIA, FEDERATED STATES OF MICRONESIA",
            "dial_code": "+691",
            "code": "FM",
            "flag": "🇫🇲"
        },
        {
            "name": "MOLDOVA",
            "dial_code": "+373",
            "code": "MD",
            "flag": "🇲🇩"
        },
        {
            "name": "MONACO",
            "dial_code": "+377",
            "code": "MC",
            "flag": "🇲🇨"
        },
        {
            "name": "MONGOLIA",
            "dial_code": "+976",
            "code": "MN",
            "flag": "🇲🇳"
        },
        {
            "name": "MONTENEGRO",
            "dial_code": "+382",
            "code": "ME",
            "flag": "🇲🇪"
        },
        {
            "name": "MONTSERRAT",
            "dial_code": "+1664",
            "code": "MS",
            "flag": "🇲🇸"
        },
        {
            "name": "MOROCCO",
            "dial_code": "+212",
            "code": "MA",
            "flag": "🇲🇦"
        },
        {
            "name": "MOZAMBIQUE",
            "dial_code": "+258",
            "code": "MZ",
            "flag": "🇲🇿"
        },
        {
            "name": "MYANMAR",
            "dial_code": "+95",
            "code": "MM",
            "flag": "🇲🇲"
        },
        {
            "name": "NAMIBIA",
            "dial_code": "+264",
            "code": "NA",
            "flag": "🇳🇦"
        },
        {
            "name": "NAURU",
            "dial_code": "+674",
            "code": "NR",
            "flag": "🇳🇷"
        },
        {
            "name": "NEPAL",
            "dial_code": "+977",
            "code": "NP",
            "flag": "🇳🇵"
        },
        {
            "name": "NETHERLANDS",
            "dial_code": "+31",
            "code": "NL",
            "flag": "🇳🇱"
        },
        {
            "name": "NETHERLANDS ANTILLES",
            "dial_code": "+599",
            "code": "AN",
            "flag": "🇳🇱"
        },
        {
            "name": "NEW CALEDONIA",
            "dial_code": "+687",
            "code": "NC",
            "flag": "🇳🇨"
        },
        {
            "name": "NEW ZEALAND",
            "dial_code": "+64",
            "code": "NZ",
            "flag": "🇳🇿"
        },
        {
            "name": "NICARAGUA",
            "dial_code": "+505",
            "code": "NI",
            "flag": "🇳🇮"
        },
        {
            "name": "NIGER",
            "dial_code": "+227",
            "code": "NE",
            "flag": "🇳🇪"
        },
        {
            "name": "NIGERIA",
            "dial_code": "+234",
            "code": "NG",
            "flag": "🇳🇬"
        },
        {
            "name": "NIUE",
            "dial_code": "+683",
            "code": "NU",
            "flag": "🇳🇺"
        },
        {
            "name": "NORFOLK ISLAND",
            "dial_code": "+672",
            "code": "NF",
            "flag": "🇳🇫"
        },
        {
            "name": "NORTHERN MARIANA ISLANDS",
            "dial_code": "+1670",
            "code": "MP",
            "flag": "🏳"
        },
        {
            "name": "NORWAY",
            "dial_code": "+47",
            "code": "NO",
            "flag": "🇳🇴"
        },
        {
            "name": "OMAN",
            "dial_code": "+968",
            "code": "OM",
            "flag": "🇴🇲"
        },
        {
            "name": "PAKISTAN",
            "dial_code": "+92",
            "code": "PK",
            "flag": "🇵🇰"
        },
        {
            "name": "PALAU",
            "dial_code": "+680",
            "code": "PW",
            "flag": "🇵🇼"
        },
        {
            "name": "PALESTINIAN TERRITORY, OCCUPIED",
            "dial_code": "+970",
            "code": "PS",
            "flag": "🇵🇸"
        },
        {
            "name": "PANAMA",
            "dial_code": "+507",
            "code": "PA",
            "flag": "🇵🇦"
        },
        {
            "name": "PAPUA NEW GUINEA",
            "dial_code": "+675",
            "code": "PG",
            "flag": "🇵🇬"
        },
        {
            "name": "PARAGUAY",
            "dial_code": "+595",
            "code": "PY",
            "flag": "🇵🇾"
        },
        {
            "name": "PERU",
            "dial_code": "+51",
            "code": "PE",
            "flag": "🇵🇪"
        },
        {
            "name": "PHILIPPINES",
            "dial_code": "+63",
            "code": "PH",
            "flag": "🇵🇭"
        },
        {
            "name": "PITCAIRN",
            "dial_code": "+64",
            "code": "PN",
            "flag": "🇵🇳"
        },
        {
            "name": "POLAND",
            "dial_code": "+48",
            "code": "PL",
            "flag": "🇵🇱"
        },
        {
            "name": "PORTUGAL",
            "dial_code": "+351",
            "code": "PT",
            "flag": "🇵🇹"
        },
        {
            "name": "PUERTO RICO",
            "dial_code": "+1939",
            "code": "PR",
            "flag": "🇵🇷"
        },
        {
            "name": "QATAR",
            "dial_code": "+974",
            "code": "QA",
            "flag": "🇶🇦"
        },
        {
            "name": "ROMANIA",
            "dial_code": "+40",
            "code": "RO",
            "flag": "🇷🇴"
        },
        {
            "name": "RUSSIA",
            "dial_code": "+7",
            "code": "RU",
            "flag": "🇷🇺"
        },
        {
            "name": "RWANDA",
            "dial_code": "+250",
            "code": "RW",
            "flag": "🇷🇼"
        },
        {
            "name": "REUNION",
            "dial_code": "+262",
            "code": "RE",
            "flag": "🇫🇷"
        },
        {
            "name": "SAINT BARTHELEMY",
            "dial_code": "+590",
            "code": "BL",
            "flag": "🇧🇱"
        },
        {
            "name": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA",
            "dial_code": "+290",
            "code": "SH",
            "flag": "🇸🇭"
        },
        {
            "name": "SAINT KITTS AND NEVIS",
            "dial_code": "+1869",
            "code": "KN",
            "flag": "🇰🇳"
        },
        {
            "name": "SAINT LUCIA",
            "dial_code": "+1758",
            "code": "LC",
            "flag": "🇱🇨"
        },
        {
            "name": "SAINT MARTIN",
            "dial_code": "+590",
            "code": "MF",
            "flag": "🏳"
        },
        {
            "name": "SAINT PIERRE AND MIQUELON",
            "dial_code": "+508",
            "code": "PM",
            "flag": "🇵🇲"
        },
        {
            "name": "SAINT VINCENT AND THE GRENADINES",
            "dial_code": "+1784",
            "code": "VC",
            "flag": "🇻🇨"
        },
        {
            "name": "SAMOA",
            "dial_code": "+685",
            "code": "WS",
            "flag": "🇼🇸"
        },
        {
            "name": "SAN MARINO",
            "dial_code": "+378",
            "code": "SM",
            "flag": "🇸🇲"
        },
        {
            "name": "SAO TOME AND PRINCIPE",
            "dial_code": "+239",
            "code": "ST",
            "flag": "🇸🇹"
        },
        {
            "name": "SAUDI ARABIA",
            "dial_code": "+966",
            "code": "SA",
            "flag": "🇸🇦"
        },
        {
            "name": "SENEGAL",
            "dial_code": "+221",
            "code": "SN",
            "flag": "🇸🇳"
        },
        {
            "name": "SERBIA",
            "dial_code": "+381",
            "code": "RS",
            "flag": "🇷🇸"
        },
        {
            "name": "SEYCHELLES",
            "dial_code": "+248",
            "code": "SC",
            "flag": "🇸🇨"
        },
        {
            "name": "SIERRA LEONE",
            "dial_code": "+232",
            "code": "SL",
            "flag": "🇸🇱"
        },
        {
            "name": "SINGAPORE",
            "dial_code": "+65",
            "code": "SG",
            "flag": "🇸🇬"
        },
        {
            "name": "SLOVAKIA",
            "dial_code": "+421",
            "code": "SK",
            "flag": "🇸🇰"
        },
        {
            "name": "SLOVENIA",
            "dial_code": "+386",
            "code": "SI",
            "flag": "🇸🇮"
        },
        {
            "name": "SOLOMON ISLANDS",
            "dial_code": "+677",
            "code": "SB",
            "flag": "🇸🇧"
        },
        {
            "name": "SOMALIA",
            "dial_code": "+252",
            "code": "SO",
            "flag": "🇸🇴"
        },
        {
            "name": "SOUTH AFRICA",
            "dial_code": "+27",
            "code": "ZA",
            "flag": "🇿🇦"
        },
        {
            "name": "SOUTH SUDAN",
            "dial_code": "+211",
            "code": "SS",
            "flag": "🇸🇸"
        },
        {
            "name": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
            "dial_code": "+500",
            "code": "GS",
            "flag": "🇬🇸"
        },
        {
            "name": "SPAIN",
            "dial_code": "+34",
            "code": "ES",
            "flag": "🇪🇸"
        },
        {
            "name": "SRI LANKA",
            "dial_code": "+94",
            "code": "LK",
            "flag": "🇱🇰"
        },
        {
            "name": "SUDAN",
            "dial_code": "+249",
            "code": "SD",
            "flag": "🇸🇩"
        },
        {
            "name": "SURINAME",
            "dial_code": "+597",
            "code": "SR",
            "flag": "🇸🇷"
        },
        {
            "name": "SVALBARD AND JAN MAYEN",
            "dial_code": "+47",
            "code": "SJ",
            "flag": "🇩🇰"
        },
        {
            "name": "SWAZILAND",
            "dial_code": "+268",
            "code": "SZ",
            "flag": "🇸🇿"
        },
        {
            "name": "SWEDEN",
            "dial_code": "+46",
            "code": "SE",
            "flag": "🇸🇪"
        },
        {
            "name": "SWITZERLAND",
            "dial_code": "+41",
            "code": "CH",
            "flag": "🇨🇭"
        },
        {
            "name": "SYRIAN ARAB REPUBLIC",
            "dial_code": "+963",
            "code": "SY",
            "flag": "🇸🇾"
        },
        {
            "name": "TAIWAN",
            "dial_code": "+886",
            "code": "TW",
            "flag": "🇹🇼"
        },
        {
            "name": "TAJIKISTAN",
            "dial_code": "+992",
            "code": "TJ",
            "flag": "🇹🇯"
        },
        {
            "name": "TANZANIA, UNITED REPUBLIC OF TANZANIA",
            "dial_code": "+255",
            "code": "TZ",
            "flag": "🇹🇿"
        },
        {
            "name": "THAILAND",
            "dial_code": "+66",
            "code": "TH",
            "flag": "🇹🇭"
        },
        {
            "name": "TIMOR-LESTE",
            "dial_code": "+670",
            "code": "TL",
            "flag": "🇹🇱"
        },
        {
            "name": "TOGO",
            "dial_code": "+228",
            "code": "TG",
            "flag": "🇹🇬"
        },
        {
            "name": "TOKELAU",
            "dial_code": "+690",
            "code": "TK",
            "flag": "🇹🇰"
        },
        {
            "name": "TONGA",
            "dial_code": "+676",
            "code": "TO",
            "flag": "🇹🇴"
        },
        {
            "name": "TRINIDAD AND TOBAGO",
            "dial_code": "+1868",
            "code": "TT",
            "flag": "🇹🇹"
        },
        {
            "name": "TUNISIA",
            "dial_code": "+216",
            "code": "TN",
            "flag": "🇹🇳"
        },
        {
            "name": "TURKEY",
            "dial_code": "+90",
            "code": "TR",
            "flag": "🇹🇷"
        },
        {
            "name": "TURKMENISTAN",
            "dial_code": "+993",
            "code": "TM",
            "flag": "🇹🇲"
        },
        {
            "name": "TURKS AND CAICOS ISLANDS",
            "dial_code": "+1649",
            "code": "TC",
            "flag": "🇹🇨"
        },
        {
            "name": "TUVALU",
            "dial_code": "+688",
            "code": "TV",
            "flag": "🇹🇻"
        },
        {
            "name": "UGANDA",
            "dial_code": "+256",
            "code": "UG",
            "flag": "🇺🇬"
        },
        {
            "name": "UKRAINE",
            "dial_code": "+380",
            "code": "UA",
            "flag": "🇺🇦"
        },
        {
            "name": "UNITED ARAB EMIRATES",
            "dial_code": "+971",
            "code": "AE",
            "flag": "🇦🇪"
        },
        {
            "name": "UNITED KINGDOM",
            "dial_code": "+44",
            "code": "GB",
            "flag": "🇬🇧"
        },
        {
            "name": "UNITED STATES",
            "dial_code": "+1",
            "code": "US",
            "flag": "🇺🇸"
        },
        {
            "name": "URUGUAY",
            "dial_code": "+598",
            "code": "UY",
            "flag": "🇺🇾"
        },
        {
            "name": "UZBEKISTAN",
            "dial_code": "+998",
            "code": "UZ",
            "flag": "🇺🇿"
        },
        {
            "name": "VANUATU",
            "dial_code": "+678",
            "code": "VU",
            "flag": "🇻🇺"
        },
        {
            "name": "VENEZUELA, BOLIVARIAN REPUBLIC OF VENEZUELA",
            "dial_code": "+58",
            "code": "VE",
            "flag": "🇻🇪"
        },
        {
            "name": "VIETNAM",
            "dial_code": "+84",
            "code": "VN",
            "flag": "🇻🇳"
        },
        {
            "name": "VIRGIN ISLANDS, BRITISH",
            "dial_code": "+1284",
            "code": "VG",
            "flag": "🇻🇬"
        },
        {
            "name": "VIRGIN ISLANDS, U.S.",
            "dial_code": "+1340",
            "code": "VI",
            "flag": "🇻🇮"
        },
        {
            "name": "WALLIS AND FUTUNA",
            "dial_code": "+681",
            "code": "WF",
            "flag": "🇼🇫"
        },
        {
            "name": "YEMEN",
            "dial_code": "+967",
            "code": "YE",
            "flag": "🇾🇪"
        },
        {
            "name": "ZAMBIA",
            "dial_code": "+260",
            "code": "ZM",
            "flag": "🇿🇲"
        },
        {
            "name": "ZIMBABWE",
            "dial_code": "+263",
            "code": "ZW",
            "flag": "🇿🇼"
        }
]
export const internationalDocumentType = [
        {
                label: 'Passport',
                code: 'P'
        },
        {
                label: 'Visa',
                code: 'V'
        },
        {
                label: 'Diplomat Passport',
                code: 'PD'
        },
        {
                label: 'Diplomatic Passport',
                code: 'D'
        },
        {
                label: 'Missionary or Service Passport',
                code: 'PM'
        },
        {
                label: 'Special Passport',
                code: 'PS'
        },
        {
                label: 'Seafarer Passport',
                code: 'SF'
        }
];
export const passportValidationProperties = {
        firstName: 'First name',
        lastName: 'Last name',
        issuingCountry: 'issuing country',
        gender: 'gender',
        docNumber: 'document number',
        birthCountry: 'birth country',
        nationality: 'nationality',
        docType: 'document type',
        expirationDate: 'expiration Date',
        dob: 'date of birth',
        // isDocumentVerified: 'Please verify the document to proceed add/update operation.'
}
export const validInternationalDocumentType = ['P', 'V', 'PD'];
export const mergedArrayForCountryDropdown = [defaultCountryInfo, ...countryCodes];
export const flightsearchPageIconsMapping = {
        0: 'newImages/boarding.svg',
        1: 'newImages/closed.svg',
        2: 'newImages/boarding-cancel.svg',
        3: 'newImages/boarding-cancel.svg',
        4: 'newImages/close_pending.svg',
        5: 'newImages/boarding-cancel.svg',
        6: 'newImages/boarding-cancel.svg'
}
export const sKeys = {
        'Search': 'F2',
        'Seat': 'F4',
        'Bags': 'F5',
        'Service': 'F6',
        'Payment': 'F7',
        'Finalize': 'F10',
        'PnrHistory': 'h',
        'PassengerInformation': 'i',
        'Comments': 'm',
        'SecurityTravelDoc': 'F3',
        'ManifestDetail': 'd',
        'PeripheralDevices': 'p',
        'SpiceClub': 'NA'
}
export const statusForGateChangeAction = ['Boarding', 'ClosedPending'];
export const sKeysForBoarding = {
        'FlightSearch': 'F2',
        'Overview': 'F3',
        'Manifest': 'F4',
        'Boarding': 'F5',
        'SeatManagement': 'F6'
}
export const seatBlockSSRS = ['WCHR', 'WCHS', 'WCHX', 'UNMR', 'INFT'];
export const printerForBoardingPass = {
        Tsc: true,
        Custom: false,
        OnlyTSCStation: []
}

export const printersConfigBP = {
        'TSCPL': ['TSC'],
        'ZPL': ['ZEBRA'],
        'HTML': ['KORES']
}

export const printersConfigBT = {
        'TSCPL': ['TSC'],
        'ZPL': ['ZEBRA'],
        'HTML': ['KORES']
}

export const cityNames = {
        "DEL": "Delhi",
        "BOM": "Mumbai",
        "BLR": "Bengaluru",
        "MAA": "Chennai",
        "CCU": "Kolkata",
        "HYD": "Hyderabad",
        "GOI": "Goa",
        "COK": "Kochi",
        "AMD": "Ahmedabad",
        "PNQ": "Pune",
        "ATQ": "Amritsar",
        "TRV": "Thiruvananthapuram",
        "GAU": "Guwahati",
        "VTZ": "Visakhapatnam",
        "JAI": "Jaipur",
        "IXC": "Chandigarh",
        "IDR": "Indore",
        "BBI": "Bhubaneswar",
        "IXB": "Siliguri",
        "AGX": "Agatti",
        "IXA": "Agartala",
        "AGR": "Agra",
        "AJL": "Aizawl",
        "AKD": "Akola",
        "BEK": "Bareilly",
        "IXG": "Belgaum",
        "BEP": "Bellary",
        "BHU": "Bhavnagar",
        "BHO": "Bhopal",
        "BHJ": "Bhuj",
        "CJB": "Coimbatore",
        "CCJ": "Kozhikode",
        "DED": "Dehradun",
        "NAG": "Nagpur",
        "SXR": "Srinagar",
        "IXM": "Madurai",
        "IXE": "Mangaluru",
        "IXJ": "Jammu",
        "IXZ": "Port Blair",
        "STV": "Surat"
};   

export const airlineNames = {
        'SG': 'SPICEJET',
        '6E': 'INDIGO',
        'AI': 'AIR INDIA',
        'UK': 'VISTARA',
        'G8': 'GO FIRST'
};

export function fncSetIsSelectedToFalse(returnVal) {
        returnVal.data.flightDetails.journeys.length && returnVal.data.flightDetails.journeys.forEach((val) => {

                val.segments.forEach((seg) => {
                        seg.IsSelected = false;
                        seg.passengerSegment.forEach((paxseg) => {
                                paxseg.IsSelected = false;
                        })
                })


        })
        returnVal.data.flightDetails.passenger.forEach((pax) => {
                pax.IsSelected = false;
        })

        return returnVal;
}
export function fncAssignSearchedCheckboxes(selectedPassengerIDs, stSearchedFlightDetails, Parameter) {
        // console.log('selectedPassengerIDs, stSearchedFlightDetails, Parameter', selectedPassengerIDs, stSearchedFlightDetails, Parameter);
        var selectedPassengerIDs = selectedPassengerIDs;
        var vSearchedFlightDetails = '';
        var arrSelectedPaxSegmentPassengerKey = [];
        debugger
        //     if(Parameter=="SEARCH")
        //     {
        //       vSearchedFlightDetails = stSearchedFlightDetails;

        //     }
        //     else if(Parameter=="AUTOSEATASSIGN")
        //     {
        stSearchedFlightDetails.journeys.forEach((val) => {

                val.segments.forEach((seg) => {
                        seg.IsSelected = false;
                        seg.passengerSegment.forEach((paxseg) => {
                                paxseg.IsSelected = false;
                        })
                })


        })
        stSearchedFlightDetails.passenger.forEach((pax) => {
                pax.IsSelected = false;
        })
        vSearchedFlightDetails = stSearchedFlightDetails;
        //     }
        selectedPassengerIDs.SelectedPassengerKey.forEach((val) => {
                vSearchedFlightDetails.passenger.forEach((pax) => {
                        if ((pax.name.title + '' + pax.name.first + "" + pax.name.last).toUpperCase() == val.toUpperCase()) {

                                pax.IsSelected = true;
                                arrSelectedPaxSegmentPassengerKey.push(pax.passengerKey)
                        }
                })
        })

        selectedPassengerIDs.SelectedSegmentKey.forEach((val) => {
                vSearchedFlightDetails.journeys.forEach((jou) => {
                        jou.segments.forEach((seg) => {
                                if (seg.segmentKey == val) {
                                        seg.IsSelected = true;
                                        seg.passengerSegment.forEach((paxseg) => {
                                                // selectedPassengerIDs.SelectedPassengerKey.forEach((selectedPax) => {
                                                arrSelectedPaxSegmentPassengerKey.forEach((selectedPax) => {

                                                        if (paxseg.passengerKey == selectedPax) {
                                                                paxseg.IsSelected = true;
                                                        }
                                                })
                                        })
                                }
                        })
                })
        })

        // vSearchedFlightDetails.journeys.forEach((j) => {
        //         j.segments.forEach((seg) => {
        //                 if(seg.IsSelected && selectedPassengerIDs.SelectedSegmentKey.includes(seg.segmentKey)) {
        //                         // console.log('selected seg', seg);
        //                         seg.passengerSegment.forEach((pseg) => {
        //                                 vSearchedFlightDetails.passenger.forEach((p) => {
        //                                         if (p.traveldocuments && p.traveldocuments.length) {
        //                                                 p.traveldocuments.forEach((td) => {
        //                                                         if (pseg.verifiedTravelDocuments
        //                                                                 && pseg.verifiedTravelDocuments.length
        //                                                                 && pseg.verifiedTravelDocuments.includes(td.passengerTravelDocumentKey)) {
        //                                                                         td.isDocVerified = true;
        //                                                         } else {
        //                                                                 td.isDocVerified = false;
        //                                                         }
        //                                                 })
        //                                         }
        //                                 }) 
        //                         })
        //                 }
        //         })
        // })

        // console.log('vSearchedFlightDetails', vSearchedFlightDetails);
        return vSearchedFlightDetails;
}
//
export function fncGetPaymentNameFromCode(paymentJSON, code) {

        var fileterd = paymentJSON.filter(record => record.paymentMethodCode.toUpperCase() === code.toUpperCase())
        const paymentName = fileterd.length ? fileterd[0].name : code
        return paymentName;
}
export function fncMakeFlightReference(data, passengerKey) {
        var amount = 0;
        for (var i = 0; i < data.passenger.length; i++) {
                if (data.passenger[i].IsSelected == true && data.passenger[i].passengerKey == passengerKey) {
                        for (var j = 0; j < data.journeys.length; j++) {
                                var Segments = data.journeys[j].segments;
                                for (var k = 0; k < Segments.length; k++) {
                                        if (Segments[k].IsSelected == true) {
                                                var syear = Segments[k].designator.departure.split('T')[0].split('-')[0];
                                                var smonth = Segments[k].designator.departure.split('T')[0].split('-')[1];
                                                var sdate = Segments[k].designator.departure.split('T')[0].split('-')[2];
                                                var airline = Segments[k].designator.origin + "" + Segments[k].designator.destination;
                                                var identifier = Segments[k].identifier.carrierCode + "  " + Segments[k].identifier.identifier;
                                                var flightReference = syear + "" + smonth + "" + sdate + " " + identifier + " " + airline;

                                                for (var l = 0; l < data.passenger[i].fees.length; l++) {
                                                        if (data.passenger[i].fees[l].type == "SeatFee" && data.passenger[i].fees[l].flightReference.replace(/ /g, '') == flightReference.replace(/ /g, '')) {
                                                                amount = amount + parseInt(data.passenger[i].fees[l].totalAmount);
                                                        }
                                                }
                                        }
                                }
                        }
                }
        }

        return amount;

}

export function fncGetServiceNameFromCode(paymentJSON, code) {
           
        var fileterd = paymentJSON.filter(record => record.ssrCode === code.toUpperCase())
        if (fileterd.length > 0) {
                return fileterd[0].name
        }
        else {
                fileterd = paymentJSON.filter(record => record.feeCode === code.toUpperCase())
                if(fileterd.length==0)
                {
                        return code;  
                }
                else
                {
                        return fileterd[0].name;
                }                
        }
}

export function fncMulitpleJourneyStatus(flightStatus) {
           
        var count = 0;
        for (var j = 0; j < flightStatus.length; j++) {
                var fltStatus = flightStatus[j].segments;
                for (var i = 0; i < fltStatus.length; i++) {
                        if (fltStatus[i].IsSelected == true) {
                                count = count + 1;
                                break;
                                // return fltStatus[i].legs[0].statusCode+"_"+fltStatus[i].legs[0].status;
                        }
                }
        }
        if (count == 1) {
                return true;
        }
        else {
                return false;
        }



}
export function fncCheckFlightStatus(flightStatus) {
           
        var count = 0;
        var data = "";
        for (var j = 0; j < flightStatus.length; j++) {
                var fltStatus = flightStatus[j].segments;
                for (var i = 0; i < fltStatus.length; i++) {
                        if (fltStatus[i].IsSelected == true && fltStatus[i].legs[0].statusCode == 2) {
                                if (count == 0) {
                                        count = count + 1;
                                        data = fltStatus[i].legs[0].statusCode + "_" + fltStatus[i].legs[0].status + "_" + count;
                                }
                        }
                }
        }
        return data;
}

export function fncCheckFlightReferenceOnServicePage(data, passengerKey, flightReference) {
           
        if (flightReference == "") {
                return true;
        }
        var isExist = false;
        for (var i = 0; i < data.passenger.length; i++) {
                if (data.passenger[i].IsSelected == true && data.passenger[i].passengerKey == passengerKey) {
                        for (var j = 0; j < data.journeys.length; j++) {
                                var Segments = data.journeys[j].segments;
                                for (var k = 0; k < Segments.length; k++) {
                                        if (Segments[k].IsSelected == true) {
                                                var syear = Segments[k].designator.departure.split('T')[0].split('-')[0];
                                                var smonth = Segments[k].designator.departure.split('T')[0].split('-')[1];
                                                var sdate = Segments[k].designator.departure.split('T')[0].split('-')[2];
                                                var airline = Segments[k].designator.origin + "" + Segments[k].designator.destination;
                                                var identifier = Segments[k].identifier.carrierCode + "  " + Segments[k].identifier.identifier;
                                                var CompareflightReference = syear + "" + smonth + "" + sdate + " " + identifier + " " + airline;

                                                if (CompareflightReference.replace(/ /g, '') == flightReference) {
                                                        isExist = true;
                                                }
                                        }
                                }
                        }
                }
        }

        return isExist;
}

export function fncBagStatus(SearchedFlightDetails, BaggageKey, passengerKey, From) {
        var status = "";
        for (var i = 0; i < SearchedFlightDetails.journeys.length; i++) {
                var segment = SearchedFlightDetails.journeys[i].segments;
                for (var j = 0; j < segment.length; j++) {
                        if (segment[j].IsSelected == true) {
                                var passSeg = segment[j].passengerSegment
                                for (var k = 0; k < passSeg.length; k++) {
                                        if (passSeg[k].passengerKey == passengerKey && passSeg[k].IsSelected == true) {
                                                var bags = passSeg[k].bags;
                                                for (var l = 0; l < bags.length; l++) {
                                                        if (BaggageKey == bags[l].baggageKey) {
                                                                status = bags[l].status
                                                        }
                                                }
                                        }
                                }
                        }
                }
        }

        return status;

}
// created on 31 may 2021
export function fncBagCount(SearchedFlightDetails, passengerKey) {
        // debugger
        var count = 0;
        let totalBagWeight = 0;
        // debugger
        for (var i = 0; i < SearchedFlightDetails.journeys.length; i++) {
                var segment = SearchedFlightDetails.journeys[i].segments.filter(s => s.IsSelected);
                // for(var j=0; j<segment.length; j++)
                // {
                const passenger = SearchedFlightDetails.passenger.filter(p => p.IsSelected && p.passengerKey === passengerKey);
                if (segment.length > 0) {
                        var passSeg = segment[0].passengerSegment
                        for (var k = 0; k < passSeg.length; k++) {
                                if (passSeg[k].passengerKey == passengerKey && passSeg[k].IsSelected == true) {
                                        var bags = passSeg[k].bags;
                                        for (var l = 0; l < bags.length; l++) {
                                                if ("CHECKED" == bags[l].status.toUpperCase() || "ADDED" == bags[l].status.toUpperCase() ) {
                                                        if (passenger.length) {
                                                                const bagweight = passenger[0].bags.filter(b => b.baggageKey === bags[l].baggageKey)[0];
                                                                totalBagWeight = totalBagWeight + bagweight.weight;
                                                        }
                                                        count = count + 1;
                                                }
                                        }
                                }
                        }
                }
                // }
        }

        return `${count}/${totalBagWeight}`;

}

export function fncSeqNo(SearchedFlightDetails, passengerKey) {
        let seq = "0";
        for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
                let segment = SearchedFlightDetails.journeys[i].segments.filter(seg => seg.IsSelected);
                if (segment.length) {
                        let passSeg = segment[0].passengerSegment;
                        for (let k = 0; k < passSeg.length; k++) {
                                if (passSeg[k].passengerKey == passengerKey && passSeg[k].IsSelected == true) {
                                     seq = passSeg[k].boardingSequence;
                                }
                        }
                }
        }
        return seq;
}

export function fncSSR(SearchedFlightDetails, passengerKey) {
        let ssrString = "";
        for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
                let segment = SearchedFlightDetails.journeys[i].segments.filter(seg => seg.IsSelected);
                if (segment.length) {
                        let passSeg = segment[0].passengerSegment;
                        for (let k = 0; k < passSeg.length; k++) { 
                                if (passSeg[k].passengerKey === passengerKey && passSeg[k].IsSelected == true) {                                  
                                        let ssrs = passSeg[k].ssrs;                          
                                        if (ssrs.length) {
                                                for (let s = 0; s < ssrs.length; s++) {
                                                        if (s === 0) {
                                                               ssrString = `${ssrs[s].ssrCode}`; 
                                                        } else {
                                                                ssrString = `${ssrString}, ${ssrs[s].ssrCode}`; 
                                                        }                                                                                     
                                                }
                                        } else {
                                                ssrString = "-"  
                                        }
                                        if (passSeg[k].hasInfant) {
                                                ssrString = ssrString.length && ssrString !== '-' ? `${ssrString}, INFT` : 'INFT';
                                        }
                                }  
                                
                                // if (passSeg[k].passengerKey == passengerKey && passSeg[k].IsSelected == true) {
                                //         ssrString = passSeg[k].boardingSequence;
                                // }
                        }
                }
        }
        return ssrString;
}

// created on 29 may 2021
export function fncCheckDepartedFlight(SearchedFlightDetails, segmentKey) {
        var arrDepatureArray = [];
        var now = moment();
        var vSearchedFlightDetails = SearchedFlightDetails;

        for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
                if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
                        for (var j = 0; j < vSearchedFlightDetails.journeys.length; j++) {
                                var Segments = vSearchedFlightDetails.journeys[j].segments;
                                for (var k = 0; k < Segments.length; k++) {
                                        if (segmentKey == "") {
                                                if (Segments[k].IsSelected) {
                                                        const DepartureTime = Segments[k].legs[0].operationsInfo && Segments[k].legs[0].operationsInfo.departureTimes.estimated ? Segments[k].legs[0].operationsInfo.departureTimes.estimated : Segments[k].designator.departure;
                                                        const then = moment(DepartureTime);
                                                        if (now > then) {
                                                                arrDepatureArray.push(true)
                                                        } else {
                                                                arrDepatureArray.push(false)
                                                        }

                                                }
                                        }
                                        else {
                                                if (Segments[k].IsSelected && Segments[k].segmentKey === segmentKey) {
                                                        const DepartureTime = Segments[k].legs[0].operationsInfo && Segments[k].legs[0].operationsInfo.departureTimes.estimated ? Segments[k].legs[0].operationsInfo.departureTimes.estimated : Segments[k].designator.departure;
                                                        const then = moment(DepartureTime);
                                                        if (now > then) {
                                                                arrDepatureArray.push(true)
                                                        } else {
                                                                arrDepatureArray.push(false)
                                                        }

                                                }
                                        }

                                }
                        }
                }
        }

        return arrDepatureArray;


        //---------------- old on 17 june -------------------
        // var DepartureDateTime = SearchedFlightDetails.journeys[0].designator.departure;
        // var now = moment();
        // var vSearchedFlightDetails= SearchedFlightDetails;
        // for(var i=0; i<vSearchedFlightDetails.passenger.length; i++)
        // {
        //   if(vSearchedFlightDetails.passenger[i].IsSelected==true)
        //   {
        //     for(var j=0; j<vSearchedFlightDetails.journeys.length; j++)
        //     {
        //       var Segments = vSearchedFlightDetails.journeys[j].segments;
        //         for(var k=0; k<Segments.length; k++)
        //         {
        //           if(Segments[k].IsSelected==true)
        //           {

        //           var passSeg =Segments[k].passengerSegment;
        //           for(var l=0; l<passSeg.length; l++)
        //           {
        //             if(passSeg[l].passengerKey==vSearchedFlightDetails.passenger[i].passengerKey && passSeg[l].IsSelected==true && passSeg[l].seats.length>0)
        //             {
        //                 DepartureDateTime ="";
        //             }
        //           }
        //         }
        //         }
        //     }
        //   }
        // }

        // var then = moment(DepartureDateTime);
        // if (now > then) {
        //         return true;
        //       } else {
        //         return false;
        //       }
}

// created on 31 may 2021
export function fncRedirectToHome() {
           
        if (localStorage.getItem("LoginToken") === undefined) {
                return false;
        }
        else {
                return true;
        }

}
// created on 27 august 2021
export function fncPageNavigations(UserRights,page,assignStateAgain) {
        // console.log('UserRights----', UserRights);
        if(page=="Search")
        {
           //------------------------------- Skiping the seat page ------------------------------
           var journeys = assignStateAgain.journeys;
           const international = isInternationalFlight(journeys, false);
           var seatFlag = false;
           for(var i=0; i<journeys.length; i++)
           {
                   var segments=journeys[i].segments;
                   for(var j=0; j<segments.length; j++)
                   {
                           if(segments[j].IsSelected==true)
                           {
                                   var passengerSegment= segments[j].passengerSegment;
                                   for(var k=0; k<passengerSegment.length; k++)
                                   {
                                           if(passengerSegment[k].IsSelected==true && passengerSegment[k].seats.length==0)
                                           {
                                                   seatFlag=true;   
                                           }
                                   }
                           }
                   }
           }
           if (!international && UserRights.find(user => user.key === 'SecurityTravelDoc')) {
                   return 'SecurityTravelDoc';
           } else {
                   /// ----------------------------- skiping the seat page ends here-----------------
           if(seatFlag)
           {
                   return 'Seat';   
           }
           else
           {

           //-------------------------------- Skiping the Bags-------------------------------
                   var passengers = assignStateAgain.passenger;
                   var bagFlag = false;
                   var bagcount=0;
                   for(var i=0; i<passengers.length>0; i++)
                   {
                           if(passengers[i].IsSelected==true)
                           {
                                if(bagcount==0 && passengers[i].bags.length>0)
                                {
                                   for(var j=0; j<passengers[i].bags.length; j++)
                                   {
                                        var status = fncBagStatus(assignStateAgain, passengers[i].bags[j].baggageKey, passengers[i].passengerKey, "")
                                      
                                                if(status.toUpperCase()=="CHECKED" || status.toUpperCase()=="ADDED")
                                                {
                                                        bagcount=1;
                                                        bagFlag=false;
                                                        break;
                                                }      
                                                else{
                                                        bagFlag=true; 
                                                } 
                                        }                                                                        
                                }   
                                else
                                {
                                        bagFlag=true;
                                }                          
                           }
                   }
                   //-------------------------------------- skiping the bags ends here ------------------------

                   if(bagFlag==true)
                   {
                           return 'Bags';    
                   }
                   else
                   {
                           //-------------------------------------- Skiping the payment page --------------------------
                           if(assignStateAgain.breakdown.balanceDue==0)
                           {
                                   return 'Finalize'; 
                           }
                           else
                           {
                                   return 'Payment';   
                           }
                           //----------------------------------------- Skiping the payment page ends here ------------------------
                   }          
           }
           }
        }
        else if (page === 'SecurityTravelDoc') {
                return 'Seat';
        }
        else if(page=="Seat")
        {

                var passengers = assignStateAgain.passenger;
                var bagFlag = false;
                var bagcount=0;
                for(var i=0; i<passengers.length>0; i++)
                {
                        if(passengers[i].IsSelected==true)
                        {
                             if(bagcount==0 && passengers[i].bags.length>0)
                             {
                                for(var j=0; j<passengers[i].bags.length; j++)
                                {
                                     var status = fncBagStatus(assignStateAgain, passengers[i].bags[j].baggageKey, passengers[i].passengerKey, "")
                                   
                                             if(status.toUpperCase()=="CHECKED" || status.toUpperCase()=="ADDED")
                                             {
                                                     bagcount=1;
                                                     bagFlag=false;
                                                     break;
                                             }      
                                             else{
                                                     bagFlag=true; 
                                             } 
                                     }                                                                        
                             }   
                             else
                             {
                                     bagFlag=true;
                             }                          
                        }
                }
                //-------------------------------------- skiping the bags ends here ------------------------

                if(bagFlag==true)
                {
                        return 'Bags';    
                }
                else
                {
                        //-------------------------------------- Skiping the payment page --------------------------
                        if(assignStateAgain.breakdown.balanceDue==0)
                        {
                                return 'Finalize'; 
                        }
                        else
                        {
                                return 'Payment';   
                        }
                        //----------------------------------------- Skiping the payment page ends here ------------------------
                }
        }
        else if(page=="Bags")
        {
                if(assignStateAgain.breakdown.balanceDue==0)
                {
                        return 'Finalize'; 
                }
                else
                {
                        return 'Payment';   
                }
        }
        else if(page=="Services")
        {
                if(assignStateAgain.breakdown.balanceDue==0)
                {
                        return 'Finalize'; 
                }
                else
                {
                        return 'Payment';   
                }
        }

}

export function shortcutKeyForPage(page, event, SearchedFlightDetails) {
        debugger
        // event.preventDefault();
        let returnUrl;
        switch (event.key) {
                case 'F2':
                        returnUrl = 'Search';
                        break;
                case 'F3':
                        if (isInternationalPNR(SearchedFlightDetails)) {
                                returnUrl = 'SecurityTravelDoc';
                        } else {
                                returnUrl = '';
                        }
                        break;
                case 'F4':
                        returnUrl = 'Seat';
                        break;
                case 'F6':
                        returnUrl = 'Service';
                        break;
                case 'F7':
                        returnUrl = 'Payment';
                        break;
                case 'F5':
                        returnUrl = 'Bags';
                        break;
                case 'F10':
                        returnUrl = 'Finalize';
                        break;
                case 'i':
                        returnUrl = event.ctrlKey ? 'PassengerInformation' : null;
                        break;
                case 'h':
                        returnUrl = event.ctrlKey ? 'PnrHistory' : null;
                        break;
                case 'm':
                        returnUrl = event.ctrlKey ? 'Comments' : null;
                        break;
                case 'd':
                        returnUrl = event.ctrlKey ? 'ManifestDetail' : null;
                        break;
                case 'p':
                        returnUrl = event.ctrlKey ? 'PeripheralDevices' : null;
                        break;
        
                default:
                        returnUrl = 'Search';
        }

        return returnUrl;
}

// export function getCtrlshortcutKeyForPage(event,SearchedFlightDetails) {
//         if (!event.ctrlKey) return null;
      
//         const key = event.key.toLowerCase();
      
//         switch (key) {
//           case 'i':
//             return 'PassengerInformation';
//           case 'h':
//             return 'PnrHistory';
//           case 'm':
//             return 'Comments';
//           case 'd':
//             return 'ManifestDetail';
//           case 'p':
//             return 'PeripheralDevices';
//           default:
//             return null;
//         }
//       }
      

function assignSeatRequest(seatData, dataId, AssignSeatRequests, seatMap, segmentKey, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails) {
        // console.log('assignSeatRequest', seatData, dataId, AssignSeatRequests, seatMap, segmentKey, st_SelectedSeatByPassenger.journeyKey, seatIdentificationData, SearchedFlightDetails);
        const asr = AssignSeatRequests;
        const firstPassenger = asr.length > 0 ? asr[0].passengerKey : null;
        const selectedSegment = SearchedFlightDetails.journeys.filter(j => j.journeyKey === st_SelectedSeatByPassenger.journeyKey)[0].segments.filter(s => s.segmentKey === segmentKey);
        if (selectedSegment.length) {
                let ssrLeg = [];
                let allSSRBlockedSeats = [];
                let blockedRows = [];
                if (seatIdentificationData.length > 0) {
                        selectedSegment[0].legs.forEach(leg => {
                                ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);
                        })
                        ssrLeg.forEach(s => {
                        allSSRBlockedSeats.push(...s.rownoInfant, ...s.rownoUNMR, ...s.rownoWheelchair);
                        });
                }
                if (allSSRBlockedSeats.length) {
                        blockedRows = allSSRBlockedSeats.map(i => i = i.replace(/\D/g,''));
                }

                const minRowId = seatMap[0].id;
                const maxRowId = seatMap[seatMap.length - 1].id;
                const selectedSeatByPaxId = dataId;
                let incrementCounter = selectedSeatByPaxId;
                let tempCounter = 0; 
                // let incrementCount = selectedSeatByPaxId;
                let decrementCounter = selectedSeatByPaxId - 1;
                
                const firstPassengerBlockSSRs = firstPassenger && selectedSegment[0].passengerSegment.filter(p => p.IsSelected && p.passengerKey === firstPassenger);
                if (firstPassengerBlockSSRs && firstPassengerBlockSSRs.length > 0 && (firstPassengerBlockSSRs[0].hasInfant || firstPassengerBlockSSRs[0].ssrs.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0)) {
                        blockedRows.push(selectedSeatByPaxId.toString());
                }
                const seatsAssigned = [];

                seatsAssigned.push(seatData.SeatDesignator);
                // console.log('currentPnrWithBlockedSSRSRows', currentPnrWithBlockedSSRSRows);
                const totalSelectedPassengers = selectedSegment[0].passengerSegment.filter(p => p.IsSelected).length;
                const passengersOtherThanPrimaryPax = firstPassenger ? selectedSegment[0].passengerSegment.filter(p => p.passengerKey !== firstPassenger && p.IsSelected && p.seats.length === 0) : selectedSegment[0].passengerSegment.filter(p => p.IsSelected && p.seats.length === 0);

                passengersOtherThanPrimaryPax.length && passengersOtherThanPrimaryPax.forEach(pseg => {
                          
                        while(!asr.some(asr => asr.passengerKey === pseg.passengerKey)) {

                                 /** if tempCounter === 0, increment if tempCounter === 1, decrement */
                                let rowToSelect = selectedSeatByPaxId;
                                if (tempCounter === 0) {
                                        rowToSelect = incrementCounter; 
                                } else {
                                        rowToSelect = decrementCounter;
                                }
                                if (minRowId <= rowToSelect <= maxRowId) {
                                        var row = seatMap.filter(sm => sm.id === rowToSelect);
                                        if (row.length) {
                                                if (blockedRows.includes(row[0].id.toString()) && (pseg.hasInfant || pseg.ssrs.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0)) {
                                                        if (tempCounter === 0) {
                                                                incrementCounter = incrementCounter + 1;
                                                                tempCounter = 1;
                                                        } else {
                                                                decrementCounter = decrementCounter - 1;
                                                                tempCounter = 0;
                                                        }
                                                        
                                                } else {
                                                        if ((pseg.hasInfant || pseg.ssrs.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0)) {
                                                                blockedRows.push(row[0].id.toString());
                                                        }
                                                        const availableSeatInCurrentRow = row[0].dataToBind.filter(rd =>  !seatsAssigned.includes(rd.SeatDesignator) && rd.Status === 'Open');  //&& rd.Y === 0
                                                        if (availableSeatInCurrentRow.length > 0 && passengersOtherThanPrimaryPax.length) {
                                                                // for(let i = 0; i < availableSeatInCurrentRow.length; i++) {
                                                                        const currentPaxAlreadyAssigned = asr.some(asr => asr.passengerKey === pseg.passengerKey);
                                                                        if (currentPaxAlreadyAssigned) {
                                                                                return;
                                                                        }
                                                                        // console.log('seatsAssigned', seatsAssigned[seatsAssigned.length-1], row[0].dataToBind);
                                                                        const lastAssignedSeatIndex = row[0].dataToBind.findIndex(rd => rd.SeatDesignator === seatsAssigned[seatsAssigned.length-1]);
                                                                        // console.log('availableSeatInCurrentRow', availableSeatInCurrentRow, lastAssignedSeatIndex);
                                                                        let indexToSelect = lastAssignedSeatIndex;
                                                                        if (lastAssignedSeatIndex >= row[0].dataToBind.length/2) {
                                                                                if (lastAssignedSeatIndex >= availableSeatInCurrentRow.length) {
                                                                                        indexToSelect = availableSeatInCurrentRow.length-1;
                                                                                }
                                                                                // console.log('move right')
                                                                        } else {

                                                                                indexToSelect = 0;
                                                                                // console.log('move left');
                                                                        }

                                                                        if (availableSeatInCurrentRow[indexToSelect].Status === 'Open' && !seatsAssigned.includes(availableSeatInCurrentRow[indexToSelect].SeatDesignator) && !currentPaxAlreadyAssigned && totalSelectedPassengers !== asr.length) {
                                                                                asr.push({
                                                                                        "passengerKey": pseg.passengerKey,
                                                                                        "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                                                                                        "unitKey": availableSeatInCurrentRow[indexToSelect].UnitKey,
                                                                                        "waiveFee": false,
                                                                                        "SegmentKey": segmentKey,
                                                                                        "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                                                                                        "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                                                                                        "ignoreSeatSsrs": true
                                                                                })
                                                                                seatsAssigned.push(availableSeatInCurrentRow[indexToSelect].SeatDesignator);
                                                                        } else {
                                                                                if (totalSelectedPassengers !== AssignSeatRequests.length) {
                                                                                        if (tempCounter === 0) {
                                                                                                incrementCounter = incrementCounter + 1;
                                                                                                tempCounter = 1;
                                                                                        } else {
                                                                                                decrementCounter = decrementCounter - 1;
                                                                                                tempCounter = 0;
                                                                                        }
                                                                                }
                                                                                
                                                                        }
                                                                        // if (availableSeatInCurrentRow[i].Status === 'Open' && !seatsAssigned.includes(availableSeatInCurrentRow[i].SeatDesignator) && !currentPaxAlreadyAssigned && totalSelectedPassengers !== asr.length) { //availableSeatInCurrentRow[i].Y === 0 &&
                                                                        //         asr.push({
                                                                        //                 "passengerKey": pseg.passengerKey,
                                                                        //                 "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                                                                        //                 "unitKey": availableSeatInCurrentRow[i].UnitKey,
                                                                        //                 "waiveFee": false,
                                                                        //                 "SegmentKey": segmentKey,
                                                                        //                 "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                                                                        //                 "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                                                                        //                 "ignoreSeatSsrs": true
                                                                        //         })
                                                                        //         seatsAssigned.push(availableSeatInCurrentRow[i].SeatDesignator);
                                                                        // } else {
                                                                        //         if (totalSelectedPassengers !== AssignSeatRequests.length) {
                                                                        //                 if (tempCounter === 0) {
                                                                        //                         incrementCounter = incrementCounter + 1;
                                                                        //                         tempCounter = 1;
                                                                        //                 } else {
                                                                        //                         decrementCounter = decrementCounter - 1;
                                                                        //                         tempCounter = 0;
                                                                        //                 }
                                                                        //         }
                                                                                
                                                                        // }

                                                                // }
                                                        } else {
                                                                if (totalSelectedPassengers !== AssignSeatRequests.length) {
                                                                        if (tempCounter === 0) {
                                                                                incrementCounter = incrementCounter + 1;
                                                                                tempCounter = 1;
                                                                        } else {
                                                                                decrementCounter = decrementCounter - 1;
                                                                                tempCounter = 0;
                                                                        }
                                                                }
                                                        }
                                                        
                                                }
                                        } else {
                                                if (totalSelectedPassengers !== AssignSeatRequests.length) {
                                                        if (tempCounter === 0) {
                                                                incrementCounter = incrementCounter + 1;
                                                                tempCounter = 1;
                                                        } else {
                                                                decrementCounter = decrementCounter - 1;
                                                                tempCounter = 0;
                                                        }
                                                }
                                        }
                                }
                        }
                        
                        
                });
        }
        return asr;
}

export function assignSeatRequestForDirectFlight(seatData, dataId, IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests, seatMap, segmentKey, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails) {
        // debugger;
        const req = assignSeatRequest(seatData, dataId, AssignSeatRequests, seatMap, segmentKey, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails);
        return req;

}

export function assignSeatRequestForConnectingFlight(connectingFlightData, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails) {
        // console.log('assignSeatRequestForConnectingFlight', connectingFlightData, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails);
        const req = [];
        // debugger
        connectingFlightData.forEach(d => {
                const requestResult = assignSeatRequest(d.seatData, d.dataId, d.AssignSeatRequests, d.seatMap, d.segmentKey, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails);
                req.push(...requestResult);
                
        });
        return req;
}

export function createSeatMapData(returnVal, SearchedFlightDetails, segmentKey) {
        var vSearchedFlightDetails = SearchedFlightDetails;
        var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments;
            // setSeatMapApiData(returnVal.data);

            var compartmentsLength = returnVal.data.seatMapResponse.seatMap.decks[0].compartments.length;
            let countOfRowsFormedAftrAddingFalseSets = [];
            // For multiple compartments
            if (compartmentsLength > 1) {
              const result = [];
              const map = new Map();
              for (const item of seats.Compartments[1].Seats) {
                if (item.SeatDesignator.length == 2) {
                  var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2);
                  if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2))) {
                    map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2), true);    // set any value to Map
                    result.push({
                      SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2),
                      X: item.X
                    });
                  }
                }
                else {
                  var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3);
                  if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3))) {
                    map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3), true);    // set any value to Map
                    result.push({
                      SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3),
                      X: item.X
                    });
                  }
                }

              }
              var arrayWithMargin = [];
              var mar = 0;
              var marginAllowed = 0;
              for (var i = 0; i < result.length; i++) {
                if (i == 0) {
                  if (result[i].SeatDesignator != "") {
                    arrayWithMargin[i] = {
                      SeatDesignator: result[i].SeatDesignator,
                      X: result[i].X,
                      Margin: 0,
                    }
                  }

                }
                else {
                  if (i == 1) {
                    mar = result[i].X - result[i - 1].X;
                  }
                  var diff = result[i].X - result[i - 1].X;
                  if (diff > mar) {
                    marginAllowed = 1;
                  }
                  else {
                    marginAllowed = 0;
                  }
                  if (result[i].SeatDesignator != "") {
                    arrayWithMargin[i] = {
                      SeatDesignator: result[i].SeatDesignator,
                      X: result[i].X,
                      Margin: marginAllowed,
                    }
                  }


                }
              }


              var marSeats = 0;
              var marginAllowedSeats = 0;
              var countOfRowsFormed = [];

              var counter = 0;
              for (var k = 0; k < seats.Compartments.length; k++) {
                var compartmentSeats = seats.Compartments[k].Seats;
                const maxValueOfY = Math.max(...compartmentSeats.map(o => o.SeatRow), 0);
                const minValueOfY = Math.min(...compartmentSeats.map(o => o.SeatRow), 0);


                for (var j = 0; j < maxValueOfY; j++) {
                  var arrayWithMarginSeats = [];
                  var count = 0;


                  for (var i = 0; i < compartmentSeats.length; i++) {
                    if ((j + 1) == compartmentSeats[i].SeatRow) {

                      if (i == 0) {

                        // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));

                        arrayWithMarginSeats[count] = {
                          SeatDesignator: compartmentSeats[i].SeatDesignator,
                          X: compartmentSeats[i].X,
                          Margin: 0,
                          SeatRow: compartmentSeats[i].SeatRow,
                          Status: compartmentSeats[i].Status
                        }
                      }
                      else {
                        if (i == 1) {
                          marSeats = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                        }
                        var diff = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                        if (diff > marSeats) {
                          marginAllowedSeats = 1;
                        }
                        else {
                          marginAllowedSeats = 0;
                        }

                        // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));

                        arrayWithMarginSeats[count] = {
                          SeatDesignator: compartmentSeats[i].SeatDesignator,
                          X: compartmentSeats[i].X,
                          Margin: marginAllowedSeats,
                          SeatRow: compartmentSeats[i].SeatRow,
                          Status: compartmentSeats[i].Status
                        }
                      }
                      count = count + 1;
                    }
                  }
                  if (arrayWithMarginSeats.length != 0) {
                    countOfRowsFormed[counter] = {
                      id: counter,
                      dataToBind: arrayWithMarginSeats
                    };
                    counter = counter + 1;
                  }
                }
              }

              // arrayWithMargin


              //------------------------------------------------------------------ new Implementations-------------------------------------


              for (var i = 0; i < countOfRowsFormed.length; i++) {
                var arrayWithMarginAftrAddingFalseSets = [];
                var fcount = 0;
                var seatCount = "";
                for (var j = 0; j < arrayWithMargin.length; j++) {
                  var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);

                  if (obj != undefined) {
                    seatCount = obj.SeatRow;
                    arrayWithMarginAftrAddingFalseSets[fcount] = {
                      SeatDesignator: obj.SeatDesignator,
                      X: obj.X,
                      Margin: obj.Margin,
                      SeatRow: obj.SeatRow,
                      Status: obj.Status
                    }
                  }
                  else {
                    arrayWithMarginAftrAddingFalseSets[fcount] = {
                      SeatDesignator: "false",
                      X: 0,
                      Margin: 0,
                      SeatRow: '',
                      Status: 0
                    }
                  }
                  fcount = fcount + 1;
                }
                countOfRowsFormedAftrAddingFalseSets[i] = {
                  id: seatCount,
                  dataToBind: arrayWithMarginAftrAddingFalseSets
                };

              }

        //       setState({
        //         // st_countOfRowsFormed: countOfRowsFormedAftrAddingFalseSets,
        //         st_AirlineHeader: arrayWithMargin
        //       })
            }
            else {
              // For single compartment
              //   const maxValueOfY = Math.max(...returnVal.data.compartments[0].units.map(o => o.designator), 0); 
              //   const maxValueOfY = Math.max(...seats.Compartments[0].Seats.map(o => o.SeatRow), 0);   


              const maxValueOfY = 20;
              const result = [];
              const uniqueROWS = [];
              const map = new Map();
              // changes on 27 August 2020
              for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                if (item.unitKey != null) {
                  if (item.designator.length == 2) {
                    var test = item.designator.substring(item.designator.length - 1, 2);
                    if (!map.has(item.designator.substring(item.designator.length - 1, 2))) {
                      map.set(item.designator.substring(item.designator.length - 1, 2), true);    // set any value to Map
                      result.push({
                        SeatDesignator: item.designator.substring(item.designator.length - 1, 2),
                        X: item.x
                      });
                    }
                  }
                  else {
                    var test = item.designator.substring(item.designator.length - 1, 3);
                    if (!map.has(item.designator.substring(item.designator.length - 1, 3))) {
                      map.set(item.designator.substring(item.designator.length - 1, 3), true);    // set any value to Map
                      result.push({
                        SeatDesignator: item.designator.substring(item.designator.length - 1, 3),
                        X: item.x
                      });
                    }
                  }
                }
              }

              result.sort((a, b) => a.SeatDesignator > b.SeatDesignator ? 1 : -1);

              for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                if (item.unitKey != null) {

                  var test = item.designator.replace(/[^0-9]/g, '');

                  if (!map.has(parseInt(test))) {
                    map.set(parseInt(test), true);    // set any value to Map
                    uniqueROWS.push(parseInt(test));
                  }

                }
              }



              var arrayWithMargin = [];
              var mar = 0;
              var marginAllowed = 0;
              for (var i = 0; i < result.length; i++)  // changed on 27 august 2020
              {
                if (i == 0) {
                  if (result[i].SeatDesignator != "") {
                    arrayWithMargin[i] = {
                      SeatDesignator: result[i].SeatDesignator,
                      X: result[i].X,
                      Margin: 0,
                    }
                  }

                }
                else {
                  if (i == 1) {
                    mar = result[i].X - result[i - 1].X;
                  }
                  var diff = result[i].X - result[i - 1].X;
                  if (diff > mar) {
                    marginAllowed = 1;
                  }
                  else {
                    marginAllowed = 0;
                  }
                  if (result[i].SeatDesignator != "") {
                    arrayWithMargin[i] = {
                      SeatDesignator: result[i].SeatDesignator,
                      X: result[i].X,
                      Margin: marginAllowed,
                    }
                  }
                }
              }
        //       setAirlineHeader(arrayWithMargin);
              // setSegmentKeyForCurrentSeatmap(segmentKey);
              // debugger;

              var marSeats = 0;
              var marSeatsY = 0;
              var marginAllowedSeats = 0;
              var marginAllowedSeatsY = 0;
              var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units;
              var countOfRowsFormed = [];
              for (var j = 0; j < uniqueROWS.length; j++) {
                var arrayWithMarginSeats = [];
                var count = 0;
                var isEntered = false;
                var comparewithlast = 0;
                for (var i = 0; i < seats.length; i++) {
                  if (seats[i].unitKey != null) {
                    if (uniqueROWS[j] == parseInt(seats[i].designator.replace(/[^0-9]/g, ''))) {
                      if (isEntered == false) {
                        comparewithlast = i;
                        isEntered = true;
                      }

                      if (i == 0) {
                        arrayWithMarginSeats[count] = {
                          SeatDesignator: seats[i].designator,
                          X: seats[i].x,
                          Margin: 0,
                          SeatRow: seats[i].assignable,
                          Status: seats[i].availability,
                          Y: fncSeatGroupSelection(seats[i].group),
                          UnitKey: seats[i].unitKey
                        }
                      }
                      else {
                        if (i == 1) {
                          marSeats = seats[i].x - seats[i - 1].x;
                          // marSeatsY = seats[i].y - seats[i-1].y;
                        }
                        var diff = seats[i].x - seats[i - 1].x;
                        var diffY = seats[i].y - seats[comparewithlast == 0 ? 0 : comparewithlast - 1].y;
                        if (diff > marSeats) {
                          marginAllowedSeats = 1;
                        }
                        else {
                          marginAllowedSeats = 0;
                        }

                        if (diffY > 2) {
                          marginAllowedSeatsY = 1;
                        }
                        else {
                          marginAllowedSeatsY = 0;
                        }
                        arrayWithMarginSeats[count] = {
                          SeatDesignator: seats[i].designator,
                          X: seats[i].x,
                          Margin: marginAllowedSeats,
                          SeatRow: seats[i].assignable,
                          Status: seats[i].availability,
                          // Y: marginAllowedSeatsY,
                          Y: fncSeatGroupSelection(seats[i].group),
                          UnitKey: seats[i].unitKey
                        }
                      }
                      count = count + 1;
                    }
                  }
                }
                countOfRowsFormed[j] = {
                  id: uniqueROWS[j],
                  dataToBind: arrayWithMarginSeats
                };
              }
              //------------------------------------------------------------------ new Implementations-------------------------------------
              // var countOfRowsFormedAftrAddingFalseSets = [];

              for (var i = 0; i < countOfRowsFormed.length; i++) {
                var arrayWithMarginAftrAddingFalseSets = [];
                var fcount = 0;
                var seatCount = "";
                for (var j = 0; j < arrayWithMargin.length; j++) {
                  var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);
                  if (obj != undefined) {
                    seatCount = countOfRowsFormed[i].id;
                    arrayWithMarginAftrAddingFalseSets[fcount] = {
                      SeatDesignator: obj.SeatDesignator,
                      X: obj.X,
                      Margin: obj.Margin,
                      SeatRow: obj.SeatRow,
                      Status: obj.Status,
                      Y: obj.Y,
                      UnitKey: obj.UnitKey,
                      PNRPassenger: false,
                      PNRPassengerGender: ""
                    }
                  }
                  else {
                    arrayWithMarginAftrAddingFalseSets[fcount] = {
                      SeatDesignator: "false",
                      X: 0,
                      Margin: 0,
                      SeatRow: '',
                      Status: 0,
                      Y: 0,
                      UnitKey: 0,
                      PNRPassenger: false,
                      PNRPassengerGender: ""
                    }
                  }
                  fcount = fcount + 1;
                }

                // debugger;
                for (var f = 0; f < arrayWithMarginAftrAddingFalseSets.length; f++) {
                  for (var c = 0; c < vSearchedFlightDetails.journeys.length; c++) {
                    for (var d = 0; d < vSearchedFlightDetails.journeys[c].segments.length; d++) {
                      if (vSearchedFlightDetails.journeys[c].segments[d].IsSelected == true && vSearchedFlightDetails.journeys[c].segments[d].segmentKey == segmentKey) {
                        for (var e = 0; e < vSearchedFlightDetails.journeys[c].segments[d].passengerSegment.length; e++) {
                          if (vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats.length !== 0) //vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].IsSelected==true && 
                          {
                            if (arrayWithMarginAftrAddingFalseSets[f].SeatDesignator == vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats[0].unitDesignator) {
                              var GenderType = fncPassengerInformation(vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].passengerKey, SearchedFlightDetails)
                              arrayWithMarginAftrAddingFalseSets[f].PNRPassenger = true;
                              arrayWithMarginAftrAddingFalseSets[f].PNRPassengerGender = GenderType;
                            }
                          }
                        }
                      }
                    }
                  }
                }


                countOfRowsFormedAftrAddingFalseSets[i] = {
                  id: countOfRowsFormed[i].id,
                  dataToBind: arrayWithMarginAftrAddingFalseSets
                };
                
              }
        }
        return countOfRowsFormedAftrAddingFalseSets;
}

export function fncSeatGroupSelection(group) {
        const SPICE_MAX_SEAT_GROUPS = [1, 4, 5, 9, 21, 22, 23, 24, 25];
        var Result = 0;
        for (var i = 0; i < SPICE_MAX_SEAT_GROUPS.length; i++) {
          if (SPICE_MAX_SEAT_GROUPS[i] == parseInt(group)) {
            Result = 1;
          }
        }
        return Result;
}

export function fncPassengerInformation(PassengerKey, SearchedFlightDetails) {
        // debugger;
        var PassengerGender = "";
        var WithORwithoutINFT = "";
        var PassengerTypeCode = "";  //ADULT OR CHILD
        var PassengerWheelChair = "";
    
        var vSearchedPASSENGER = SearchedFlightDetails.passenger;
        for (var i = 0; i < vSearchedPASSENGER.length; i++) {
          if (vSearchedPASSENGER[i].IsSelected == true && vSearchedPASSENGER[i].passengerKey == PassengerKey) {
            PassengerGender = vSearchedPASSENGER[i].name.title == "MS" || vSearchedPASSENGER[i].name.title == "MRS" ||
              vSearchedPASSENGER[i].name.title == "MISS" ? "FEMALE" : "MALE";
            PassengerTypeCode = vSearchedPASSENGER[i].passengerTypeCode;
            WithORwithoutINFT = vSearchedPASSENGER[i].infant == null ? "NO" : "INFT";
          }
        }
    
    
        var vSearchedFlightDetails = SearchedFlightDetails.journeys;
        for (var i = 0; i < vSearchedFlightDetails.length; i++) {
          var segments = vSearchedFlightDetails[i].segments;
          for (var j = 0; j < segments.length; j++) {
            if (segments[j].IsSelected == true) {
              var passengerSegmentData = segments[j].passengerSegment;
              for (var k = 0; k < passengerSegmentData.length; k++) {
                if (passengerSegmentData[k].passengerKey == PassengerKey) {
                  for (var l = 0; l < passengerSegmentData[k].ssrs.length; l++) {
                    if (passengerSegmentData[k].ssrs[l].ssrCode == "WCHC"
                      || passengerSegmentData[k].ssrs[l].ssrCode == "WCHR"
                      || passengerSegmentData[k].ssrs[l].ssrCode == "WCHS"
                      || passengerSegmentData[k].ssrs[l].ssrCode == "WCHX") {
                      PassengerWheelChair = "YES";
                    }
                  }
                }
              }
            }
          }
        }
    
    
    
        var PassengerInfo = "";
        if (PassengerGender == "MALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "YES") {
          PassengerInfo = "MALEWITHWHEELCHAIRANDINFT"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "NO" && PassengerWheelChair == "YES") {
          PassengerInfo = "MALEWITHWHEELCHAIR"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "NO" && PassengerWheelChair == "") {
          PassengerInfo = "MALE"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "") {
          PassengerInfo = "MALEWITHINFANT"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "YES") {
          //------ child male
          PassengerInfo = "MALECHILDWITHWHEELCHAIRANDINFT"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "NO" && PassengerWheelChair == "YES") {
          PassengerInfo = "MALECHILDWITHWHEELCHAIR"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "NO" && PassengerWheelChair == "") {
          PassengerInfo = "MALECHILD"
        }
        else if (PassengerGender == "MALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "") {
          PassengerInfo = "MALECHILDWITHINFANT"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "YES") {
          //------ FEMALE 
          PassengerInfo = "FEMALEWITHWHEELCHAIRANDINFT"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "NO" && PassengerWheelChair == "YES") {
          PassengerInfo = "FEMALEWITHWHEELCHAIR"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "NO" && PassengerWheelChair == "") {
          PassengerInfo = "FEMALE"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "ADT" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "") {
          PassengerInfo = "FEMALEWITHINFANT"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "YES") {
          //------ FEMALE CHILD 
          PassengerInfo = "FEMALECHILDWITHWHEELCHAIRANDINFT"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "NO" && PassengerWheelChair == "YES") {
          PassengerInfo = "FEMALECHILDWITHWHEELCHAIR"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "NO" && PassengerWheelChair == "") {
          PassengerInfo = "FEMALECHILD"
        }
        else if (PassengerGender == "FEMALE" && PassengerTypeCode == "CHD" && WithORwithoutINFT == "INFT" && PassengerWheelChair == "") {
          PassengerInfo = "FEMALECHILDWITHINFANT"
        }
    
        return PassengerInfo;
    
}

export function fncCreateDuplicateFlightInfo(recordLocator, segmentsFromFlightInfo, passengers, indexPositions, dupArray,ZeroPosition, flightInfoCollection, Location, stSearchedFlightDetails) {
        
        // console.log('stSearchedFlightDetails', stSearchedFlightDetails);
        var n = indexPositions.includes("-");
        var arr = [];
        var segments = [];
        segments = JSON.parse(JSON.stringify(segmentsFromFlightInfo));

        if (n) {
                   
                var splitedArray = indexPositions.split('-');

                for (var i = 0; i < splitedArray.length; i++) {
                        var passengerKey = dupArray[splitedArray[i]].passengerKey;
                        for (var j = 0; j < passengers.length; j++) {
                                if (passengerKey == passengers[j].passengerKey) {
                                        if(ZeroPosition==0)
                                        {
                                                passengers[j].IsSelected=true; 
                                        }
                                           
                                        arr.push(
                                                passengers[j]
                                        )
                                }
                        }
                }
        }
        else {
                   
                var passengerKey = dupArray[indexPositions].passengerKey;
                for (var j = 0; j < passengers.length; j++) {
                        if (passengerKey == passengers[j].passengerKey) {
                                if(ZeroPosition==0 && j == 0)
                                {
                                        passengers[j].IsSelected=true; 
                                }
                                   
                                arr.push(
                                        passengers[j]
                                )
                        }
                }
        }
        debugger
        var IsCheckedIn= false;
        var IsPassengerCheckedIn =false;
        var IsPassengerNotCheckedIn = false;
        var IsPassengerBoarded= false;
        var CheckBothSegmentsForDefaultCheck= false;

        const secondJourneyKey = segments[segments.length - 1].journeyKey;
        const sameJourneySegments = segments.every(s => s.journeyKey === secondJourneyKey);
        arr.forEach((val, j) => {
                // var count=0;
                for (let i = 0; i < segments.length; i++) {
                        const seg = segments[i]; 
                        // if (seg.origin === Location) {
                                var count=0;
                                let SODBookingJourney = [];
                                let SODBookingSegment = [];
                                if (stSearchedFlightDetails) {
                                        SODBookingJourney = stSearchedFlightDetails.journeys.filter(j => j.journeyKey === seg.journeyKey);
                                        SODBookingSegment = SODBookingJourney.length && SODBookingJourney[0].segments.filter(sj => sj.segmentKey === seg.segmentKey);
                                }
                                
                                const passeg = seg.passengerSegments.find(pseg => pseg.passengerKey === val.passengerKey);
                                // seg.passengerSegments.forEach((passeg, i) => {
                                if(ZeroPosition===0 )
                                {       
                                        // if (secondJourneyKey === seg.journeyKey) {
                                                seg.IsSelected=true; 
                                        // }
                                        
                                }  
                                // ------------------------------------------- for CheckedIn Cases ----------------------                             
                                if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase()))) {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "MALEWITHINFANTCHECKEDIN";
                                        }
                                        else{
                                                val.IsCheckedIn= "MALEWITHOUTINFANTCHECKEDIN";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTCHECKEDIN";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTMALEWITHINFANTCHECKEDIN";
                                                } else{
                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTCHECKEDIN";
                                                }  
                                        }
                                        seg.IsAlreadyChecked = true;                                                
                                        IsPassengerCheckedIn=true;
                                        count++;
                                }
                                else if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey  && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase()))) {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "FEMALEWITHINFANTCHECKEDIN";
                                        }
                                        else{
                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTCHECKEDIN";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTCHECKEDIN";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTCHECKEDIN";
                                                }
                                                else {
                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTCHECKEDIN";
                                                }
                                        }
                                        seg.IsAlreadyChecked = true;                                                
                                        IsPassengerCheckedIn=true;
                                        count++;;
                                }
                                else if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey && val.title && val.title.toUpperCase()==="CHD".toUpperCase() ) {
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "CHILDWITHINFANTCHECKEDIN";
                                        }
                                        else{
                                                val.IsCheckedIn= "CHILDWITHOUTINFANTCHECKEDIN";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                val.IsCheckedIn= "ELTCHILDWITHINFANTCHECKEDIN";
                                                } else {
                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTCHECKEDIN";
                                                }
                                        }
                                        seg.IsAlreadyChecked = true;                                                
                                        IsPassengerCheckedIn=true;
                                        count++;;
                                }
                                //--------------------------------------------- For Boarded cases -----------------------
                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase())))
                                {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "MALEWITHINFANTBOARDED";
                                        }
                                        else{
                                                val.IsCheckedIn= "MALEWITHOUTINFANTBOARDED";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTBOARDED";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTMALEWITHINFANTBOARDED";
                                                } else{
                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTBOARDED";
                                                }
                                        }
                                        // IsCheckedIn= "BOARDED";
                                        IsPassengerBoarded=true;
                                        count++;
                                }
                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase())))
                                {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "FEMALEWITHINFANTBOARDED";
                                        }
                                        else{
                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTBOARDED";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTBOARDED";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTBOARDED";
                                                } else{
                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTBOARDED";
                                                }
                                        }
                                        // IsCheckedIn= "BOARDED";
                                        IsPassengerBoarded=true;
                                        count++;
                                }
                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && val.title.toUpperCase()==="CHD".toUpperCase()))
                                {
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "CHILDWITHINFANTBOARDED";
                                        }
                                        else{
                                                val.IsCheckedIn= "CHILDWITHOUTINFANTBOARDED";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTBOARDED";
                                                } else{
                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTBOARDED";
                                                }  
                                        }
                                        // IsCheckedIn= "BOARDED";
                                        IsPassengerBoarded=true;
                                        count++;
                                }         
                                //--------------------------------------------  For Default cases ------------------------ 
                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase())))
                                {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "MALEWITHINFANTDEFAULT";
                                        }
                                        else{
                                                val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTDEFAULT";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTMALEWITHINFANTDEFAULT";
                                                } else{
                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTDEFAULT";
                                                }
                                        }
                                        // IsCheckedIn= "DEFAULT";
                                        IsPassengerNotCheckedIn=true;
                                        count++;
                                }
                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase())))
                                {
                                        
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "FEMALEWITHINFANTDEFAULT";
                                        }
                                        else{
                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTDEFAULT";
                                        }
                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTDEFAULT";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTDEFAULT";
                                                } else{
                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTDEFAULT";
                                                }
                                        }
                                        // IsCheckedIn= "DEFAULT";
                                        IsPassengerNotCheckedIn=true;
                                        count++;
                                }
                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey  && val.title && val.title.toUpperCase()==="CHD".toUpperCase())
                                {
                                        if(val.hasInfant)
                                        {
                                                val.IsCheckedIn= "CHILDWITHINFANTDEFAULT";
                                        }
                                        else{
                                                val.IsCheckedIn= "CHILDWITHOUTINFANTDEFAULT";
                                        }
                                        if(SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '')
                                        {
                                                if (val.hasInfant) {
                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTDEFAULT";
                                                } else{
                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTDEFAULT";
                                                }
                                        }
                                        // IsCheckedIn= "DEFAULT";
                                        IsPassengerNotCheckedIn=true;
                                        count++;
                                }
                                else if (passeg.liftStatus === 3) {
                                        val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT";
                                        // IsPassengerNotCheckedIn=true;
                                        count++;
                                }
                                //--------------------------------------------  For Partial CheckedIn cases ------------------------ 

                                if(count==2)
                                {

                                        if(ZeroPosition==0 )
                                        {
                                                segments.forEach((segval, k) => {
                                                        segval.passengerSegments.forEach((passegval, i) => { 
                                                                if(passegval.passengerKey == val.passengerKey) 
                                                                {
                                                                        if(secondJourneyKey === segval.journeyKey && passegval.liftStatus === 1)
                                                                        {
                                                                                segval.IsSelected=true; 
                                                                        }
                                                                        else
                                                                        {
                                                                                // if (secondJourneyKey === segval.journeyKey) {
                                                                                //         segval.IsSelected=true;
                                                                                // } else {
                                                                                //      segval.IsSelected=false;
                                                                                // }
                                                                                if (sameJourneySegments || i=== 0) {
                                                                                        segval.IsSelected=true;
                                                                                } else {
                                                                                        segval.IsSelected=false;
                                                                                }
                                                                                
                                                                        }                                                                                
                                                                }  
                                                        })
                                                })
                                        }  
                                        
                                        if(IsPassengerCheckedIn)
                                        {
                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTCHECKEDIN"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTCHECKEDIN"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTCHECKEDIN"; 
                                                                }
                                                        }
                                                        
                                                }
                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTCHECKEDIN";
                                                                }   
                                                        }
                                                }
                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTCHECKEDIN";
                                                                }  
                                                        }
                                                }
                                                // IsCheckedIn= "CHECKEDIN";   
                                        }
                                        else if(IsPassengerBoarded)
                                        {
                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTBOARDED"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTBOARDED"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTBOARDED"; 
                                                                } 
                                                        }
                                                        
                                                }
                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTBOARDED";
                                                                } 
                                                        }
                                                }
                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTBOARDED";
                                                                }  
                                                        }
                                                }
                                                // IsCheckedIn= "BOARDED"; 
                                        }
                                        else if(IsPassengerNotCheckedIn)
                                        {
                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                        
                                                        if(val.hasInfant) 
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTDEFAULT"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant) 
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTDEFAULT";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTDEFAULT"; 
                                                                }
                                                        }
                                                        
                                                }
                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTDEFAULT";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTDEFAULT";
                                                                } 
                                                        }
                                                }
                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTDEFAULT";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTDEFAULT";
                                                                }         
                                                        }
                                                }
                                                // IsCheckedIn= "DEFAULT"; 
                                        }
                                        if((IsPassengerCheckedIn && IsPassengerBoarded)||(IsPassengerCheckedIn && IsPassengerNotCheckedIn))
                                        {
                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTPARTIAL"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTPARTIAL"; 
                                                                }  
                                                        }
                                                        
                                                }
                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTPARTIAL";
                                                                } 
                                                        }
                                                }
                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTPARTIAL";
                                                                }  
                                                        }
                                                }
                                                // IsCheckedIn= "PARTIAL"; 
                                        }
                                        if(IsPassengerBoarded  && IsPassengerNotCheckedIn )
                                        {
                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTPARTIAL"; 
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTPARTIAL"; 
                                                                }   
                                                        }
                                                        
                                                }
                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                        
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTPARTIAL";
                                                        }

                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTPARTIAL";
                                                                }
                                                        }
                                                }
                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTPARTIAL";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTPARTIAL";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTPARTIAL";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTPARTIAL";
                                                                }   
                                                        }
                                                }
                                                // IsCheckedIn= "PARTIAL"; 
                                        }
                                            
                                }
                                break;
                        // }
                }
        })



        let count = 0;
        segments.forEach((seg, i) => {
                if (seg.IsAlreadyChecked) {
                        count = count + 1;
                }
        })
        
        if (count != segments.length && count > 0) {
                segments.forEach((seg, i) => {
                        if (seg.IsAlreadyChecked) { //secondJourneyKey === seg.journeyKey &&
                                seg.IsSelected = true;
                        } else {
                                seg.IsSelected = false;
                        }
                })
        }
        
        // console.log('segments', segments);
        if (arr.some(p => p.IsSelected)) {
                segments.forEach((seg, i , segarr) => {
                        if (seg.IsSelected && seg.origin !== Location) { //&& new Date(seg.departureTime) < new Date()
                                seg.IsSelected = false;
                                // seg.IsAlreadyChecked = false;
                        }
                        if (segarr.length > 1) {
                             if(!seg.IsSelected && seg.origin === Location) {
                                     seg.IsSelected = true;
                                //      seg.IsAlreadyChecked = true;
                             }
                        }
                });
        }
        

        flightInfoCollection.push({
                "passengers": arr,
                "segments": segments,
                "IsCheckedIn":IsCheckedIn
        })
}

export function fncIconsUpdateOnPassengerSelect(CheckedPassengerKey, stSearchedFlightDetails) {
        
        var IsPassengerCheckedIn =false;
        var IsPassengerNotCheckedIn = false;
        var IsPassengerBoarded= false;
        CheckedPassengerKey.forEach(cp => {
                cp.passengerData.forEach(pd => {
                        // const segSelectedAndCheckedin = pd.segments.filter(seg => seg.IsSelected && seg.IsAlreadyChecked);
                        // if(segSelectedAndCheckedin.length > 0) {

                                pd.passengers.filter(p => p.IsSelected).forEach(val => {
                                        pd.segments.filter(s => s.IsSelected).forEach(s => {
                                                let count = 0;
                                                let SODBookingJourney = [];
                                                let SODBookingSegment = [];
                                                if (stSearchedFlightDetails.recordLocator) {
                                                        SODBookingJourney = stSearchedFlightDetails.journeys.filter(j => j.journeyKey === s.journeyKey);
                                                        SODBookingSegment = SODBookingJourney.length && SODBookingJourney[0].segments.filter(sj => sj.segmentKey === s.segmentKey);
                                                }
                                                
                                                const passeg = s.passengerSegments.find(pseg => pseg.passengerKey === val.passengerKey);
                                                if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase()))) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTCHECKEDIN";
                                                                }
                                                        }
                                                        s.IsAlreadyChecked = true;                                                
                                                        IsPassengerCheckedIn=true;
                                                        count++;
                                                }
                                                else if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey  && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase()))) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTCHECKEDIN";
                                                                }  
                                                        }
                                                        s.IsAlreadyChecked = true;                                                
                                                        IsPassengerCheckedIn=true;
                                                        count++;;
                                                }
                                                else if (passeg.liftStatus === 1 && passeg.passengerKey === val.passengerKey && val.title && val.title.toUpperCase()==="CHD".toUpperCase() ) {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTCHECKEDIN";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTCHECKEDIN";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTCHECKEDIN";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTCHECKEDIN";
                                                                }   
                                                        }
                                                        s.IsAlreadyChecked = true;                                                
                                                        IsPassengerCheckedIn=true;
                                                        count++;;
                                                }
                                                //--------------------------------------------- For Boarded cases -----------------------
                                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase())))
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTBOARDED";
                                                                }  
                                                        }
                                                        // IsCheckedIn= "BOARDED";
                                                        IsPassengerBoarded=true;
                                                        count++;
                                                } 
                                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase())))
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTBOARDED";
                                                                }  
                                                        }
                                                        // IsCheckedIn= "BOARDED";
                                                        IsPassengerBoarded=true;
                                                        count++;
                                                }
                                                
                                                else  if (passeg.liftStatus === 2 && passeg.passengerKey === val.passengerKey && (val.title && val.title.toUpperCase()==="CHD".toUpperCase()))
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTBOARDED";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTBOARDED";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTBOARDED";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTBOARDED";
                                                                } 
                                                        }
                                                        // IsCheckedIn= "BOARDED";
                                                        IsPassengerBoarded=true;
                                                        count++;
                                                }         
                                                //--------------------------------------------  For Default cases ------------------------ 
                                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="MR".toUpperCase() || val.title.toUpperCase()==="Master".toUpperCase() || val.title.toUpperCase()==="MSTR".toUpperCase())))
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "MALEWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTDEFAULT";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTDEFAULT";
                                                                } 
                                                        }
                                                        // IsCheckedIn= "DEFAULT";
                                                        IsPassengerNotCheckedIn=true;
                                                        count++;
                                                }
                                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey && (val.title && (val.title.toUpperCase()==="Miss".toUpperCase() || val.title.toUpperCase()==="Mrs".toUpperCase() || val.title.toUpperCase()==="Ms".toUpperCase())))
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "FEMALEWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "ELTFEMALEWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTDEFAULT";
                                                        }
                                                        }
                                                        // IsCheckedIn= "DEFAULT";
                                                        IsPassengerNotCheckedIn=true;
                                                        count++;
                                                }
                                                else  if (passeg.liftStatus === 0 && passeg.passengerKey === val.passengerKey  && val.title && val.title.toUpperCase()==="CHD".toUpperCase())
                                                {
                                                        if(val.hasInfant)
                                                        {
                                                                val.IsCheckedIn= "CHILDWITHINFANTDEFAULT";
                                                        }
                                                        else{
                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTDEFAULT";
                                                        }
                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                if(val.hasInfant)
                                                                {
                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTDEFAULT";
                                                                }
                                                                else{
                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTDEFAULT";
                                                                }  
                                                        }
                                                        // IsCheckedIn= "DEFAULT";
                                                        IsPassengerNotCheckedIn=true;
                                                        count++;
                                                }
                                                else if (passeg.liftStatus === 3) {
                                                        val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT";
                                                        // IsPassengerNotCheckedIn=true;
                                                        count++;
                                                }
                                                //--------------------------------------------  For Partial CheckedIn cases ------------------------ 
                
                                                if(count==2)
                                                {        
                                                        if(IsPassengerCheckedIn)
                                                        {
                                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "MALEWITHINFANTCHECKEDIN";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "MALEWITHOUTINFANTCHECKEDIN"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTCHECKEDIN"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTCHECKEDIN";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTCHECKEDIN"; 
                                                                                }
                                                                        }
                                                                        
                                                                }
                                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "FEMALEWITHINFANTCHECKEDIN";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTCHECKEDIN";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTCHECKEDIN";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTCHECKEDIN";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTCHECKEDIN";
                                                                                }
                                                                        }
                                                                }
                                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "CHILDWITHINFANTCHECKEDIN";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTCHECKEDIN";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTCHECKEDIN";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTCHECKEDIN";
                                                                                }
                                                                        }
                                                                }
                                                                // IsCheckedIn= "CHECKEDIN";   
                                                        }
                                                        else if(IsPassengerBoarded)
                                                        {
                                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "MALEWITHINFANTBOARDED";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "MALEWITHOUTINFANTBOARDED"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTBOARDED"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTBOARDED";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTBOARDED"; 
                                                                                }
                                                                        }
                                                                        
                                                                }
                                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "FEMALEWITHINFANTBOARDED";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTBOARDED";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTBOARDED";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTBOARDED";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTBOARDED";
                                                                                }
                                                                        }
                                                                }
                                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "CHILDWITHINFANTBOARDED";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTBOARDED";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTBOARDED";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTBOARDED";
                                                                                }
                                                                        }
                                                                }
                                                                // IsCheckedIn= "BOARDED"; 
                                                        }
                                                        else if(IsPassengerNotCheckedIn)
                                                        {
                                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                                        if(val.hasInfant) 
                                                                        {
                                                                                val.IsCheckedIn= "MALEWITHINFANTDEFAULT";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "MALEWITHOUTINFANTDEFAULT"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTDEFAULT"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant) 
                                                                                {
                                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTDEFAULT";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTDEFAULT"; 
                                                                                }
                                                                        }
                                                                        
                                                                }
                                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "FEMALEWITHINFANTDEFAULT";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTDEFAULT";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTDEFAULT";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTDEFAULT";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTDEFAULT";
                                                                                }
                                                                        }
                                                                }
                                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "CHILDWITHINFANTDEFAULT";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTDEFAULT";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTDEFAULT";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTDEFAULT";
                                                                                }
                                                                        }
                                                                }
                                                                // IsCheckedIn= "DEFAULT"; 
                                                        }
                                                        if((IsPassengerCheckedIn && IsPassengerBoarded)||(IsPassengerCheckedIn && IsPassengerNotCheckedIn))
                                                        {
                                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "MALEWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "MALEWITHOUTINFANTPARTIAL"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTPARTIAL"; 
                                                                                }
                                                                        }
                                                                        
                                                                }
                                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "FEMALEWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTPARTIAL";
                                                                                }
                                                                        }
                                                                }
                                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "CHILDWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTPARTIAL";
                                                                                }
                                                                        }
                                                                }
                                                                // IsCheckedIn= "PARTIAL"; 
                                                        }
                                                        if(IsPassengerBoarded  && IsPassengerNotCheckedIn )
                                                        {
                                                                if (val.title && (val.title.toUpperCase()=="MR".toUpperCase() || val.title.toUpperCase()=="Master".toUpperCase() || val.title.toUpperCase()=="MSTR".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "MALEWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "MALEWITHOUTINFANTPARTIAL"; 
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTMALEWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTMALEWITHOUTINFANTPARTIAL"; 
                                                                                }
                                                                        }
                                                                        
                                                                }
                                                                else if (val.title && (val.title.toUpperCase()=="Miss".toUpperCase() || val.title.toUpperCase()=="Mrs".toUpperCase() || val.title.toUpperCase()=="Ms".toUpperCase())) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "FEMALEWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "FEMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === 'ZD') {
                                                                                val.IsCheckedIn= "SODFEMALEWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTFEMALEWITHOUTINFANTPARTIAL";
                                                                                }
                                                                        }
                                                                }
                                                                else if (val.title && val.title.toUpperCase()=="CHD".toUpperCase() ) {
                                                                        if(val.hasInfant)
                                                                        {
                                                                                val.IsCheckedIn= "CHILDWITHINFANTPARTIAL";
                                                                        }
                                                                        else{
                                                                                val.IsCheckedIn= "CHILDWITHOUTINFANTPARTIAL";
                                                                        }
                                                                        if (SODBookingSegment.length && SODBookingSegment[0].classOfService === 'Z' && SODBookingSegment[0].productClass === '') {
                                                                                if(val.hasInfant)
                                                                                {
                                                                                        val.IsCheckedIn= "ELTCHILDWITHINFANTPARTIAL";
                                                                                }
                                                                                else{
                                                                                        val.IsCheckedIn= "ELTCHILDWITHOUTINFANTPARTIAL";
                                                                                }
                                                                        }
                                                                }
                                                                // IsCheckedIn= "PARTIAL"; 
                                                        }
                                                            
                                                }
                                        }) 
                                })
                        // }
                })
        })
}

export function cryptoEncryption(dataToEncrypt) {
        return CryptoJS.AES.encrypt(JSON.stringify(dataToEncrypt), secretKeyForCrypto).toString();    
}

export function cryptoDecryption(dataToDecryppt) {
        const bytes  = CryptoJS.AES.decrypt(dataToDecryppt, secretKeyForCrypto);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); 
}

export function pageNavigationForBoardingModule(page) {
        let returnUrl;
        switch (page) {
                case 'FlightSearch':
                        returnUrl = 'Overview';
                        break;
                case 'Overview':
                        returnUrl = 'Manifest';
                        break;
                default:
                        returnUrl = 'FlightSearch';
        }
        return returnUrl;
}

export const mapToProp = (data, prop) => {
        return data.reduce((res, item) =>
        Object.assign(res, {
            [item[prop]]: 1 + (res[item[prop]] || 0)
        }), Object.create(null));
}

export const getSegmentsDetail = (market, property, passengerData) => {
        const flightNo  = market.identifier.identifier;
        const { segments } = passengerData.services[0];
        const { origin, destination } = market;
        const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
        const leg = currentSegment.legs.filter(leg => (leg.market.origin === origin && leg.market.destination === destination));
        if (property === 'bagscount') {
            return leg[0].bags.length;
        }
        if (property === 'boardingSequence') {
                return leg[0].boardingSequence === 0 ? '' : leg[0].boardingSequence;
        }
        if (property === 'seat') {
            return leg[0].unitDesignator ? leg[0].unitDesignator : '';
        }
        if (property === 'liftStatus') {
            return leg[0].liftStatus;
        }
        if (property === 'classOfService') {
            return currentSegment.classOfService;
        }
        if (property === 'productClassCode') {
            return currentSegment.productClassCode;
        }
        if (property === 'ssrsCount') {
            return leg[0].ssrs.length;
        }
        if (property === 'ssrs') {
            let ssrs = (leg[0].ssrs==null || leg[0].ssrs.length === 0) ?"": leg[0].ssrs.map((ssr,j) =>ssr.ssrCode+" "); 
            return ssrs.toString();
        }
        if (property === 'baggages') {
            let baggages = (leg[0].bags==null || leg[0].bags.length === 0) ?"": leg[0].bags.filter(b => b.baggageStatus == 1).map((bag,j) => bag.osTag+" "); 
            return baggages.toString();
        }
        if (property === 'ssrsArray') {
                let ssrs = leg[0].ssrs;
                return ssrs;
        }
}

export const getIconForPassenger = (passenger, flightManifest) => {
        let icon = 'newImages/manifest-user.svg';
        if (getSegmentsDetail(flightManifest.market,'liftStatus', passenger) === 1) {
            if (passenger.name.title
                && (passenger.name.title.toUpperCase() === 'MR'.toUpperCase()
                || passenger.name.title.toUpperCase() === 'Master'.toUpperCase()
                || passenger.name.title.toUpperCase() === 'MSTR'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['MALEWITHINFANTCHECKEDIN'];
                } else {
                    icon = searchPageIconsMapping['MALEWITHOUTINFANTCHECKEDIN'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODMALEWITHOUTINFANTCHECKEDIN'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTMALEWITHINFANTCHECKEDIN'];
                    } else{
                        icon = searchPageIconsMapping['ELTMALEWITHOUTINFANTCHECKEDIN'];
                    }  
                }
            }
            if (passenger.name.title && (passenger.name.title.toUpperCase() === 'Ms'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Mrs'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Miss'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['FEMALEWITHINFANTCHECKEDIN'];
                } else {
                    icon = searchPageIconsMapping['FEMALEWITHOUTINFANTCHECKEDIN'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODFEMALEWITHOUTINFANTCHECKEDIN'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTFEMALEWITHINFANTCHECKEDIN'];
                    } else{
                        icon = searchPageIconsMapping['ELTFEMALEWITHOUTINFANTCHECKEDIN'];
                    }  
                }
            }
            if (passenger.name.title && passenger.name.title.toUpperCase() === 'CHD'.toUpperCase()) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['CHILDWITHINFANTCHECKEDIN'];
                } else {
                    icon = searchPageIconsMapping['CHILDWITHOUTINFANTCHECKEDIN'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTCHILDWITHINFANTCHECKEDIN'];
                    } else{
                        icon = searchPageIconsMapping['ELTCHILDWITHOUTINFANTCHECKEDIN'];
                    }  
                }
            }
        } else if (getSegmentsDetail(flightManifest.market,'liftStatus', passenger) === 2) {
            if (passenger.name.title && (passenger.name.title.toUpperCase() === 'MR'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Master'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'MSTR'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['MALEWITHINFANTBOARDED'];
                } else {
                    icon = searchPageIconsMapping['MALEWITHOUTINFANTBOARDED'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODMALEWITHOUTINFANTBOARDED'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTMALEWITHINFANTBOARDED'];
                    } else{
                        icon = searchPageIconsMapping['ELTMALEWITHOUTINFANTBOARDED'];
                    }
                }
            }
            if (passenger.name.title && (passenger.name.title.toUpperCase() === 'Ms'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Mrs'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Miss'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['FEMALEWITHINFANTBOARDED'];
                } else {
                    icon = searchPageIconsMapping['FEMALEWITHOUTINFANTBOARDED'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODFEMALEWITHOUTINFANTBOARDED'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTFEMALEWITHINFANTBOARDED'];
                    } else{
                        icon = searchPageIconsMapping['ELTFEMALEWITHOUTINFANTBOARDED'];
                    }  
                }
            }
            if (passenger.name.title && passenger.name.title.toUpperCase() === 'CHD'.toUpperCase()) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['CHILDWITHINFANTBOARDED'];
                } else {
                    icon = searchPageIconsMapping['CHILDWITHOUTINFANTBOARDED'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTCHILDWITHINFANTBOARDED'];
                    } else{
                        icon = searchPageIconsMapping['ELTCHILDWITHOUTINFANTBOARDED'];
                    }  
                }
            }
        } else if (getSegmentsDetail(flightManifest.market,'liftStatus', passenger) === 0) {
            if (passenger.name.title && (passenger.name.title.toUpperCase() === 'MR'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Master'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'MSTR'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['MALEWITHINFANTDEFAULT'];
                } else {
                    icon = searchPageIconsMapping['MALEWITHOUTINFANTDEFAULT'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODMALEWITHOUTINFANTDEFAULT'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTMALEWITHINFANTDEFAULT'];
                    } else{
                        icon = searchPageIconsMapping['ELTMALEWITHOUTINFANTDEFAULT'];
                    }
                }
            }
            if (passenger.name.title && (passenger.name.title.toUpperCase() === 'Ms'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Mrs'.toUpperCase()
            || passenger.name.title.toUpperCase() === 'Miss'.toUpperCase())) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['FEMALEWITHINFANTDEFAULT'];
                } else {
                    icon = searchPageIconsMapping['FEMALEWITHOUTINFANTDEFAULT'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === 'ZD') {
                    icon = searchPageIconsMapping['SODFEMALEWITHOUTINFANTDEFAULT'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTFEMALEWITHINFANTDEFAULT'];
                    } else{
                        icon = searchPageIconsMapping['ELTFEMALEWITHOUTINFANTDEFAULT'];
                    }  
                }
            }
            if (passenger.name.title && passenger.name.title.toUpperCase() === 'CHD'.toUpperCase()) {
                if (passenger.infant) {
                    icon = searchPageIconsMapping['CHILDWITHINFANTDEFAULT'];
                } else {
                    icon = searchPageIconsMapping['CHILDWITHOUTINFANTDEFAULT'];
                }
                if (getSegmentsDetail(flightManifest.market,'classOfService', passenger) === 'Z' && getSegmentsDetail(flightManifest.market,'productClassCode', passenger) === '') {
                    if (passenger.infant) {
                        icon = searchPageIconsMapping['ELTCHILDWITHINFANTDEFAULT'];
                    } else{
                        icon = searchPageIconsMapping['ELTCHILDWITHOUTINFANTDEFAULT'];
                    }  
                }
            }
        } else { //getSegmentsDetail(flightManifest.market.identifier.identifier,'liftStatus', passenger) === 3
            icon = searchPageIconsMapping['MALEWITHOUTINFANTDEFAULT'];
        }
        return icon;
}

export function shortcutKeyForBoardingsPage(page, event) {
        let returnUrl;
        event.preventDefault();
        switch (event.key) {
                case 'F2':
                        returnUrl = 'FlightSearch';
                        break;
                case 'F3':
                        returnUrl = 'Overview';
                        break;
                case 'F4':
                        returnUrl = 'Manifest';
                        break;
                case 'F5':
                        returnUrl = 'Boarding';
                        break;
                case 'F6':
                        returnUrl = 'SeatManagement';
                        break;
                // case 'o':
                //         returnUrl = event.ctrlKey ? 'PassengerInformation' : null;
                //         break;
                // case 'p':
                //         returnUrl = event.ctrlKey ? 'PnrHistory' : null;
                //         break;
                // case 'c':
                //         returnUrl = event.ctrlKey ? 'Comments' : null;
                //         break;
                default:
                        // returnUrl = 'FlightSearch';
                        break;
        }

        return returnUrl;
}

export const isInternationalFlight = (SearchedFlightDetails, sfd = true) => {
        
        let journeys;
        if (sfd) {
                journeys = SearchedFlightDetails.journeys && SearchedFlightDetails.journeys.length ? SearchedFlightDetails.journeys: [];
        } else {
                journeys = SearchedFlightDetails && SearchedFlightDetails.length ? SearchedFlightDetails : [];
        }
        if (journeys.length) {
                for(let i = 0; i < journeys.length; i++) {
                        if (journeys[i].segments.some(seg => seg.IsSelected)) {
                                const selectedSeg = journeys[i].segments.filter(seg => seg.IsSelected);
                                // console.log('selectedSeg', selectedSeg)
                                if (selectedSeg.length && selectedSeg.some(s => s.international)) {
                                  return false;
                                } else {
                                        return true;
                                }
                        }     
                }
        } else {
                return true;
        }
}

export const isInternationalSeg = (SearchedFlightDetails, segKey) => {
        const journeys = SearchedFlightDetails.journeys && SearchedFlightDetails.journeys.length ? SearchedFlightDetails.journeys: [];
        if (journeys.length) {
                for(let i = 0; i < journeys.length; i++) {
                        if (journeys[i].segments.some(seg => seg.IsSelected)) {
                                const selectedSeg = journeys[i].segments.filter(seg => seg.IsSelected && seg.segmentKey === segKey);
                                // console.log('selectedSeg', selectedSeg)
                                if (selectedSeg.length && selectedSeg.some(s => s.international)) {
                                  return true;
                                } else {
                                        return false;
                                }
                        }     
                }
        } else {
                return false;
        }
}

export const isInternationalPNR = (SearchedFlightDetails) => {
        const journeys = SearchedFlightDetails.journeys && SearchedFlightDetails.journeys.length ? SearchedFlightDetails.journeys: [];
        if (journeys.length) {
                for(let i = 0; i < journeys.length; i++) {
                        if (journeys[i].segments.some(seg => seg.IsSelected)) {
                                const selectedSeg = journeys[i].segments.filter(seg => seg.IsSelected);
                                // console.log('selectedSeg', selectedSeg)
                                if (selectedSeg.length && selectedSeg.some(s => s.international)) {
                                  return true;
                                } else {
                                        return false;
                                }
                        }     
                }
        } else {
                return false;
        }
}

export const checkPassengerStatus = (SearchedFlightDetails, SearchedSelectedPassengerData, pax, infant = false) => {
        let status = false;
        SearchedFlightDetails.journeys.forEach((jou, j) =>
            jou.segments.forEach((seg, i) => {
                if (seg.segmentKey === SearchedSelectedPassengerData.SelectedSegmentKey[0]) {
                    seg.passengerSegment.forEach((paxseg, loop) => {
                    if (paxseg.passengerKey === pax.passengerKey) {
                        status = pax.IsSelected && paxseg.IsSelected && (paxseg.liftStatus === "CheckedIn" || paxseg.liftStatus === "Boarded") ? true : false;
                    }
                })
                    
                } 
            })
        )
        return status;
}

export const haveTravelDocs = (SearchedFlightDetails) => {
        const selectedPassengers = SearchedFlightDetails.passenger.filter(p => p.IsSelected);
        const havetd = selectedPassengers.some(item => item.traveldocuments.length);
        return havetd;
}

export const getBagtagPrintData = (AddBags, selectedJourney, lrtBagType) => {
        let BagsTagToPrint = AddBags.filter(pax => pax.IsSelected);
        let a = '';
        // const selectedJourney = SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length);
        BagsTagToPrint.forEach((passenger) => {
                passenger.bags.filter(bag => bag.IsSelected).forEach((paxBag) => {
                
                        let segIndexToShow =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier === paxBag.identifier));
                        let segIndexToShowSeq =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier !== paxBag.identifier));
                        let flightName = selectedJourney[0][segIndexToShow];
                        paxBag.origin = selectedJourney[0][0].designator.origin;
                        paxBag.flightnumberAtTop = `${flightName.identifier.carrierCode} ${flightName.identifier.identifier}`;
                        paxBag.destAtTop = flightName.designator.destination;
                        if (lrtBagType && lrtBagType[passenger.passengerKey] && lrtBagType[passenger.passengerKey].find(b => b.bagWeight === paxBag.weight)) {

                                paxBag.isLrt = true;
                        } else {
                                paxBag.isLrt = false;
                        }
                        paxBag.seqAtTop = selectedJourney[0][segIndexToShowSeq].passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence;
                        let psegForOsTagUnderBarCode = flightName.passengerSegment.filter(pseg => pseg.IsSelected && pseg.passengerKey === passenger.passengerKey)[0];
                        let psegBagForOsTagUnderBarCode = psegForOsTagUnderBarCode.bags.filter(psegBag => psegBag.baggageKey === paxBag.baggageKey)[0].osTag;
                        paxBag.osTagUnderBarCode = psegBagForOsTagUnderBarCode;
                        paxBag.table = [];
                        if (segIndexToShow === 0) {
                                const segmentForTable = selectedJourney[0][segIndexToShow];
                                const bagTagDetailObject = {
                                taggedToStation: segmentForTable.designator.destination,
                                flightNumber: `${segmentForTable.identifier.carrierCode} ${segmentForTable.identifier.identifier}`,
                                depDate: moment(segmentForTable.designator.departure).format("D MMM, YYYY"),
                                seqNo: segmentForTable.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                                }
                                paxBag.table.push(bagTagDetailObject);
                        } else {
                                const segmentsForTable = selectedJourney[0];
                                segmentsForTable.forEach((seg) => {
                                const bagTagDetailObject = {
                                        taggedToStation: seg.designator.destination,
                                        flightNumber: `${seg.identifier.carrierCode} ${seg.identifier.identifier}`,
                                        depDate: moment(seg.designator.departure).format("D MMM, YYYY"),
                                        seqNo: seg.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                                }
                                paxBag.table.push(bagTagDetailObject);
                                })
                        }
                        paxBag.table.forEach((trow, index, array) => {
                                a = array.length > 1 && index === 0 ? '' : trow.taggedToStation
                        })
                })
        });
        return {BagsTagToPrint, a};
}

export const fncCheckIfTokenIsExpired = (errorDetail) => {
        let tokenStatus = false;
        if (errorDetail.errorCode == 500 && errorDetail.errorMessage === 'The provided token has timed out.') {
                tokenStatus = true;
        }
        return tokenStatus;
}

export function fncFocusElementDependsOnPathLocation(pathname, elementRef) {
        console.log("Current Path:", pathname);
        
        const focusablePaths = new Set(["/Search", "/Seat", "/Bags", "/Service", "/Payment", "/Finalize", "/FlightSearch", "/Overview", "/Manifest", "/Boarding", "/SeatManagement", "/Notification"]);
    
        if (focusablePaths.has(pathname)) {
                elementRef?.focus();
        }
    }
export const fncCheckSearchedFlightDetailsEmpty = (SearchedFlightDetails) => {
        return SearchedFlightDetails && typeof SearchedFlightDetails === "object" && Object.keys(SearchedFlightDetails).length === 0;
}

export const findMatchingFlight = (data, paxdata)  => {
        debugger
        return data.find(flight => {
            // Trim and concatenate MarketingCarrierCode and MarketingFlightNumber
            const flightCode = flight.MarketingCarrierCode.trim() + flight.MarketingFlightNumber.trim();
            
            // Convert departureDate and schedule dates to comparable formats
            const departureDate = new Date(paxdata.departureDate);
            const scheduleStartDate = new Date(flight.ScheduleBeginDate);
            const scheduleEndDate = new Date(flight.ScheduleEndDate);
    
            // Check conditions
            return (
                flightCode === paxdata.flight &&
                flight.Origin === paxdata.fromStationCode &&
                flight.Destination === paxdata.toStationCode &&
                departureDate >= scheduleStartDate &&
                departureDate <= scheduleEndDate
            );
        });
}

export const checkIfFlybigFlight = (flyBigData, paxData) => {
        // console.log('checkIfFlybigFlight', flyBigData, paxData);
        // Call the function with data and paxdata
        debugger
        const result = findMatchingFlight(flyBigData, paxData);
        
        console.log('result',result);
        if (result === undefined) {
                return false
        } else {
                return result;
        }
}

export const isValidObject = (obj) => {
        // Check if object is null or undefined
        if (obj === null || obj === undefined) {
            return false;
        }
        
        // Check if object is empty (has no properties)
        if (typeof obj === 'object' && Object.keys(obj).length === 0) {
            return false;
        }
        
        return true;
}

export const extractBagsFromPassengers = (bookingObj) => {
        let allBags = [];
        
        try {
            // Validate the booking object
            if (!isValidObject(bookingObj)) {
                console.error("Booking object is null or empty");
                return allBags;
            }
            
            // Check if passenger property exists and is an array
            if (!bookingObj.passenger || !Array.isArray(bookingObj.passenger)) {
                console.error("Passenger property is missing or not an array");
                return allBags;
            }
            
            // Loop through each passenger
            bookingObj.passenger.forEach((passenger, index) => {
                if (passenger && passenger.bags && Array.isArray(passenger.bags)) {
                    // Add passenger index for reference and spread the bags
                    passenger.bags.forEach(bag => {
                        allBags.push({
                            passengerIndex: index,
                            passengerKey: passenger.passengerKey,
                            passengerName: passenger.name,
                            ...bag
                        });
                    });
                    
                    console.log(`Found ${passenger.bags.length} bag(s) for passenger ${index + 1}`);
                } else {
                    console.log(`No bags found for passenger ${index + 1}`);
                }
            });
            
            console.log(`Total bags extracted: ${allBags.length}`);
            
        } catch (error) {
            console.error("Error while extracting bags:", error.message);
        }
        
        return allBags;
}

// Function to remove similar bags from AddBags object
export const removeSimilarBags = (newAddBagData, initialBagData) => {
        // Create a Set of baggageKeys from initialBagData for efficient lookup
        const initialBagKeys = new Set(initialBagData.map(bag => bag.baggageKey));
        
        // Process each passenger in the array
        const updatedPassengers = newAddBagData.map(passenger => {
            // Filter out bags that exist in initialBagData
            const filteredBags = passenger.bags.filter(bag => {
                return !initialBagKeys.has(bag.baggageKey);
            });
            
            // Return passenger object with updated bags array
            return {
                ...passenger,
                bags: filteredBags
            };
        });
        
        return updatedPassengers;
}

// Function to compare and log the differences
export const compareBags = (originalBags, filteredBags, initialBags) => {
        console.log('=== BAG COMPARISON RESULTS ===');
        console.log(`Original bags count: ${originalBags.length}`);
        console.log(`Initial bags count: ${initialBags.length}`);
        console.log(`Filtered bags count: ${filteredBags.length}`);
        console.log(`Bags removed: ${originalBags.length - filteredBags.length}`);
        
        // Show which bags were removed
        const removedBags = originalBags.filter(bag => 
            !filteredBags.some(filteredBag => filteredBag.baggageKey === bag.baggageKey)
        );
        
        console.log('\n=== REMOVED BAGS ===');
        removedBags.forEach((bag, index) => {
            console.log(`${index + 1}. OS Tag: ${bag.osTag}, Weight: ${bag.weight}kg, Date: ${bag.osTagDate}`);
        });
        
        console.log('\n=== REMAINING BAGS ===');
        filteredBags.forEach((bag, index) => {
            console.log(`${index + 1}. OS Tag: ${bag.osTag}, Weight: ${bag.weight}kg, Date: ${bag.osTagDate}`);
        });
}

export const isValidEmail = (email = '') => {
        if (typeof email !== 'string') return false;
        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return emailReg.test(email.trim());
};

export const isValidIndianPhone = (phone = '') => {
        if (typeof phone !== 'string') return false;
        const numeric = phone.replace(/[^0-9]/g, '');
        const indianMobileRegex = /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
        return indianMobileRegex.test(numeric);
};

export const sanitizePhone = (phone = '') => {
        return phone.replace(/[^\d]/g, '').slice(-10); // keep only last 10 digits
};

export const getSSRForBP = (seg) => {
  let ssrs = seg.legs[0].ssrs==null?"": seg.legs[0].ssrs.map((ssr,j) =>ssr.ssrCode+" "
  );
  if (seg.hasInfant) {
    ssrs = ssrs + " INFT" 
  }    
  return ssrs;                                                                                                   
}

export const getFlightTimingsForTscPrinter = (SearchedFlightDetails, seg) => {
  let departTime = " "+("0"+new Date(seg.designator.departure).getHours()).slice(-2)+":"+("0"+new Date(seg.designator.departure).getMinutes()).slice(-2);
  let arrivalTime = "-"+("0"+new Date(seg.designator.arrival).getHours()).slice(-2)+":"+("0"+new Date(seg.designator.arrival).getMinutes()).slice(-2)+" hrs";

  SearchedFlightDetails.journeys.forEach((jou, j) =>
    jou.segments.forEach((segment, i) => {
      if (seg.identifier.identifier === segment.identifier.identifier) {
        if (segment.legs.length > 1) {
          departTime = " "+("0"+new Date(segment.designator.departure).getHours()).slice(-2)+":"+("0"+new Date(segment.designator.departure).getMinutes()).slice(-2);
          arrivalTime = "-"+("0"+new Date(segment.designator.arrival).getHours()).slice(-2)+":"+("0"+new Date(segment.designator.arrival).getMinutes()).slice(-2)+" hrs";
        }
        if (segment.legs[0].operationsInfo && segment.legs[0].operationsInfo.departureTimes && segment.legs[0].operationsInfo.departureTimes.estimated) {
          departTime = " "+("0"+new Date(segment.legs[0].operationsInfo.departureTimes.estimated).getHours()).slice(-2)+":"+("0"+new Date(segment.legs[0].operationsInfo.departureTimes.estimated).getMinutes()).slice(-2);
        }
        if (segment.legs[0].operationsInfo && segment.legs[0].operationsInfo.estimatedArrivalTime) {
          arrivalTime = "-"+("0"+new Date(segment.legs[0].operationsInfo.estimatedArrivalTime).getHours()).slice(-2)+":"+("0"+new Date(segment.legs[0].operationsInfo.estimatedArrivalTime).getMinutes()).slice(-2)+" hrs";
        }
      }
    })
  )
  return departTime + arrivalTime;
}

export const getBaggageWeights = (SearchedFlightDetails, bp) => {
  const { passenger } = bp;
  const pax = SearchedFlightDetails.passenger.filter( p =>
    p.name.first === passenger.name.first &&
    p.name.last === passenger.name.last &&
    p.name.title === passenger.name.title);
  if (pax && pax.length) {
    return fncBagCount(SearchedFlightDetails, pax[0].passengerKey);
  } else {
    return '';
  }
}

export const getZPLCommandForBoardingPass = (SearchedFlightDetails, bp, item, seg) => {
        const ticketNumber = SearchedFlightDetails.locators.recordLocators[0].recordCode;
        let customerName = bp.passenger.name.title
          ?
          `${bp.passenger.name.title} . ${bp.passenger.name.last} ${bp.passenger.name.first}`
          :
          `${bp.passenger.name.last} ${bp.passenger.name.first}`;
          debugger
          customerName = customerName.length > 30 ? customerName.substring(0, 30) : customerName;
          const ssr = getSSRForBP(seg);
          const dateForBP = "  "+("0"+new Date(seg.designator.departure).getDate()).slice(-2)+" "+monthNames[new Date(seg.designator.departure).getMonth()]+" "+new Date(seg.designator.departure).getFullYear();
          const flightTiming = getFlightTimingsForTscPrinter(SearchedFlightDetails, seg);
          const boardingTime = ("0"+new Date(seg.boardingTime).getHours()).slice(-2)                                                         
          +":"+("0"+new Date(seg.boardingTime).getMinutes()).slice(-2) 
          +"hrs";
          const baggageWeight = getBaggageWeights(SearchedFlightDetails, bp);
        return `^XA
        ~SD25
        
        ^FO500,50^GFA,1176,1176,7,7QFC,::::::::::::::::::::7F8OFC,7F83NFC,7F01NFC,:7F80F07KFC,7F80F03KFC,7F80701KFC,7FC0700KFC,7FE0700KFC,7FF0F007JFC,7JF807JFC,7FF1F80703FFC,7FF0FC0E01FFC,7FF07F1E00FFC,7FF038FE007FC,7FF0303E007FC,7FF8301F007FC,7FFC381F007FC,7JF81F807FC,7JFC1C20FFC,7JFE181IFC,7FFC3FF80IFC,7FFC1DFC07FFC,7FFE187C07FFC,7FFE183E07FFC,7IF183F07FFC,7JFC3BJFC,7IFBE30JFC,7IF1FF07IFC,7IF88703IFC,7IF8C783IFC,7JFC3KFC,7JFE63JFC,7IFCCE1JFC,7IFC471JFC,7IFE44KFC,7KFC7JFC,7KFE3JFC,7QFC,7IFE7LFC,7IF07LFC,7FFE07LFC,7FFE0381JFC,7FFE0700JFC,7FFE1F007IFC,7FFE1E003IFC,7FFE1C0C3IFC,7FFE001E3IFC,7IF001E3IFC,7IF80383IFC,7F8FC0703IFC,7F8071F83IFC,7F8007F87IFC,7F8I0F8JFC,7FFJ07JFC,7IFI03JFC,7FFE3803JFC,7FFE3F03JFC,7FFE1FC7JFC,7FFE03C7JFC,7IFI03JFC,7IF8003JFC,7IFE003JFC,7JFC07JFC,7FFE1MFC,7FFE00LFC,7FFE001KFC,7IFI03JFC,7IFEI03IFC,7JFE003IFC,7LF43IFC,7IF01FE3IFC,7FFE003KFC,7FFEI0KFC,7FFEI07JFC,7FFE3E07JFC,7FFE1FC3JFC,7FFE0FC3JFC,7IF07C3JFC,7IF0703JFC,7IFC703JFC,7KF07JFC,7IF8F0KFC,7IF00LFC,7FFE001KFC,7FFEI0KFC,7FFE1007JFC,7FC23807JFC,7F821843JFC,7F020843JFC,7F030843JFC,7F0F8803JFC,7F0FC803JFC,7F07F807JFC,7F80FF1KFC,7FC01MFC,7FEI0LFC,7FF8I0KFC,7IFJ0JFC,7JFI03IFC,7KF003IFC,7IF87F03IFC,7FFE007E3IFC,7FFE001KFC,7FFEI0KFC,7FFE3807JFC,7FFE3803JFC,7FFE1843JFC,7FFE0843JFC,7IF0803JFC,7IF8803JFC,7IFE807JFC,7JFC0KFC,7FFE0FDKFC,7FFE00C7JFC,7FFEI07JFC,7FFEJ0JFC,7FFE1I03IFC,7IF3F003IFC,7KFC03IFC,7KFC73IFC,7KFE7JFC,7QFC,::::3QFC,:::1QFC,::0QFC,:07PFC,03PFC,:01PFC,00PFC,007OFC,001OFC,I07NFC,I01NFC,J03MFC,R04,^FS
        
        ^FWR
        
        ^FO450,50,999^A0,30^FD${customerName}^FS
        ^FO450,550,999^A0,30^FDPNR:^FS
        ^FO450,620,999^A0,30^FD${item.recordLocator}^FS
        ^FO450,850,999^A0,30^FDSeat No.:^FS
        ^FO450,970,999^A0,30^FD${seg.legs[0].seat.designator}^FS
        ^FO370,50,999^A0,30^FDSSR: ${ssr}^FS
        ^FO350,50^GB3,1000,3^FS
        ^FO290,50,999^A0,30^FDDate:^FS
        ^FO290,120,999^A0,30^FD${dateForBP}^FS
        ^FO290,350,999^A0,30^FDFlight:^FS
        ^FO290,435,999^A0,30^FD${seg.identifier.carrierCode+""+seg.identifier.identifier}^FS
        ^FO290,600,999^A0,30^FDFlight Timings:^FS
        ^FO290,800,999^A0,30^FD${flightTiming}^FS
        ^FO210,50,999^A0,30^FDFrom:^FS
        ^FO210,130,999^A0,30^FD${" "+seg.designator.originStationName}^FS
        ^FO210,350,999^A0,30^FDTo:^FS
        ^FO210,400,999^A0,30^FD${" "+seg.designator.destinationStationName}^FS
        ^FO130,50,999^A0,30^FDBoarding  Gate:^FS
        ^FO130,255,999^A0,30^FD${seg.departureGate==null?"Verify":seg.departureGate}^FS
        ^FO130,450,999^A0,30^FDBoarding  Time:^FS
        ^FO130,660,999^A0,30^FD${boardingTime}^FS
        ^FO130,850,999^A0,30^FDSeq No.:^FS
        ^FO130,960,999^A0,30^FD${seg.legs[0].boarding.boardingSequence}^FS
        ^FO50,50,999^A0,30^FDE-Ticket no.:^FS
        ^FO50,225,999^A0,30^FD${ticketNumber}^FS
        ^FO50,350,999^A0,30^FDOperated by:^FS
        ^FO50,510,999^A0,30^FD${seg.transportationName}^FS
        ^FO50,850,999^A0,30^FDBag Pc/Wt:^FS
        ^FO50,990,999^A0,30^FD${baggageWeight}^FS
        ^FO120,1100
        ^BQN,2,8
        ^FDQA,${bp.passenger.barCode}^FS
        
        ^XZ`
}

export const getZPLCommandForDirectBagTag = (item,bt,j, recordLocator, a) => {
        let bagtype = '';
        let name = ''
        name = `${item.name.last}/${item.name.first}`;
        name = name.substring(0, 25);
        if (bt.type === 'LRT') {
          bagtype = `^FWI
          ^LRY
          ^FO155,1850
          ^GB240,70,70^FS
          ^FO185,1860^A0,40^CFG
          ^LRT^FS`;
        } else {
          bagtype = `^FWI
          ^LRY
          ^FO180,1780
          ^GB180,70,70^FS
          ^FO195,1790^A0,40^CFG
          ^FDBaggage^FS
          
          ^FWI
          ^LRY
          ^FO155,1850
          ^GB240,70,70^FS
          ^FO185,1860^A0,40^CFG
          ^FDRegistered^FS`
        }
        return `^XA
        ^FWN
        ^FX Top section with Company Name and user detail
        ^FO90,40^GB380,710,3^FS
        ^FO190,80,999^A0,50^FDSPICEJET^FS
        ^FO120,150,999^A0,30^FD${name}^FS
        ^FO120,190,999^A0,30^FD${recordLocator}^FS
        ^FO120,220,999^A15,25,10^FD${bt.destAtTop}^FS
        ^FO120,250,999^A15,25,10^FDSeq No.: ${bt.seqAtTop}^FS
        ^FO120,280,999^A15,25,10^FD${bt.flightnumberAtTop}^FS
        
        
        ^BY5,2,270
        ^FO150,330^BY2,200,10^BC,150,Y,N,N,A^FD SG ${bt.osTagUnderBarCode}^FS
        
        
        ^FX Second Section will rotate i flight detail
        ^FO90,750^GB380,180,3^FS
        
        ^FWI
        ^LRY
        ^FO300,800
        ^GB160,70,70^FS
        ^FO350,800^A0,50^CFG
        ^FD${bt.table[0].taggedToStation}^FS
        
        ^LRY
        ^FO120,770
        ^GB150,50,50^FS
        ^FO140,775^A0,30^CFG
        ^FDSEQ - ${bt.table[0].seqNo}^FS
        ^FO120,830,999^A0,20^FD${bt.table[0].depDate}^FS
        ^FO120,870,999^A0,30,50^FD${bt.table[0].flightNumber}^FS
        
        ^FWN
        ^FX Third Section will rotate i flight detail
        
        ^FO90,930^GB380,1850,3^FS
        
        ^FO95,935^GB0,150,70,B^FS
        ^FWR
        ^FO120,950^A0,30^CFG
        ^FDSEQ No.:${bt.seqAtTop}^FS
        
        ^FWI
        
        ^FO200,1010^A0I,20,20^FB300,3,0,R^FD
        ${name}
        ^FS
        ^FO200,990^A0I,20,20^FB300,3,0,R^FD
        PNR: ${recordLocator}
        ^FS
        ^FO200,970^A0I,20,20^FB300,3,0,R^FD
        Tag No.: SG   ${bt.osTagUnderBarCode}
        ^FS
        ^FO200,950^A0I,20,20^FB300,3,0,R^FD
        Baggage weight: ${bt.weight} KG
        ^FS
        ^FO200,930^A0I,20,20^FB300,3,0,R^FD
        Total Pieces: ${item.bags.filter(items => items.IsSelected).length}
        ^FS
        ^FO200,910^A0I,20,20^FB300,3,0,R^FD
        Origin: ${bt.origin}
        ^FS
        
        ^FS
        
        ^FWR
        ^FO125,1120
        ^BY2.5,50,10
        ^BC,320,N,N,N,N
        ^FD${bt.osTagUnderBarCode}^FS
        
        ^FS
        ^FWN
        ^FO125,1600
        ^BY2,10,10
        ^BC,140,N,N,N,N
        ^FD${bt.osTagUnderBarCode}
        ^FS
        
        ${bagtype}
        
        ^FS
        ^FWN
        ^FO125,1950
        ^BY2,10,10
        ^BC,140,N,N,N,N
        ^FD${bt.osTagUnderBarCode}
        ^FS
        
        ^FWR
        ^FO125,2150
        ^BY2.5,50,10
        ^BC,320,N,N,N,N
        ^FD${bt.osTagUnderBarCode}^FS
        
        ^FO395,2630^GB0,150,70,B^FS
        ^FWB
        ^FO430,2635^A0,30^CFG
        ^FDSEQ No.:${bt.seqAtTop}^FS
        
        
        ^FWN
        ^FO120,2635^A0,20,20^FD${name}^FS
        ^FO120,2655^A0,20,20^FDPNR: ${recordLocator}^FS
        ^FO120,2675^A0,20,20^FDTAG No.: SG ${bt.osTagUnderBarCode}^FS
        ^FO120,2695^A0,20,20^FDBaggage Weight: ${bt.weight}KG^FS
        ^FO120,2715^A0,20,20^FDTotal Pieces: ${item.bags.filter(items => items.IsSelected).length}^FS
        ^FO120,2735^A0,20,20^FDOrigin: ${bt.origin}^FS
        
        ^FX Fourth Section
        ^FO90,2780^GB380,180,3^FS
        
        ^FWN
        ^LRY
        ^FO120,2830
        ^GB 95,70,70^FS
        ^FO120,2850^A0,50^CFG
        ^FD${bt.table[0].taggedToStation}^FS
        
        ^LRY
        ^FO290,2880
        ^GB150,50,50^FS
        ^FO310,2890^A0,30^CFG
        ^FDSEQ - ${bt.table[0].seqNo}^FS
        ^FO290,2850,999^A0,20^FD${bt.table[0].depDate}^FS
        ^FO290,2800,999^A0,30,50^FD${bt.table[0].flightNumber}^FS
        ^FX Fifth Section
        ^FO90,2960^GB380,800,3^FS
        
        
        ^FO150,3160^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS
        ^FO150,3300^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS
        ^FO150,3420^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS
        
        ^XZ`
      // return btdirectzplCommand;
}
      
export const getTSCPLCommandForDirectBagTag = (item,bt,j, recordLocator, a) => {
let bagtype = '';
let name = ''
name = `${item.name.last}/${item.name.first}`;
name = name.substring(0, 25);
if (bt.type === 'LRT') {
        bagtype = `BAR 67,1802, 281, 62
        ERASE 163,1809,89,60
        TEXT 164,1810,"ROMAN.TTF",0,1,18,"LRT"
        REVERSE 163,1809,89,60`;
} else {
        bagtype = `BAR 36,1784, 327, 122
        ERASE 51,1790,296,60
        TEXT 52,1791,"ROMAN.TTF",0,1,18,"REGISTERED"
        REVERSE 51,1790,296,60
        ERASE 81,1851,236,60
        TEXT 82,1852,"ROMAN.TTF",0,1,18,"BAGGAGE"
        REVERSE 81,1851,236,60`
}
return `SIZE 51.10 mm, 458.1 mm
GAP 3 mm, 0 mm
SPEED 5
DENSITY 10
DIRECTION 0,0
REFERENCE 0,0
OFFSET 0 mm
SET PEEL OFF
SET CUTTER OFF
SET PARTIAL_CUTTER OFF
SET TEAR ON
CLS
BOX 19,18,393,3650,2
CODEPAGE 1252
TEXT 327,3635,"ROMAN.TTF",180,1,20,"SPICEJET"
TEXT 375,3519,"0",180,13,10,"${recordLocator}"
TEXT 375,3484,"0",180,14,10,"${bt.destAtTop}"
TEXT 375,3452,"ROMAN.TTF",180,1,10,"Seq No.: ${bt.seqAtTop}"
TEXT 375,3412,"ROMAN.TTF",180,1,10,"${bt.flightnumberAtTop}"
BARCODE 339,3359,"128M",141,0,180,2,4,"!104SG !099${bt.osTagUnderBarCode}"
TEXT 291,3212,"ROMAN.TTF",180,1,10,"SG ${bt.osTagUnderBarCode}"
TEXT 378,3561,"0",180,10,8,"${name}"
DIAGONAL 393,2953,21,2953,2
ERASE 33,2859,125,80
TEXT 34,2860,"ROMAN.TTF",0,1,24,"${bt.table[0].taggedToStation}"
REVERSE 33,2859,125,80
DIAGONAL 394,2793,18,2794,2
ERASE 229,2907,150,41
TEXT 230,2908,"ROMAN.TTF",0,1,12," SEQ - ${bt.seqAtTop}"
REVERSE 229,2907,150,41
TEXT 173,2808,"0",0,21,14,"${bt.table[0].flightNumber}"
ERASE 344,2610,47,180
TEXT 345,2789,"0",270,11,14,"SEQ No. : ${bt.seqAtTop}"
REVERSE 344,2610,47,180
TEXT 31,2595,"ROMAN.TTF",0,1,9,"${name}"
TEXT 31,2646,"ROMAN.TTF",0,1,8,"PNR : ${recordLocator}"
TEXT 31,2676,"ROMAN.TTF",0,1,8,"TAG NO. : SG  ${bt.osTagUnderBarCode}"
TEXT 31,2705,"ROMAN.TTF",0,1,8,"BAGGAGE WEIGHT : ${bt.weight} KG"
TEXT 31,2734,"ROMAN.TTF",0,1,8,"TOTAL PIECES : ${item.bags.filter(items => items.IsSelected).length}"
TEXT 31,2759,"ROMAN.TTF",0,1,8,"ORIGIN : ${bt.origin}"
BARCODE 54,2530,"128M",298,0,270,4,8,"!105${bt.osTagUnderBarCode}"
BARCODE 341,2092,"128M",148,0,180,3,6,"!105${bt.osTagUnderBarCode}"
${bagtype}
BARCODE 342,1734,"128M",151,0,180,3,6,"!105${bt.osTagUnderBarCode}"
BAR 20,709, 373, 2
BAR 19,869, 374, 2
TEXT 258,2869,"ROMAN.TTF",0,1,8,"${bt.table[0].depDate}"
BARCODE 340,485,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
BARCODE 53,1498,"128M",298,0,270,4,8,"!105${bt.osTagUnderBarCode}"
DIAGONAL 393,3122,19,3122,2
DIAGONAL 19,538,393,538,2
TEXT 382,1071,"ROMAN.TTF",180,1,9,"${name}"
TEXT 382,1020,"ROMAN.TTF",180,1,8,"PNR : ${recordLocator}"
TEXT 382,990,"ROMAN.TTF",180,1,8,"TAG NO. : SG  ${bt.osTagUnderBarCode}"
TEXT 382,961,"ROMAN.TTF",180,1,8,"BAGGAGE WEIGHT : ${bt.weight} KG"
TEXT 382,931,"ROMAN.TTF",180,1,8,"TOTAL PIECES : ${item.bags.filter(items => items.IsSelected).length}"
TEXT 382,906,"ROMAN.TTF",180,1,8,"ORIGIN : ${bt.origin}"
ERASE 24,877,47,180
TEXT 70,878,"0",90,11,14,"SEQ No. : ${bt.seqAtTop}"
REVERSE 24,877,47,180
ERASE 249,727,125,80
TEXT 373,806,"ROMAN.TTF",180,1,24,"${bt.table[0].taggedToStation}"
REVERSE 249,727,125,80
TEXT 237,858,"0",180,21,14,"${bt.table[0].flightNumber}"
TEXT 158,800,"ROMAN.TTF",180,1,8,"${bt.table[0].depDate}"
ERASE 31,716,150,41
TEXT 180,756,"ROMAN.TTF",180,1,12," SEQ - ${bt.table[0].seqNo}"
REVERSE 31,716,150,41
TEXT 360,522,"ROMAN.TTF",180,1,9,"${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}"
DIAGONAL 392,142,17,143,2
DIAGONAL 395,270,20,271,2
DIAGONAL 393,399,18,400,2
BARCODE 340,355,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
TEXT 361,392,"ROMAN.TTF",180,1,9,"${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}"
BARCODE 346,221,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
TEXT 366,258,"ROMAN.TTF",180,1,9,"${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}"
TEXT 364,132,"ROMAN.TTF",180,1,9,"${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}"
BARCODE 344,95,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
PRINT 1,1
`
}

export const getZPLCommandForConnectingBagTag = (item,bt,j,recordLocator, a) => {
let bagtype = '';
let name = ''
name = `${item.name.last}/${item.name.first}`;
name = name.substring(0, 25);
if (bt.type === 'LRT') {
        bagtype = `^FWI
        ^LRY
        ^FO155,1850
        ^GB240,70,70^FS
        ^FO185,1860^A0,40^CFG
        ^LRT^FS`;
} else {
        bagtype = `^FWI
        ^LRY
        ^FO180,1780
        ^GB180,70,70^FS
        ^FO195,1790^A0,40^CFG
        ^FDBaggage^FS
        
        ^FWI
        ^LRY
        ^FO155,1850
        ^GB240,70,70^FS
        ^FO185,1860^A0,40^CFG
        ^FDRegistered^FS`
}
return `^XA
^FO90,40^GB380,3710,3^FS
^FWN
^FX Top section with Company Name and user detail
//
^FO190,80,999^A0,50^FDSPICEJET^FS
^FO120,150,999^A0,30^FD${name}^FS
^FO120,190,999^A0,30^FD${recordLocator}^FS
^FO120,220,999^A15,25,10^FD${bt.destAtTop}^FS
^FO120,250,999^A15,25,10^FDSeq No.: ${bt.seqAtTop}^FS
^FO120,280,999^A15,25,10^FD${bt.flightnumberAtTop}^FS

^BY5,2,270
^FO150,330^BY2,200,10^BC,150,Y,N,N,A^FD ${bt.osTagUnderBarCode}^FS

^FX Second Section will rotate i flight detail
//
^FO90,550
^GB380,0,3,B^FS
^FWI
^LRY
^FO350,600^A0,50^CFG
^FD${bt.table[0].taggedToStation}^FS

^LRY
^FO120,610
^GB150,50,50^FS
^FO140,615^A0,30^CFG
^FDSEQ - ${bt.table[0].seqNo}^FS
^FO120,665,999^A0,20^FD${bt.table[0].depDate}^FS
^FO120,690,999^A0,30,50^FD${bt.table[0].flightNumber}^FS

//
^FO90,750
^GB380,0,3,B^FS
^FWI
^LRY
^FO300,600
^GB160,70,70^FS
^FO350,800^A0,50^CFG
^FD${bt.table[1].taggedToStation}^FS

^LRY
^FO120,770
^GB150,50,50^FS
^FO140,775^A0,30^CFG
^FDSEQ - ${bt.table[1].seqNo}^FS
^FO120,830,999^A0,20^FD${bt.table[1].depDate}^FS
^FO120,870,999^A0,30,50^FD${bt.table[1].flightNumber}^FS

^FWN
^FX Third Section will rotate i flight detail

//
^FO90,920
^GB380,0,3,B^FS

^FO95,935^GB0,150,70,B^FS
^FWB
^FO120,950^A0,30^CFG
^FDSEQ No.:${bt.seqAtTop}^FS

^FWI

^FO200,1010^A0I,20,20^FB300,3,0,R^FD
${name}
^FS
^FO200,990^A0I,20,20^FB300,3,0,R^FD
PNR: ${recordLocator}
^FS
^FO200,970^A0I,20,20^FB300,3,0,R^FD
Tag No.: SG   ${bt.osTagUnderBarCode}
^FS
^FO200,950^A0I,20,20^FB300,3,0,R^FD
Baggage weight: ${bt.weight} KG
^FS
^FO200,930^A0I,20,20^FB300,3,0,R^FD
Total Pieces: ${item.bags.filter(items => items.IsSelected).length}
^FS
^FO200,910^A0I,20,20^FB300,3,0,R^FD
Origin: ${bt.origin}
^FS

^FS

^FWR
^FO125,1120
^BY2.5,50,10
^BC,320,N,N,N,N
^FD${bt.osTagUnderBarCode}^FS

^FS
^FWN
^FO125,1600
^BY2,10,10
^BC,140,N,N,N,N
^FD${bt.osTagUnderBarCode}
^FS

${bagtype}

^FS
^FWN
^FO125,1950
^BY2,10,10
^BC,140,N,N,N,N
^FD${bt.osTagUnderBarCode}
^FS

^FWR
^FO125,2150
^BY2.5,50,10
^BC,320,N,N,N,N
^FD${bt.osTagUnderBarCode}^FS

^FO395,2630^GB0,150,70,B^FS
^FWB
^FO430,2635^A0,30^CFG
^FDSEQ No.:${bt.seqAtTop}^FS


^FWN
^FO120,2635^A0,20,20^FD${name}^FS
^FO120,2655^A0,20,20^FDPNR: ${recordLocator}^FS
^FO120,2675^A0,20,20^FDTAG No.: SG ${bt.osTagUnderBarCode}^FS
^FO120,2695^A0,20,20^FDBaggage Weight: ${bt.weight}KG^FS
^FO120,2715^A0,20,20^FDTotal Pieces: ${item.bags.filter(items => items.IsSelected).length}^FS
^FO120,2735^A0,20,20^FDOrigin: ${bt.origin}^FS

^FX Fourth Section
//


^FWN
^FO90,1100
^GB380,0,3,B^FS

^LRY
^FO120,2980
^GB 95,70,70^FS
^FO120,3000^A0,50^CFG
^FD${bt.table[1].taggedToStation}^FS

^FO90,2950
^GB380,0,3,B^FS
^LRY
^FO290,3060
^GB150,50,50^FS
^FO310,3070^A0,30^CFG
^FDSEQ - ${bt.table[1].seqNo}^FS
^FO290,3020,999^A0,20^FD${bt.table[1].depDate}^FS
^FO290,2980,999^A0,30,50^FD${bt.table[1].flightNumber}^FS

//

^FWN

^FO90,2780
^GB380,0,3,B^FS

^LRY
^FO120,2850
^FO120,2850^A0,50^CFG
^FD${bt.table[0].taggedToStation}^FS

^LRY
^FO290,2880
^GB150,50,50^FS
^FO310,2890^A0,30^CFG
^FDSEQ - ${bt.table[0].seqNo}^FS
^FO290,2850,999^A0,20^FD${bt.table[0].depDate}^FS
^FO290,2800,999^A0,30,50^FD${bt.table[0].flightNumber}^FS

^FX Fifth Section
//
^FO90,3140
^GB380,0,3,B^FS

^FO150,3160^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS
^FO150,3300^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS
^FO150,3420^BY1.4,70,5^BC,70,Y,N,N,A^FDSG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}^FS

^XZ`
// console.log('cmd foor connecting bt', cmd);
// return cmd;
// return btconnectingzplcommand;
}

export const getTSCPLCommandForConnectingBagTag = (item,bt,j,recordLocator, a) => {
let bagtype = '';
let name = ''
name = `${item.name.last}/${item.name.first}`;
name = name.substring(0, 25);
if (bt.type === 'LRT') {
        bagtype = `BAR 67,1802, 281, 62
        ERASE 163,1809,89,60
        TEXT 164,1810,"ROMAN.TTF",0,1,18,"LRT"
        REVERSE 163,1809,89,60`;
} else {
        bagtype = `BAR 36,1784, 327, 122
        ERASE 51,1790,296,60
        TEXT 52,1791,"ROMAN.TTF",0,1,18,"REGISTERED"
        REVERSE 51,1790,296,60
        ERASE 81,1851,236,60
        TEXT 82,1852,"ROMAN.TTF",0,1,18,"BAGGAGE"
        REVERSE 81,1851,236,60`
}

return `SIZE 51.10 mm, 458.1 mm
GAP 3 mm, 0 mm
SPEED 5
DENSITY 10
DIRECTION 0,0
REFERENCE 0,0
OFFSET 0 mm
SET PEEL OFF
SET CUTTER OFF
SET PARTIAL_CUTTER OFF
SET TEAR ON
CLS
BOX 19,18,393,3650,2
CODEPAGE 1252
TEXT 327,3635,"ROMAN.TTF",180,1,20,"SPICEJET"
TEXT 375,3519,"0",180,13,10,"${recordLocator}"
TEXT 375,3484,"0",180,14,10,"${bt.destAtTop}"
TEXT 375,3452,"ROMAN.TTF",180,1,10,"Seq No.: ${bt.seqAtTop}"
TEXT 375,3412,"ROMAN.TTF",180,1,10,"${bt.flightnumberAtTop}"
BARCODE 339,3359,"128M",141,0,180,2,4,"!104SG !099${bt.osTagUnderBarCode}"
TEXT 291,3212,"ROMAN.TTF",180,1,10,"SG ${bt.osTagUnderBarCode}"
TEXT 378,3561,"0",180,10,8,"${name}"
DIAGONAL 393,2953,21,2953,2
ERASE 33,2859,125,80
TEXT 34,2860,"ROMAN.TTF",0,1,24,"${bt.table[1].taggedToStation}"
REVERSE 33,2859,125,80
DIAGONAL 394,2793,18,2794,2
ERASE 225,2907,150,41
TEXT 226,2908,"ROMAN.TTF",0,1,12," SEQ - ${bt.table[1].seqNo}"
REVERSE 225,2907,150,41
TEXT 179,2808,"0",0,21,14,"${bt.table[1].flightNumber}"
ERASE 342,2610,47,180
TEXT 343,2789,"0",270,11,14,"SEQ No. : ${bt.seqAtTop}"
REVERSE 342,2610,47,180
TEXT 31,2595,"ROMAN.TTF",0,1,9,"${name}"
TEXT 31,2646,"ROMAN.TTF",0,1,8,"PNR : ${recordLocator}"
TEXT 31,2676,"ROMAN.TTF",0,1,8,"TAG NO. : SG  ${bt.osTagUnderBarCode}"
TEXT 31,2705,"ROMAN.TTF",0,1,8,"BAGGAGE WEIGHT : ${bt.weight} KG"
TEXT 31,2734,"ROMAN.TTF",0,1,8,"TOTAL PIECES : ${item.bags.filter(items => items.IsSelected).length}"
TEXT 31,2759,"ROMAN.TTF",0,1,8,"ORIGIN : ${bt.origin}"
BARCODE 54,2530,"128M",298,0,270,4,8,"!105${bt.osTagUnderBarCode}"
BARCODE 341,2092,"128M",148,0,180,3,6,"!105${bt.osTagUnderBarCode}"
${bagtype}
BARCODE 342,1734,"128M",151,0,180,3,6,"!105${bt.osTagUnderBarCode}"
BAR 20,709, 373, 2
BAR 19,869, 374, 2
TEXT 255,2863,"ROMAN.TTF",0,1,8,"${bt.table[1].depDate}"
BARCODE 340,485,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
BARCODE 53,1498,"128M",298,0,270,4,8,"!105${bt.osTagUnderBarCode}"
TEXT 28,2968,"ROMAN.TTF",0,1,24,"${bt.table[0].taggedToStation}"
ERASE 225,2978,150,41
TEXT 226,2979,"ROMAN.TTF",0,1,12," SEQ - ${bt.table[0].seqNo}"
REVERSE 225,2978,150,41
TEXT 254,3057,"ROMAN.TTF",0,1,8,"${bt.table[0].depDate}"
TEXT 28,3052,"0",0,21,14,"${bt.table[0].flightNumber}"
DIAGONAL 393,3122,19,3122,2
DIAGONAL 19,538,393,538,2
TEXT 382,1071,"ROMAN.TTF",180,1,9,"${name}"
TEXT 382,1020,"ROMAN.TTF",180,1,8,"PNR : ${recordLocator}"
TEXT 382,990,"ROMAN.TTF",180,1,8,"TAG NO. : SG  ${bt.osTagUnderBarCode}"
TEXT 382,961,"ROMAN.TTF",180,1,8,"BAGGAGE WEIGHT : ${bt.weight} KG"
TEXT 382,931,"ROMAN.TTF",180,1,8,"TOTAL PIECES : ${item.bags.filter(items => items.IsSelected).length}"
TEXT 382,906,"ROMAN.TTF",180,1,8,"ORIGIN : ${bt.origin}"
ERASE 24,877,47,180
TEXT 70,878,"0",90,11,14,"SEQ No. : ${bt.seqAtTop}"
REVERSE 24,877,47,180
ERASE 249,727,125,80
TEXT 373,806,"ROMAN.TTF",180,1,24,"${bt.table[1].taggedToStation}"
REVERSE 249,727,125,80
TEXT 235,858,"0",180,21,14,"${bt.table[1].flightNumber}"
TEXT 156,800,"ROMAN.TTF",180,1,8,"${bt.table[1].depDate}"
ERASE 35,716,150,41
TEXT 184,756,"ROMAN.TTF",180,1,12," SEQ - ${bt.table[1].seqNo}"
REVERSE 35,716,150,41
TEXT 373,685,"ROMAN.TTF",180,1,24,"${bt.table[0].taggedToStation}"
ERASE 35,634,150,41
TEXT 184,674,"ROMAN.TTF",180,1,12," SEQ - ${bt.table[0].seqNo}"
REVERSE 35,634,150,41
TEXT 157,598,"ROMAN.TTF",180,1,8,"${bt.table[0].depDate}"
TEXT 385,600,"0",180,21,14,"${bt.table[0].flightNumber}"
TEXT 360,522,"ROMAN.TTF",180,1,9,"SG${bt.osTagUnderBarCode} ${a} Seq-${bt.seqAtTop}"
DIAGONAL 392,142,17,143,2
DIAGONAL 395,270,20,271,2
DIAGONAL 393,399,18,400,2
BARCODE 340,355,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
TEXT 361,392,"ROMAN.TTF",180,1,9,"SG${bt.osTagUnderBarCode} ${a} Seq-${bt.seqAtTop}"
BARCODE 346,221,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
TEXT 366,258,"ROMAN.TTF",180,1,9,"SG${bt.osTagUnderBarCode} ${a} Seq-${bt.seqAtTop}"
BARCODE 344,95,"128M",58,0,180,3,6,"!105${bt.osTagUnderBarCode}"
TEXT 364,132,"ROMAN.TTF",180,1,9,"SG${bt.osTagUnderBarCode} ${a} Seq-${bt.seqAtTop}"
PRINT 1,1
`
}

export const getCheckedBaggageKeys = (SearchedFlightDetails) => {
    const checkedBaggageKeys = [];
    SearchedFlightDetails.journeys.forEach(journey => {
      journey.segments.forEach(seg => {
        if (seg.IsSelected) {
          seg.passengerSegment.forEach(pseg => {
            pseg.bags.forEach(bag => {
              if (bag.status === 'Checked') {
                // return bg;
                checkedBaggageKeys.push(bag.baggageKey);
              }
            })
          })
        }
      })
    });
    return checkedBaggageKeys;
};

export const generateReferenceStringForBoardingPass = (boardingPassData) => {
        const response = boardingPassData;
        console.log('generateReferenceStringForBoardingPass', boardingPassData);
        // Get boarding passes that have at least one selected segment
        const selectedBoardingPasses = boardingPassData.flatMap(item => 
                item.boardingPasses.filter(bp => 
                bp.segments.some(segment => segment.IsSelected === true)
                )
        );
      
        console.log(selectedBoardingPasses);
        const boardingPasses = selectedBoardingPasses;
        
        let referenceStrings = [];
        
        boardingPasses.forEach((pass, index) => {
            const passenger = pass.passenger;
            const segment = pass.segments.filter(seg => seg.IsSelected)[0];
            const leg = segment.legs[0];
            const designator = segment.designator;
            const identifier = segment.identifier;
            
            // Extract data for reference string
            let passengerName = `${passenger.name.last.toUpperCase()}/${passenger.name.first.toUpperCase()}`;
            passengerName = passengerName.slice(0, 20);
            const recordLocator = response[0].recordLocator;
            const origin = designator.origin;
            const originName = designator.originStationName;
            const destination = designator.destination;
            const destinationName = designator.destinationStationName;
            const flightNumber = identifier.identifier.length === 4 ? `${identifier.carrierCode}${identifier.identifier}` : `${identifier.carrierCode} ${identifier.identifier}`;
            const seatDesignator = leg.seat.designator;
            const seqNo = leg.boarding.boardingSequence;
            const barCode = passenger.barCode;
            
            // Format departure date (assuming format needed is like "26Jun25")
            const departureDate = new Date(designator.departure);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const formattedDate = departureDate.getDate().toString().padStart(2, '0') + 
                                 months[departureDate.getMonth()] + 
                                 departureDate.getFullYear().toString().slice(-2);
            
            // Format times
            const departureTime = new Date(designator.departure);
            const arrivalTime = new Date(designator.arrival);
            const boardingTime = new Date(segment.boardingTime);
            
            const formatTime = (date) => {
                return date.toLocaleTimeString('en-US', { 
                    hour: '2-digit', 
                    minute: '2-digit',
                    hour12: true 
                }).replace(/\s/g, ''); // removes spaces
            };
            
            // Extract SSR codes
        //     const ssrCodes = leg.ssrs ? leg.ssrs.map(ssr => ssr.ssrCode).join(', ') : '';
        let ssrCodes = leg.ssrs;
        if (segment.hasInfant) {
                ssrCodes.push({ssrCode:'INFT'})
        }
        ssrCodes = ssrCodes.length ?
        ssrCodes.slice(0, 6).reduce((acc, ssr, index) => {
                const groupIndex = Math.floor(index / 3);
                if (!acc[groupIndex]) {
                        acc[groupIndex] = [];
                }
                acc[groupIndex].push(ssr.ssrCode);
                return acc;
                }, []).map(group => group.join(', '))
                : [];
            // Build reference string
            const refString = [
                'CP',                                    // #A#
                'A',                                     // #01S#
                '01S',                                   // #CP#
                'CP',                                    // #C01#
                'C01',                                   // #02@@01#
                '02@@01',                               // #19
                `19${passengerName}`,                   // #20
                `20${passengerName}`,                   // #215#
                `21${seqNo}`,                                 // seq no  // #30
                `30${originName}`,          // #32
                `32${flightNumber}`,                    // #33
                `33${formattedDate}`,                   // #40
                `40${destinationName}`,     // #41
                `41${recordLocator}`,                   // #43#
                '43',                                    // #44
                `44${seatDesignator}`,                  // #46
                `46${seatDesignator}`,                  // #47
                `47${formatTime(departureTime)}`,       // #48
                `48${formatTime(arrivalTime)}`,         // #49
                `49${formatTime(boardingTime)}`,        // #50
                `50${barCode}`,                         // #51
                `51(${origin})`,                        // #52
                `52(${destination})`,                   // #53
                `53${flightNumber}`,                    // #54
                `54${origin}/${destination}`,           // #80
                `80${ssrCodes.length === 1 ? ssrCodes[0]: ''}`,
                `81${ssrCodes.length > 1 ? ssrCodes[1]: ''}`,                     // SSR codes added here
                ''
            ].join('#');
        //     CP#A#01S#CP#C01#02@@01#03TUTEJA/ISHA#04Delhi#05Ahmedabad#06HHHLMB#07SG8193#08#092#1014B#112150 Hrs#1210 Dec 2025#132220 Hrs#14#150001#16#17#20TUTEJA/ISHA#21DEL#22AMD#23#24#25#50M1TUTEJA/ISHA          HHHLMB DELAMDSG 8193 344Y014B0001 147>1183OO5344BSG 0000000000000297750000000000 0                          #51M1TUTEJA/ISHA          HHHLMB DELAMDSG 8193 344Y014B0001 147>1183OO5344BSG 0000000000000297750000000000 0                          #
            referenceStrings.push(refString);
        });
        console.log('referenceStrings', referenceStrings)
        
        return encodeEachToBase64(referenceStrings);
}

const encodeEachToBase64 = (dataArray) => {
        return dataArray.map(str => 
          btoa(unescape(encodeURIComponent(str)))
        );
}

const formatDate = (dateString) => {
        // Handles formats: "20251111", "2025-11-11T00:00:00Z", or Date object
        let date;
        if (typeof dateString === 'string') {
          if (dateString.length === 8) {
            // Format: "20251111"
            const year = dateString.substring(0, 4);
            const month = dateString.substring(4, 6);
            const day = dateString.substring(6, 8);
            date = new Date(year, parseInt(month) - 1, day);
          } else {
            date = new Date(dateString);
          }
        } else {
          date = new Date(dateString);
        }
        
        const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 
                            'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        const day = String(date.getDate()).padStart(2, '0');
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day} ${month}, ${year}`;
}
    
const getCityName = (airportCode) => {
        return cityNames[airportCode] || airportCode;
}

const getAirlineName = (airlineCode) => {
        return airlineNames[airlineCode] || airlineCode;
}

const parseFlightDetails = (input) => {
        // Remove extra spaces and normalize
        const normalized = input.trim().replace(/\s+/g, ' ');
        
        // Pattern to match:
        // - Date: 8 digits at start (YYYYMMDD)
        // - Airline code: 2-3 letter code
        // - Flight number: digits (possibly with separator)
        // - Route: remaining uppercase text
        const pattern = /^(\d{8})\s+([A-Z]{2,3})[\s\-]?(\d+)\s+([A-Z]+)$/;
        
        const match = normalized.match(pattern);
        
        if (!match) {
          return {
            date: null,
            airlineCode: null,
            flightNumber: null,
            route: null,
            raw: input,
            error: 'Invalid format'
          };
        }
        
        const [, date, airlineCode, flightNumber, route] = match;
        
        // Format date as YYYY-MM-DD for better readability
        const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
        
        return {
          date: formattedDate,
          dateRaw: date,
          airlineCode,
          flightNumber,
          route,
          raw: input
        };
}

const generateDirectTag = (passengerDataInput, SearchedFlightDetails) => {
        const selectedJourney = SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length);
        let BagsTagToPrint = passengerDataInput.filter(pax => pax.IsSelected);
        let a = '';
        // console.log('BagsTagToPrint in  bagtag component', BagsTagToPrint);
        BagsTagToPrint.forEach((passenger) => {
        passenger.bags.filter(bag => bag.IsSelected).forEach((paxBag) => {
                
                let segIndexToShow =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier === paxBag.identifier));
                let segIndexToShowSeq =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier !== paxBag.identifier));
                let flightName = selectedJourney[0][segIndexToShow];
                paxBag.origin = selectedJourney[0][0].designator.origin;
                paxBag.flightnumberAtTop = `${flightName.identifier.carrierCode} ${flightName.identifier.identifier}`;
                paxBag.destAtTop = flightName.designator.destination;
                // if (lrtBagType && lrtBagType[passenger.passengerKey] && lrtBagType[passenger.passengerKey].find(b => b.bagWeight === paxBag.weight)) {

                // paxBag.isLrt = true;
                // } else {
                // paxBag.isLrt = false;
                // }
                paxBag.seqAtTop = selectedJourney[0][segIndexToShowSeq].passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence;
                let psegForOsTagUnderBarCode = flightName.passengerSegment.filter(pseg => pseg.IsSelected && pseg.passengerKey === passenger.passengerKey)[0];
                let psegBagForOsTagUnderBarCode = psegForOsTagUnderBarCode.bags.filter(psegBag => psegBag.baggageKey === paxBag.baggageKey)[0].osTag;
                paxBag.osTagUnderBarCode = psegBagForOsTagUnderBarCode;
                paxBag.table = [];
                if (segIndexToShow === 0) {
                const segmentForTable = selectedJourney[0][segIndexToShow];
                const bagTagDetailObject = {
                        taggedToStation: segmentForTable.designator.destination,
                        flightNumber: `${segmentForTable.identifier.carrierCode} ${segmentForTable.identifier.identifier}`,
                        depDate: moment(segmentForTable.designator.departure).format("D MMM, YYYY"),
                        seqNo: segmentForTable.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                }
                paxBag.table.push(bagTagDetailObject);
                } else {
                const segmentsForTable = selectedJourney[0];
                segmentsForTable.forEach((seg) => {
                        const bagTagDetailObject = {
                        taggedToStation: seg.designator.destination,
                        flightNumber: `${seg.identifier.carrierCode} ${seg.identifier.identifier}`,
                        depDate: moment(seg.designator.departure).format("D MMM, YYYY"),
                        seqNo: seg.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                        }
                        paxBag.table.push(bagTagDetailObject);
                })
                }
                paxBag.table.forEach((trow, index, array) => {
                a = array.length > 1 && index === 0 ? '' : trow.taggedToStation
                })
        })
        });
        console.log('BagsTagToPrint in  bagtag component', BagsTagToPrint);
        // Handle both single passenger and array of passengers
        // const passengers = Array.isArray(passengerDataInput) 
        //   ? passengerDataInput 
        //   : [passengerDataInput];
          const passengers = Array.isArray(BagsTagToPrint) 
          ? BagsTagToPrint 
          : [BagsTagToPrint];
          
        
        const allBagTags = [];
        // passengers.forEach((passenger, passengerIndex) => {
        //         const fee = passenger.fees.filter(f => f.flightReference !== null)[0];
                
        //         // Extract flight details from flightReference
        //         const flightRef = fee.flightReference;
        //         const { date, airlineCode, flightNumber, route } = parseFlightDetails(flightRef);
                
        //         const origin = route.substring(0, 3);
        //         const destination = route.substring(3, 6);
        //         const formattedDate = formatDate(date);
        //         const passengerName = `${passenger.name.last.toUpperCase()}/${passenger.name.first.toUpperCase()}`;
        //         const airlineName = getAirlineName(airlineCode);
        //         const destinationCity = getCityName(destination);
        //         // pnr ey51xj connecting
        //         'BTP010101#03SG#040775790164#15SEQ. NO.: 1#16SEQ - 1#25SG 385 #26BOM#2719 NOV, 2025#28SEQ - 1#35SG 669 #36BLR#38BENGALURU#42DEL#43EY51XJ#44SINGH/ANKIT#4619 NOV, 2025#48SPICEJET#49SEQ - 7#591#62REGISTERED#64BAGGAGE#65BLR#'

        //         // our code generated
        //         "BTP010101#03SG#040775790164#15SEQ. NO.: 1#16SEQ - 1#35SG 385#36BLR#38Bengaluru#42DEL#43EY51XJ#44SINGH/ANKIT#4619 NOV, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65BLR#"
                
        //         "BTP010101#03SG#040775793812#15SEQ. NO.: 1#16SEQ - 1#35SG 8169#36JAI#38Jaipur#42DEL#43V3LMVR#44BANSAL/ANKIT#4608 JAN, 2026#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65JAI#"
        //         passenger.bags.filter(bag => bag.IsSelected).forEach((bag, bagIndex) => {
        //         //   const sequenceNo = bagIndex + 1;
        //           const bagTag = `BTP010101` +
        //             `#03${bag.taggedToCarrierCode}` +
        //             `#04${bag.osTag}` +
        //             `#15SEQ. NO.: ${bag.table[0].seqNo}` +
        //             `#16SEQ - ${bag.table[0].seqNo}` +
        //             `#35${bag.table[0].flightNumber}` +
        //             `#36${bag.table[0].taggedToStation}` +
        //             `#38${getCityName(bag.taggedToStation)}` +
        //             `#42${bag.stationCode}` +
        //             `#43${SearchedFlightDetails.recordLocator}` +
        //             `#44${passengerName}` +
        //             `#46${formattedDate}` +
        //             `#48${airlineName}` +
        //             `#49SEQ - ${sequenceNo}` +
        //             `#59${passenger.bags.filter(bag => bag.IsSelected).length}` +
        //             `#62REGISTERED` +
        //             `#64BAGGAGE` +
        //             `#65${bag.taggedToStation}#`;
                  
        //           allBagTags.push(bagTag);
        //         });
        //       })
        // Loop through each passenger
        passengers.forEach((passenger, passengerIndex) => {
          const fee = passenger.fees.filter(f => f.flightReference !== null)[0];
          
          // Extract flight details from flightReference
        //   const flightRef = fee.flightReference;
        //   const { date, airlineCode, flightNumber, route } = parseFlightDetails(flightRef);
          
        //   const origin = route.substring(0, 3);
        //   const destination = route.substring(3, 6);
        //   const formattedDate = formatDate(date);
          const passengerName = `${passenger.name.last.toUpperCase()}/${passenger.name.first.toUpperCase()}`;
        //   const airlineName = getAirlineName(taggedToCarrierCode);
        //   const destinationCity = getCityName(destination);
          // pnr ey51xj
          'BTP010101#03SG#040775790164#15SEQ. NO.: 1#16SEQ - 1#25SG 385 #26BOM#2719 NOV, 2025#28SEQ - 1#35SG 669 #36BLR#38BENGALURU#42DEL#43EY51XJ#44SINGH/ANKIT#4619 NOV, 2025#48SPICEJET#49SEQ - 7#591#62REGISTERED#64BAGGAGE#65BLR#'
          "BTP010101#03SG#040775790164#15SEQ. NO.: 1#16SEQ - 1#35SG 385#36BLR#38Bengaluru#42DEL#43EY51XJ#44SINGH/ANKIT#4619 NOV, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65BLR#"
          
          "BTP010101#03SG#040775793812#15SEQ. NO.: 1#16SEQ - 1#35SG 8169#36JAI#38Jaipur#42DEL#43V3LMVR#44BANSAL/ANKIT#4608 JAN, 2026#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65JAI#"
          passenger.bags.filter(bag => bag.IsSelected).forEach((bag, bagIndex) => {
            const sequenceNo = bagIndex + 1;
            const bagTag = `BTP010101` +
              `#03${bag.taggedToCarrierCode}` +
              `#04${bag.osTag}` +
              `#15SEQ. NO.: ${sequenceNo}` +
              `#16SEQ - ${sequenceNo}` +
              `#35${bag.taggedToCarrierCode} ${bag.identifier}` +
              `#36${bag.taggedToStation}` +
              `#38${getCityName(bag.taggedToStation)}` +
              `#42${bag.stationCode}` +
              `#43${SearchedFlightDetails.recordLocator}` +
              `#44${passengerName}` +
              `#46${formatDate(bag.osTagDate)}` +
              `#48${getAirlineName(bag.taggedToCarrierCode)}` +
              `#49SEQ - ${sequenceNo}` +
              `#59${passenger.bags.filter(bag => bag.IsSelected).length}` +
              `#62REGISTERED` +
              `#64BAGGAGE` +
              `#65${bag.taggedToStation}#`;
            
            allBagTags.push(bagTag);
          });
        });
        console.log('allBagTags direct',allBagTags);
        return allBagTags;
}
    
const generateViaTag = (passengerDataInput, SearchedFlightDetails) => {
        // Handle both single passenger and array of passengers
        const passengers = Array.isArray(passengerDataInput) 
          ? passengerDataInput 
          : [passengerDataInput];
        
        const allBagTags = [];
        
        // Loop through each passenger
        passengers.forEach((passenger, passengerIndex) => {
          const journey = passenger.journey;
          
          const airlineCode = journey.airlineCode;
          const flightNumber = journey.flightNumber;
          const origin = journey.origin;
          const destination = journey.finalDestination;
          const formattedDate = formatDate(journey.travelDate);
          const passengerName = `${passenger.name.last.toUpperCase()}/${passenger.name.first.toUpperCase()}`;
          const airlineName = getAirlineName(airlineCode);
          const destinationCity = getCityName(destination);
          
          // Generate tag for each bag
          passenger.bags.filter(bag => bag.IsSelected).forEach((bag, bagIndex) => {
            const sequenceNo = bagIndex + 1;
            const bagTag = `BTP010101` +
              `#03${airlineCode}` +
              `#04${bag.osTag}` +
              `#15SEQ. NO.: ${sequenceNo}` +
              `#16SEQ - ${sequenceNo}` +
              `#35${airlineCode}${flightNumber}` + // Note: No space for Via tags
              `#36${destination}` +
              `#38${destinationCity}` +
              `#42${origin}` +
              `#43${SearchedFlightDetails.recordLocator}` +
              `#44${passengerName}` +
              `#46${formattedDate}` +
              `#48${airlineName}` +
              `#49SEQ - ${sequenceNo}` +
              `#59${passenger.bags.filter(bag => bag.IsSelected).length}` +
              `#62REGISTERED` +
              `#64BAGGAGE` +
              `#65${destination}#`;
            
            allBagTags.push(bagTag);
          });
        });
        
        return allBagTags;
}
    
const generateConnectingTag = (passengerDataInput, SearchedFlightDetails) => {
        // Handle both single passenger and array of passengers
        console.log('generateConnectingTag passengerDataInput', passengerDataInput );
        console.log('SearchedFlightDetails', SearchedFlightDetails);
        const passengers = Array.isArray(passengerDataInput) 
          ? passengerDataInput 
          : [passengerDataInput];
        
        const allBagTags = [];
        
        // Loop through each passenger
        passengers.forEach((passenger, passengerIndex) => {
          const journey = passenger.journey;
          
          const airlineCode = journey.airlineCode;
          const currentSegment = journey.currentSegment; // The segment being processed
          const baseSequenceNo = journey.sequenceNumber;
          
          const origin = journey.origin;
          const intermediateStop = journey.intermediateStop; // Where bag is being processed
          const finalDestination = journey.finalDestination;
          const formattedDate = formatDate(journey.travelDate);
          const passengerName = `${passenger.name.last.toUpperCase()}/${passenger.name.first.toUpperCase()}`;
          const airlineName = getAirlineName(airlineCode);
          const intermediateCity = getCityName(intermediateStop);
          'BTP010101#03SG#040775790133#15SEQ. NO.: 1#16SEQ - 1#25SG 105 #26BOM#2714 NOV, 2025#28SEQ - 1#35SG 648 #36MAA#38CHENNAI#42DEL#43TBI8UW#44TESTLNASDPYNCARHB/MC#4615 NOV, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65MAA#'
          // Generate tag for each bag
          'BTP010101#03SG#040775790133#15SEQ. NO.: 1#16SEQ - 1#35SG 105#36BOM#38Mumbai#42DEL#43TBI8UW#44TESTLNASDPYNCARHB/MCFBRFQ#4614 NOV, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65BOM#'
          // Generate tag for each bag

          'BTP010101#03SG#040775792955#15SEQ. NO.: 15#16SEQ - 15#25SG 105 #26BOM#2715 DEC, 2025#28SEQ - 15#35SG 648 #36MAA#38CHENNAI#42DEL#43KG1U5E#44TEST/TEST#4616 DEC, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65MAA#'
          
          // pnr ey51xj
          'BTP010101#03SG#040775790164#15SEQ. NO.: 1#16SEQ - 1#25SG 385 #26BOM#2719 NOV, 2025#28SEQ - 1#35SG 669 #36BLR#38BENGALURU#42DEL#43EY51XJ#44SINGH/ANKIT#4619 NOV, 2025#48SPICEJET#49SEQ - 7#591#62REGISTERED#64BAGGAGE#65BLR#'
          
          // pnr TBI8UW
          'BTP010101#03SG#040775790133#15SEQ. NO.: 1#16SEQ - 1#25SG 105 #26BOM#2714 NOV, 2025#28SEQ - 1#35SG 648 #36MAA#38CHENNAI#42DEL#43TBI8UW#44TESTLNASDPYNCARHB/MC#4615 NOV, 2025#48SPICEJET#49SEQ - 1#591#62REGISTERED#64BAGGAGE#65MAA#'

          passenger.bags.filter(bag => bag.IsSelected).forEach((bag, bagIndex) => {
            const sequenceNo = baseSequenceNo + bagIndex;
            const bagTag = `BTP010101` +
              `#03${airlineCode}` +
              `#04${bag.osTag}` +
              `#15SEQ. NO.: ${sequenceNo}` +
              `#16SEQ - ${sequenceNo}` +
              `#25${journey.internalFlightRef}` + // Internal flight reference
              `#26${origin}` +
              `#27${formattedDate}` +
              `#28SEQ - ${sequenceNo}` +
              `#35${airlineCode} ${currentSegment.flightNumber}` +
              `#36${intermediateStop}` +
              `#38${intermediateCity}` +
              `#42${finalDestination}` +
              `#43${SearchedFlightDetails.recordLocator}` +
              `#44${passengerName}` +
              `#46${formattedDate}` +
              `#48${airlineName}` +
              `#49SEQ - 1` +
              `#59${passenger.bags.filter(bag => bag.IsSelected).length}` +
              `#62REGISTERED` +
              `#64BAGGAGE` +
              `#65${intermediateStop}#`;
            
            allBagTags.push(bagTag);
          });
        });
        
        return allBagTags;
}

const detectFlightType = (journey) => {
        if (!journey || !journey.segments || journey.segments.length === 0) {
          return 'Unknown';
        }
      
        // If journey has multiple segments, it's connecting
        if (journey.segments.length > 1) {
          return 'CONNECTING';
        }
      
        // If journey has single segment, check legs
        const segment = journey.segments[0];
        
        if (!segment.legs || segment.legs.length === 0) {
          return 'Unknown';
        }
      
        // If segment has multiple legs, it's via
        if (segment.legs.length > 1) {
          return 'VIA';
        }
      
        // Single segment with single leg is direct
        return 'DIRECT';
};
      
//       // Usage example:
//       const journeyType = getJourneyType(journey);
//       console.log(journeyType); // Output: "Connecting" (since your data has 2 segments)

export const generateReferenceStringForBagTag = (passengerData, SearchedFlightDetails) => {
        const flightType = detectFlightType(SearchedFlightDetails.journeys[0]);

        console.log(`\nGenerating ${flightType} Baggage Tag...\n`);

        switch(flightType) {
                case 'DIRECT':
                return encodeEachToBase64(generateDirectTag(passengerData, SearchedFlightDetails));
                case 'VIA':
                return encodeEachToBase64(generateDirectTag(passengerData, SearchedFlightDetails));
                // return encodeEachToBase64(generateViaTag(passengerData, SearchedFlightDetails));
                case 'CONNECTING':
                return encodeEachToBase64(generateDirectTag(passengerData, SearchedFlightDetails));
                // return encodeEachToBase64(generateConnectingTag(passengerData, SearchedFlightDetails));
                default:
                return encodeEachToBase64(generateDirectTag(passengerData, SearchedFlightDetails));
        }
}
